import { CallSignalingService } from 'src/app/services/calls/call-signaling.service';
import { Component, OnInit, Input, OnDestroy, ViewChild, AfterViewInit, Optional, NgZone, HostBinding } from '@angular/core';


import {RequestService} from "src/app/services/request/request.service";
import { ElementRef } from '@angular/core';

import { Share } from '@capacitor/share';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import {
  ApplicationMetadata,
  AsyncScheduler,
  Attendee,
  AudioInputDevice,
  AudioProfile,
  AudioVideoFacade,
  AudioVideoObserver,
  BackgroundBlurProcessor,
  BackgroundBlurVideoFrameProcessor,
  BackgroundBlurVideoFrameProcessorObserver,
  BackgroundReplacementProcessor,
  BackgroundReplacementVideoFrameProcessor,
  BackgroundReplacementVideoFrameProcessorObserver,
  BackgroundReplacementOptions,
  ClientMetricReport,
  ConsoleLogger,
  ContentShareObserver,
  DataMessage,
  DefaultActiveSpeakerPolicy,
  DefaultAudioVideoController,
  DefaultBrowserBehavior,
  DefaultDeviceController,
  DefaultMeetingEventReporter,
  DefaultMeetingSession,
  DefaultModality,
  DefaultVideoTransformDevice,
  Device,
  DeviceChangeObserver,
  EventAttributes,
  EventIngestionConfiguration,
  EventName,
  EventReporter,
  LogLevel,
  Logger,
  MeetingEventsClientConfiguration,
  MeetingSession,
  MeetingSessionConfiguration,
  MeetingSessionStatus,
  MeetingSessionStatusCode,
  VideoFxProcessor,
  MeetingSessionVideoAvailability,
  MultiLogger,
  NoOpEventReporter,
  NoOpVideoFrameProcessor,
  VideoFxConfig,
  RemovableAnalyserNode,
  ServerSideNetworkAdaption,
  SimulcastLayers,
  Transcript,
  TranscriptEvent,
  TranscriptionStatus,
  TranscriptionStatusType,
  TranscriptItemType,
  TranscriptResult,
  Versioning,
  VideoDownlinkObserver,
  VideoFrameProcessor,
  VideoInputDevice,
  VideoPriorityBasedPolicy,
  VideoPriorityBasedPolicyConfig,
  VoiceFocusDeviceTransformer,
  VoiceFocusModelComplexity,
  VoiceFocusModelName,
  VoiceFocusPaths,
  VoiceFocusSpec,
  VoiceFocusTransformDevice,
  isAudioTransformDevice,
  isDestroyable,
  BackgroundFilterSpec,
  BackgroundFilterPaths,
  ModelSpecBuilder,
  DefaultEventController,
  MeetingSessionCredentials,
  POSTLogger,
  VideoCodecCapability,
} from 'amazon-chime-sdk-js';

import { NativeCalls } from 'src/app/plugins/native-runtime.plugins';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';
import TestSound from './audio/TestSound';
import MeetingToast from './util/MeetingToast'; MeetingToast; // Make sure this file is included in webpack
import VideoTileCollection from './video/VideoTileCollection';
import VideoPreferenceManager from './video/VideoPreferenceManager';
import CircularCut from './video/filters/CircularCut';
import EmojifyVideoFrameProcessor from './video/filters/EmojifyVideoFrameProcessor';
import SegmentationProcessor from './video/filters/SegmentationProcessor';
import ResizeProcessor from './video/filters/ResizeProcessor';
import {
  loadBodyPixDependency,
  platformCanSupportBodyPixWithoutDegradation,
} from './video/filters/SegmentationUtil';
import SyntheticVideoDeviceFactory from './video/SyntheticVideoDeviceFactory';
import { getPOSTLogger } from './util/MeetingLogger';
import Roster from './component/Roster';
import ContentShareManager from './component/ContentShareManager';
import { AudioBufferMediaStreamProvider, SynthesizedStereoMediaStreamProvider } from './util/mediastreamprovider/DemoMediaStreamProviders';
//import { RequestService } from 'src/app/services/request/request.service';
import { BackgroundImageEncoding } from './util/BackgroundImage';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ModalController, NavController } from '@ionic/angular';
import { now } from 'moment';
import Swal2 from 'sweetalert2';
import { FormServiceService } from 'src/app/services/publications/form-service.service';
import { Router } from '@angular/router';
import { Message } from 'src/app/Models/Classes/Chat/message';
import * as models from "src/app/Models/Classes/graphql/models/models-graphql";
import { ChatService } from 'src/app/services/chat/chat.service';
import { Howl } from 'howler';
declare var MediaRecorder: any;


let SHOULD_EARLY_CONNECT = (() => {
  return document.location.search.includes('earlyConnect=1');
})();

let SHOULD_DIE_ON_FATALS = (() => {
  const isLocal = document.location.host === '127.0.0.1:8080' || document.location.host === 'localhost:8080';
  const fatalYes = document.location.search.includes('fatal=1');
  const fatalNo = document.location.search.includes('fatal=0');
  return fatalYes || (isLocal && !fatalNo);
})();


export let fatal: (e: Error) => void;

// This shim is needed to avoid warnings when supporting Safari.
declare global {
  interface Window {
    webkitAudioContext: typeof AudioContext
  }
}

// Support a set of query parameters to allow for testing pre-release versions of
// Amazon Voice Focus. If none of these parameters are supplied, the SDK default
// values will be used.
const search = new URLSearchParams(document.location.search);
const VOICE_FOCUS_NAME = search.get('voiceFocusName') || undefined;
const VOICE_FOCUS_CDN = search.get('voiceFocusCDN') || undefined;
const VOICE_FOCUS_ASSET_GROUP = search.get('voiceFocusAssetGroup') || undefined;
const VOICE_FOCUS_REVISION_ID = search.get('voiceFocusRevisionID') || undefined;

const VOICE_FOCUS_PATHS: VoiceFocusPaths | undefined = VOICE_FOCUS_CDN && {
  processors: `${VOICE_FOCUS_CDN}processors/`,
  wasm: `${VOICE_FOCUS_CDN}wasm/`,
  workers: `${VOICE_FOCUS_CDN}workers/`,
  models: `${VOICE_FOCUS_CDN}wasm/`,
};

function voiceFocusName(name: string | undefined = VOICE_FOCUS_NAME): VoiceFocusModelName | undefined {
  if (name && ['default', 'ns_es'].includes(name)) {
    return name as VoiceFocusModelName;
  }
  return undefined;
}

const VOICE_FOCUS_SPEC = {
  name: voiceFocusName(),
  assetGroup: VOICE_FOCUS_ASSET_GROUP,
  revisionID: VOICE_FOCUS_REVISION_ID,
  paths: VOICE_FOCUS_PATHS,
};

function getVoiceFocusSpec(joinInfo: any): VoiceFocusSpec {
  const es = joinInfo.Meeting.Meeting?.MeetingFeatures?.Audio?.EchoReduction === 'AVAILABLE';
  let spec: VoiceFocusSpec = VOICE_FOCUS_SPEC;
  if (!spec.name) {
    spec.name = es ? voiceFocusName('ns_es') : voiceFocusName('default');
  }
  return spec;
};

const MAX_VOICE_FOCUS_COMPLEXITY: VoiceFocusModelComplexity | undefined = undefined;

const BACKGROUND_BLUR_CDN = search.get('blurCDN') || undefined;
const BACKGROUND_BLUR_ASSET_GROUP = search.get('blurAssetGroup') || undefined;
const BACKGROUND_BLUR_REVISION_ID = search.get('blurRevisionID') || undefined;

const BACKGROUND_BLUR_PATHS: BackgroundFilterPaths = BACKGROUND_BLUR_CDN && {
  worker: `${BACKGROUND_BLUR_CDN}/bgblur/workers/worker.js`,
  wasm: `${BACKGROUND_BLUR_CDN}/bgblur/wasm/_cwt-wasm.wasm`,
  simd: `${BACKGROUND_BLUR_CDN}/bgblur/wasm/_cwt-wasm-simd.wasm`,
};
const BACKGROUND_BLUR_MODEL = BACKGROUND_BLUR_CDN && ModelSpecBuilder.builder()
    .withSelfieSegmentationDefaults()
    .withPath(`${BACKGROUND_BLUR_CDN}/bgblur/models/selfie_segmentation_landscape.tflite`)
    .build();
const BACKGROUND_BLUR_ASSET_SPEC = (BACKGROUND_BLUR_ASSET_GROUP || BACKGROUND_BLUR_REVISION_ID) && {
  assetGroup: BACKGROUND_BLUR_ASSET_GROUP,
  revisionID: BACKGROUND_BLUR_REVISION_ID,
}

type VideoFilterName = 'Emojify' | 'NoOp' | 'Segmentation' | 'Resize (9/16)' | 'CircularCut' |
 'Background Blur 10% CPU' | 'Background Blur 20% CPU' | 'Background Blur 30% CPU' | 
 'Background Blur 40% CPU' | 'Background Replacement' | 'None' | 'Background Blur 2.0 - Low' |
 'Background Blur 2.0 - Medium' | 'Background Blur 2.0 - High' | 'Background Replacement 2.0 - (Beach)' |
 'Background Replacement 2.0 - (Blue)' | 'Background Replacement 2.0 - (Default)';

const BACKGROUND_BLUR_V1_LIST: VideoFilterName[] = [
  'Background Blur 10% CPU',
  'Background Blur 20% CPU',
  'Background Blur 30% CPU',
  'Background Blur 40% CPU',
];

const BACKGROUND_REPLACEMENT_V1_LIST: VideoFilterName[] = [
  'Background Replacement',
];


const BACKGROUND_FILTER_V2_LIST: VideoFilterName[] = [
  'Background Blur 2.0 - Low',
  'Background Blur 2.0 - Medium',
  'Background Blur 2.0 - High',
  'Background Replacement 2.0 - (Beach)',
  'Background Replacement 2.0 - (Blue)',
  'Background Replacement 2.0 - (Default)',
];


const VIDEO_FILTERS: VideoFilterName[] = ['Emojify', 'NoOp', 'Resize (9/16)', 'CircularCut'];

type ButtonState = 'on' | 'off' | 'disabled';

const SimulcastLayerMapping = {
  [SimulcastLayers.Low]: 'Low',
  [SimulcastLayers.LowAndMedium]: 'Low and Medium',
  [SimulcastLayers.LowAndHigh]: 'Low and High',
  [SimulcastLayers.Medium]: 'Medium',
  [SimulcastLayers.MediumAndHigh]: 'Medium and High',
  [SimulcastLayers.High]: 'High',
};

const LANGUAGES_NO_WORD_SEPARATOR = new Set([
  'ja-JP',
  'zh-CN',
]);

interface Toggle {
  name: string;
  oncreate: (elem: HTMLElement) => void;
  action: () => void;
}

interface TranscriptSegment {
  contentSpan: HTMLSpanElement,
  attendee: Attendee;
  startTimeMs: number;
  endTimeMs: number;
}

interface CallParticipantTile {
  attendeeId: string;
  name: string;
  isLocal: boolean;
  hasVideo: boolean;
}

interface TranscriptionStreamParams {
  contentIdentificationType?: 'PII' | 'PHI';
  contentRedactionType?: 'PII';
  enablePartialResultsStability?: boolean;
  partialResultsStability?: string;
  piiEntityTypes?: string;
  languageModelName?: string;
  identifyLanguage?: boolean;
  languageOptions?: string;
  preferredLanguage?: string;
  vocabularyNames?: string;
  vocabularyFilterNames?: string;
}
@Component({
  selector: 'app-chime-contact',
  templateUrl: './chime-contact.component.html',
  styleUrls: ['./styleV2.scss'],
})
export class ChimeContactComponent implements OnInit, OnDestroy, AfterViewInit, AudioVideoObserver, DeviceChangeObserver, ContentShareObserver, VideoDownlinkObserver { 
  @HostBinding('class.mycelium-call-page')
  get myceliumCallPageClass(): boolean {
    const queryEntry = typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('entry')
      : null;
    return queryEntry === 'mycelium'
      || this.router?.parseUrl(this.router.url || '').queryParams?.entry === 'mycelium';
  }

  callElapsedSeconds = 0;
  callInfoOpen = false;
  callInviteCopied = false;
  inviteEmailsInput = '';
  inviteEmailError = '';
  scheduledCallId: string | null = null;
  scheduledStartAt: Date | null = null;
  scheduledCallLoading = false;
  scheduledCallError = '';
  private inviteEmails: string[] = [];
  private callElapsedTimer: ReturnType<typeof setInterval> | null = null;
  private callStartedAt: number | null = null;

  get callElapsedLabel(): string {
    const total = Math.max(0, this.callElapsedSeconds);
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    return hours > 0
      ? `${hours}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`
      : `${minutes}:${String(seconds).padStart(2, '0')}`;
  }

  private startCallElapsedTimer(): void {
    if (this.callStartedAt === null) this.callStartedAt = Date.now();
    if (this.callElapsedTimer !== null) return;

    const updateElapsed = () => this.ngZone.run(() => {
      if (this.callStartedAt !== null) {
        this.callElapsedSeconds = Math.floor((Date.now() - this.callStartedAt) / 1000);
      }
    });
    updateElapsed();
    this.callElapsedTimer = setInterval(updateElapsed, 1000);
  }

  private stopCallElapsedTimer(): void {
    if (this.callElapsedTimer !== null) clearInterval(this.callElapsedTimer);
    this.callElapsedTimer = null;
    this.callStartedAt = null;
  }

  get callInviteUrl(): string {
    return `https://supercumulo.laniakea.tv/loader?meeting=${encodeURIComponent(this.meeting || '')}`;
  }

  toggleCallInfo(): void {
    this.callInfoOpen = !this.callInfoOpen;
    this.callInviteCopied = false;
  }

  async copyCallInvite(): Promise<void> {
    this.callInviteCopied = await this.copyTextToClipboard(this.callInviteUrl);
  }

  onInviteEmailsInput(event: Event): void {
    this.inviteEmailsInput = (event.target as HTMLTextAreaElement)?.value || '';
    this.inviteEmailError = '';
  }

  private validateInviteEmails(): boolean {
    const emails = this.inviteEmailsInput
      .split(/[;,\n]+/)
      .map(email => email.trim())
      .filter(Boolean);
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emails.length > 10) {
      this.inviteEmailError = 'Puedes invitar hasta 10 personas por llamada.';
      return false;
    }
    if (emails.some(email => !emailPattern.test(email))) {
      this.inviteEmailError = 'Revisa los correos. Sepáralos con comas o saltos de línea.';
      return false;
    }
    this.inviteEmails = Array.from(new Set(emails.map(email => email.toLowerCase())));
    this.inviteEmailError = '';
    return true;
  }

  private async sendMeetingInvitations(): Promise<void> {
    if (!this.inviteEmails.length) return;
    const inviteUrl = `https://supercumulo.laniakea.tv/loader?meeting=${encodeURIComponent(this.meeting || '')}`;
    try {
      const response = await this.request.createRequestPost('call-invitations', {
        emails: this.inviteEmails,
        meetingTitle: this.meeting,
        meetingUrl: inviteUrl,
        region: this.region,
      });
      const result = typeof response === 'string' ? JSON.parse(response) : response;
      const sent = Number(result?.sent ?? this.inviteEmails.length);
      const failed = Array.isArray(result?.failed) ? result.failed : [];
      await Swal2.fire({
        title: failed.length ? 'Invitaciones enviadas parcialmente' : 'Invitaciones enviadas',
        text: failed.length
          ? `Se enviaron ${sent}. No se pudieron enviar a: ${failed.join(', ')}`
          : `Enviamos el enlace de la llamada a ${sent} ${sent === 1 ? 'invitado' : 'invitados'}.`,
        icon: failed.length ? 'warning' : 'success',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 5000,
      });
    } catch (error) {
      console.error('Could not send call invitations.', error);
      this.inviteEmailError = 'No se pudieron enviar las invitaciones. Puedes continuar y compartir el enlace desde la llamada.';
      await Swal2.fire({
        title: 'No se enviaron las invitaciones',
        text: this.inviteEmailError,
        icon: 'error',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 6000,
      });
    }
  }

  publication_category;
  CallRingtone;
  private outgoingCallListener?: { unsubscribe(): void };
  private outgoingCallMeeting?: string;
  private outgoingRinging = false;
  private readonly notifiedCallMeetings = new Set<string>();
  public sound:Howl;
public message;
  @Input() profile_photo: any;
  @Input() isPublication: boolean= false;
  @Input() broadcast: boolean = false;
  @Input() receipient_user_id: any;
  @Input() conversationID: any;
  public messageResponse: Message;
  public newMessage: Message;
  @ViewChild('tileArea', { static: false }) tileArea: ElementRef;
  @Input() meetingID: any;
  @Input() nativeCallUUID?: string;
  @Input() nativeInitiallyMuted = false;
  @Input() nativeIncomingVideo = false;
  private nativeVideoStarted = false;
  private incomingVideoUpgrade = false;
  private nativeCallListener?: PluginListenerHandle;
  private nativeCallMuted = false;
  private nativeCallEnding = false;
  private videoUpgradeRequested = false;
  private callPageDestroyed = false;
  public showNoVideoPlaceholder = true;
  public noVideoDisplayName = 'Esperando video';
  public callParticipants: CallParticipantTile[] = [];
  private chatCallSession = typeof window !== 'undefined'
    && new URLSearchParams(window.location.search).get('chat_call') === 'true';
  private readonly remoteParticipantNames = new Map<string, string>();
  private readonly presentRemoteAttendees = new Set<string>();
  private readonly videoTileAttendeeIds = new Map<number, string>();
  @Input() answering: boolean= false;
  @Input() videoCall: boolean= false;
  @Input() call: boolean= false;
  @Input() username:any;
  public showSwipeIntro: boolean = false;

  get isOneToOneCallSession(): boolean {
    const queryCall = typeof window !== 'undefined'
      && new URLSearchParams(window.location.search).get('chat_call') === 'true';
    return queryCall || this.chatCallSession || this.isChatCallRoute() || this.call || this.videoCall || this.answering;
  }

  get isAudioOnlyCall(): boolean {
    if (!this.isOneToOneCallSession) return false;
    const tileArea = this.elementRef?.nativeElement?.querySelector('#tile-area') as HTMLElement | null;
    const activeTiles = Array.from(tileArea?.querySelectorAll('.video-tile.active:not(.camera-off)') || []);
    const hasRenderedVideo = activeTiles.some(tile => {
      const video = tile.querySelector('video') as HTMLVideoElement | null;
      const stream = video?.srcObject as MediaStream | null;
      return stream?.getVideoTracks?.()
        .some(track => track.readyState === 'live' && track.enabled) || false;
    });
    return !hasRenderedVideo;
  }

  get callStageParticipants(): CallParticipantTile[] {
    const participants = this.callParticipants.map(participant => ({
      ...participant,
      name: participant.isLocal
        ? this.localParticipantDisplayName()
        : this.displayParticipantName(participant.name),
      hasVideo: participant.hasVideo,
    }));
    if (!participants.some(participant => participant.isLocal)) {
      participants.push({ attendeeId: 'local', name: this.localParticipantDisplayName(), isLocal: true, hasVideo: false });
    }
    return participants;
  }

  get callParticipantCount(): number {
    // Count people only; Chime content-share attendee IDs are not added to
    // callParticipants, so this stays aligned with the participant roster.
    return this.callStageParticipants.length;
  }

  private displayParticipantName(name: string): string {
    const normalizedName = (name || '').trim();
    return !normalizedName || normalizedName === 'Participant' || normalizedName === 'You'
      ? 'Tu contacto'
      : normalizedName.replace(/^@/, '');
  }

  private localParticipantDisplayName(): string {
    const routeUsername = typeof this.username === 'string' ? this.username.trim() : '';
    const urlUsername = typeof window !== 'undefined'
      ? new URLSearchParams(window.location.search).get('username') || ''
      : '';
    const profileUsername = this.formservice?.profile?.username || this.formservice?.user?.username || '';
    const username = (routeUsername || urlUsername || profileUsername).toString().trim().replace(/^@/, '');
    return username ? `@${username}` : 'Tú';
  }

  /** Render call identities above Ionic and Chime's independent stacking layers. */
  private renderCallStageOverlay(): void {
    const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
    const isCallRoute = this.isMyceliumCallRoute()
      || this.isOneToOneCallSession
      || params?.get('chat_call') === 'true'
      || params?.get('call') === 'true'
      || params?.get('videoCall') === 'true';
    const existing = document.getElementById('call-session-identity-stage');
    // A hidden/legacy Chime instance can coexist with the routed call page.
    // It must never remove or overwrite the active call's identity layer.
    if (!isCallRoute) return;

    const stage = existing || document.createElement('section');
    stage.id = 'call-session-identity-stage';
    stage.setAttribute('aria-label', 'Participantes de la llamada');
    stage.setAttribute('aria-live', 'polite');
    const tileArea = this.elementRef?.nativeElement?.querySelector('#tile-area') as HTMLElement | null;
    const hasVideo = this.callParticipants.some(participant => participant.hasVideo
      && (participant.isLocal || this.presentRemoteAttendees.has(participant.attendeeId)))
      || Array.from(tileArea?.querySelectorAll('.video-tile.active:not(.camera-off)') || [])
      .some(tile => {
        const attendeeId = tile.querySelector('.video-tile-attendee-id')?.textContent?.trim();
        if (!tile.classList.contains('local-tile') && (!attendeeId || !this.presentRemoteAttendees.has(attendeeId))) {
          return false;
        }
        const video = tile.querySelector('video');
        if (!video) return false;
        const stream = (video as HTMLVideoElement).srcObject as MediaStream | null;
        const element = video as HTMLVideoElement;
        return (!!stream?.getVideoTracks?.().some(track => track.readyState === 'live' && track.enabled)
          && element.readyState >= HTMLMediaElement.HAVE_CURRENT_DATA) || element.videoWidth > 0;
      });
    const dropdownOpen = this.callDropdownNames.some(name =>
      this.getLocalElement<HTMLElement>(`dropdown-menu-${name}`)?.classList.contains('call-device-menu--open'))
      || this.getLocalElement<HTMLElement>('dropdown-menu-filter')?.classList.contains('live-filter-menu--open');
    const participants = this.callStageParticipants;
    stage.replaceChildren();
    Object.assign(stage.style, {
      position: 'absolute',
      zIndex: '12',
      inset: '0',
      display: 'grid',
      gridTemplateColumns: participants.length === 1
        ? 'minmax(0, min(100%, 680px))'
        : 'repeat(2, minmax(0, 1fr))',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      gap: '16px',
      padding: '18px 18px 104px',
      borderRadius: '20px',
      background: 'radial-gradient(ellipse at 50% 35%, #252b39 0%, #15171d 72%)',
      pointerEvents: 'none',
      boxSizing: 'border-box',
    });

    participants.forEach(participant => {
      const card = document.createElement('article');
      Object.assign(card.style, {
        display: 'flex',
        minWidth: '0',
        minHeight: 'min(30vh, 260px)',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        padding: '18px 10px',
        border: '1px solid rgba(255,255,255,.25)',
        borderRadius: '18px',
        color: '#fff',
        background: 'linear-gradient(145deg, #343b4c, #1c2029)',
        boxShadow: '0 8px 28px rgba(0,0,0,.3)',
        textAlign: 'center',
        overflow: 'hidden',
        fontFamily: 'system-ui, sans-serif',
      });
      const participantPhoto = participant.isLocal ? this.profile_photo : null;
      const avatar = document.createElement(participantPhoto ? 'img' : 'span');
      if (participantPhoto) {
        (avatar as HTMLImageElement).src = participantPhoto;
        (avatar as HTMLImageElement).alt = '';
      } else {
        avatar.textContent = participant.name.replace(/^@/, '').slice(0, 1).toUpperCase() || '•';
      }
      Object.assign(avatar.style, {
        display: 'grid',
        flex: '0 0 auto',
        width: 'clamp(64px, 11vw, 96px)',
        height: 'clamp(64px, 11vw, 96px)',
        placeItems: 'center',
        border: '2px solid rgba(255,255,255,.52)',
        borderRadius: '50%',
        color: '#fff',
        background: participant.isLocal ? '#53658f' : '#765777',
        fontSize: 'clamp(28px, 5vw, 44px)',
        fontWeight: '700',
        objectFit: 'cover',
      });
      const name = document.createElement('strong');
      name.textContent = participant.name;
      Object.assign(name.style, {
        maxWidth: '100%',
        color: '#fff',
        fontSize: 'clamp(16px, 2.4vw, 22px)',
        fontWeight: '650',
        overflowWrap: 'anywhere',
      });
      card.append(avatar, name);
      const camera = document.createElement('span');
      camera.textContent = 'Cámara apagada';
      Object.assign(camera.style, { color: 'rgba(255,255,255,.72)', fontSize: '13px' });
      card.appendChild(camera);
      stage.appendChild(card);
    });

    if (participants.length === 1 && participants[0].isLocal) {
      const waiting = document.createElement('p');
      waiting.textContent = 'Esperando a que se unan a la llamada';
      Object.assign(waiting.style, {
        gridColumn: '1 / -1',
        margin: '0',
        color: 'rgba(255,255,255,.72)',
        textAlign: 'center',
        fontSize: '14px',
      });
      stage.appendChild(waiting);
    }

    const stageHost = this.elementRef?.nativeElement?.querySelector('#tile-transcript-container') as HTMLElement | null;
    stage.style.display = hasVideo || dropdownOpen ? 'none' : 'grid';
    if (stageHost && stage.parentElement !== stageHost) stageHost.appendChild(stage);
  }

  trackCallParticipant(_index: number, participant: CallParticipantTile): string {
    return participant.attendeeId;
  }

  enableVideoFromAudioStage(): void {
    this.getLocalElement<HTMLButtonElement>('button-camera')?.click();
  }
  public audioElement: HTMLAudioElement; // Add this line
  public videoElement: HTMLVideoElement; // Add this line
  public chatModalOpen: boolean = false;
public showStats:boolean=false;
public buttonsModalOpen: boolean= true;
public joiningMeeting: boolean = false;
public authenticatingMeeting: boolean = false;
public tiles: any[];
  private dismissing = false;
  private returnToEcosystemAfterLeave = false;
  private returnToPreviousRouteAfterLeave = false;

  private isWebviewLiveRoute(): boolean {
    const routePath = this.router?.url?.split('?')[0]?.replace(/\/+$/, '') || '';
    return routePath === '/chime-contact'
      || routePath.startsWith('/calls/active/')
      || new URL(window.location.href).searchParams.get('webview-live') === 'true';
  }

  private isMyceliumCallRoute(): boolean {
    return this.router.url.split('?')[0].replace(/\/+$/, '') === '/chime-contact'
      && this.router.parseUrl(this.router.url).queryParams.entry === 'mycelium';
  }

  private async returnFromCallPage(): Promise<void> {
    if (this.isMyceliumCallRoute()) {
      await this.navController.navigateBack('/mycelium');
      return;
    }
    await this.navController.back();
  }

  private hydrateWebviewLiveRouteInputs(): void {
    if (!this.isWebviewLiveRoute()) {
      return;
    }

    const params = new URL(window.location.href).searchParams;
    this.username = params.get('username') || this.username;
    this.profile_photo = params.get('profile_photo') || this.profile_photo;
    this.isPublication = params.get('isPublication') === 'true';
    this.broadcast = params.get('broadcast') === 'true';
  }

  private hydrateChatCallRouteInputs(): void {
    const route = this.getChatCallRoute();
    if (!route) {
      return;
    }

    this.chatCallSession = true;
    const params = route.searchParams;
    this.username = params.get('username') || this.username;
    this.receipient_user_id = params.get('recipient_user_id')
      || params.get('receipient_user_id')
      || this.receipient_user_id;
    this.conversationID = params.get('conversationID') || this.conversationID;
    this.call = params.get('call') === 'true';
    this.videoCall = params.get('videoCall') === 'true';
  }

  private isChatCallRoute(): boolean {
    return this.getChatCallRoute() !== null;
  }

  private getChatCallRoute(): URL | null {
    if (typeof window !== 'undefined') {
      const browserUrl = new URL(window.location.href);
      if (browserUrl.pathname.replace(/\/+$/, '').endsWith('/chime-contact')
        && browserUrl.searchParams.get('chat_call') === 'true') {
        return browserUrl;
      }
    }

    const routeUrl = this.router?.url || '';
    const [path, query = ''] = routeUrl.split('?');
    if (path.replace(/\/+$/, '').endsWith('/chime-contact')) {
      const route = new URL(`https://laniakea.invalid${path}?${query}`);
      return route.searchParams.get('chat_call') === 'true' ? route : null;
    }
    return null;
  }

  private async hydrateIncomingCallPage(): Promise<boolean> {
    const route = this.router.parseUrl(this.router.url);
    const path = this.router.url.split('?')[0];
    const nativeMatch = path.match(/^\/calls\/active\/([^/]+)$/);
    if (nativeMatch) {
      const { calls } = await NativeCalls.getPending();
      if (this.callPageDestroyed) return false;
      const call = calls.find(value => value.uuid === decodeURIComponent(nativeMatch[1]) && value.action === 'answer');
      if (!call?.meeting_id) {
        await this.router.navigate(['/home/ecosystem-page'], { replaceUrl: true });
        return false;
      }
      // Recover old active-call URLs through the same single-owner handoff.
      if (!this.callPageDestroyed) {
        await this.router.navigateByUrl(
          `/chime-contact?incoming_call=true&meeting_id=${encodeURIComponent(call.meeting_id)}`
          + `&videoUpgrade=true&nativeHandoffUUID=${encodeURIComponent(call.uuid)}`,
          { replaceUrl: true }
        );
      }
      return false;
    } else if (path === '/chime-contact' && route.queryParams.incoming_call === 'true') {
      this.incomingVideoUpgrade = route.queryParams.videoUpgrade === 'true';
      const handoffUUID = route.queryParams.nativeHandoffUUID;
      if (handoffUUID) {
        const { calls } = await NativeCalls.getPending();
        if (this.callPageDestroyed) return false;
        const call = calls.find(value => value.uuid === handoffUUID && value.action === 'answer'
          && value.meeting_id === route.queryParams.meeting_id);
        if (!call) throw new Error('The native call is no longer active');
        this.meetingID = call.meeting_id;
        this.nativeIncomingVideo = !!call.has_video || this.incomingVideoUpgrade;
        this.answering = true;
        await NativeCalls.handoffToWeb({ uuid: handoffUUID });
        if (this.callPageDestroyed) return false;
        return true;
      }
      const raw = await this.request.createRequestPost('iosCall', {
        action: 'status', meeting_id: route.queryParams.meeting_id, token: this.callSignaling.deviceToken,
      });
      if (this.callPageDestroyed) return false;
      const state = typeof raw === 'string' ? JSON.parse(raw) : raw;
      if (!state?.is_recipient || (state.status !== 'ringing' && !state.answered_here)) {
        await this.router.navigate(['/home/ecosystem-page'], { replaceUrl: true });
        return false;
      }
      if (state.status === 'ringing') {
        await this.request.createRequestPost('iosCall', {
          action: 'answer', meeting_id: state.meeting_id, token: this.callSignaling.deviceToken,
        });
        if (this.callPageDestroyed) return false;
      }
      this.meetingID = state.meeting_id;
      this.nativeIncomingVideo = !!state.has_video || this.incomingVideoUpgrade;
      this.answering = true;
    }
    if (this.nativeCallUUID) {
      this.nativeCallMuted = this.nativeInitiallyMuted;
      this.nativeCallListener = await NativeCalls.addListener('callEvent', event => {
        if (event.uuid !== this.nativeCallUUID) return;
        if (event.action === 'end') {
          this.audioVideo?.stop();
          void this.stopPrejoinMedia();
        } else if (event.action === 'mute') {
          this.nativeCallMuted = !!event.muted;
          if (!this.audioVideo) return;
          if (this.nativeCallMuted) this.audioVideo.realtimeMuteLocalAudio();
          else this.audioVideo.realtimeUnmuteLocalAudio();
        }
      });
      if (this.callPageDestroyed) {
        await this.nativeCallListener.remove();
        return false;
      }
    }
    return true;
  }

onPrivacyChange(event) {

  this.publication_category = event.detail.value;
  console.log('publication_category',this.publication_category);
}

  async ngOnInit() {
    try {
      if (!(await this.hydrateIncomingCallPage())) return;
    } catch (error) {
      console.warn('Could not restore the incoming call page:', error);
      await this.router.navigate(['/home/ecosystem-page'], { replaceUrl: true });
      return;
    }
    // Route navigation cannot populate @Input values, so live and chat-call
    // routes hydrate their inputs before the meeting flow starts.
    this.hydrateWebviewLiveRouteInputs();
    this.hydrateChatCallRouteInputs();
    if (this.isOneToOneCallSession) {
      this.renderCallStageOverlay();
      requestAnimationFrame(() => this.renderCallStageOverlay());
      setTimeout(() => this.renderCallStageOverlay(), 250);
    }
    if (this.isPublication) {
      this.chatModalOpen = true;
    }

    if (this.receipient_user_id){// 2 way call
      let type;
      if(this.videoCall){
        type='Video'
      }else if(this.call){
        type='audio';
      }
      this.request.createRequestPost('Historic_calls', { postCall:true, receipient_user_id:this.receipient_user_id, conversationID:this.conversationID, type:type})
      .then((final_data) => {
        if (final_data && typeof final_data === 'string') {
          try {
            final_data = JSON.parse(final_data);
            console.log('getRecordByToken ios:',final_data);
          } catch (error) {
            console.error("Error parsing data:", error);
          }
          }
    console.log(final_data);
      
      })
    }

    //this.audioElement = document.getElementById('chime-audio-element') as HTMLAudioElement; // Get the audio element
   // this.initChimeSession();
  
    //if (this.videoCall === true){
//this.startVideoCall();
  //  }
 
  this.initEventListeners();
  this.initParameters();
  this.setMediaRegion();
  await this.hydrateScheduledCall();
  if (this.isRecorder()) {
    AsyncScheduler.nextTick(async () => {
      this.meeting = new URL(window.location.href).searchParams.get('m');
      this.name = this.isRecorder() ? '«Meeting Recorder»' : '«Meeting Broadcaster»';
      await this.authenticate();
      await this.openAudioOutputFromSelection();
      await this.join();
      this.displayButtonStates();
      this.switchToFlow('flow-meeting');
    });
  } else if (this.isBroadcaster()) {
    // A Live opened from the WebView must not inherit the WebView's `m`
    // query parameter. Start at the title form, then continue to preview.
    this.switchToFlow('flow-authenticate');
  } else if(this.videoCall === true || this.call === true){

    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let meeting = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      meeting += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    this.meeting=meeting + now();
this.region="ap-southeast-1";
    this.name= '@'+this.username;
    
    await this.redirectFromAuthentication(true);
 
    const buttonVideo = this.getLocalElement<HTMLButtonElement>('button-camera');
    if (this.videoCall === true) setTimeout(() => {

console.log('video calling');
   
   // To programmatically trigger a click on the button:
  buttonVideo?.click();
}, 9900); 

/*
  } else if(this.call === true){
		
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let meeting = '';
    const charactersLength = characters.length;
    for (let i = 0; i < length; i++) {
      meeting += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    this.meeting=meeting + now();
    this.region="ap-southeast-1";
    this.name= '@'+this.username;
  

          this.redirectFromAuthentication(true);



*/
 
  }else if(this.answering === true){

    this.meeting=this.meetingID;
    this.region="ap-southeast-1";
   
    this.redirectFromAuthentication(true);
    this.request.createRequestPost('Historic_calls', { answerCall:true, meetingID: this.meeting})
    .then((final_data) => {
      if (final_data && typeof final_data === 'string') {
        try {
          final_data = JSON.parse(final_data);
          console.log('getRecordByToken ios:',final_data);
        } catch (error) {
          console.error("Error parsing data:", error);
        }
        }
      if (!this.name) this.name='Tu vecino amistoso';
  console.log(final_data);
  if (final_data){
    this.name=final_data;
  }

  this.refreshNoVideoPlaceholder();
    
    })

    this.chatService.stopAudio();
  }else {
    this.switchToFlow('flow-authenticate');
  }
  }
   


  private async hydrateScheduledCall(): Promise<void> {
    const params = new URL(window.location.href).searchParams;
    const publicId = params.get('scheduled_call');
    if (!publicId || !this.isMyceliumCallRoute()) return;
    this.scheduledCallId = publicId;
    this.scheduledCallLoading = true;
    try {
      const response = await fetch(`https://supercluster-api.laniakea.tv/api/scheduled-calls/${encodeURIComponent(publicId)}`, {
        headers: { Accept: 'application/json' },
      });
      const call = await response.json();
      if (!response.ok) throw new Error(call?.message || 'No encontramos esta reunión programada.');
      this.meeting = String(call.title || '');
      this.region = String(call.region || 'us-west-2');
      this.scheduledStartAt = new Date(call.starts_at);
      this.scheduledCallError = '';
      const titleInput = this.getLocalElement<HTMLInputElement>('inputMeeting');
      if (titleInput) titleInput.value = this.meeting;
      const regionInput = this.getLocalElement<HTMLSelectElement>('inputRegion');
      if (regionInput) regionInput.value = this.region;
      this.updatePrejoinSummary();
    } catch (error) {
      this.scheduledCallError = error instanceof Error ? error.message : 'No se pudo cargar la reunión.';
      await Swal2.fire({ title: 'Reunión no disponible', text: this.scheduledCallError, icon: 'error' });
    } finally {
      this.scheduledCallLoading = false;
    }
  }

  get scheduledCallTimeLabel(): string {
    return this.scheduledStartAt ? this.scheduledStartAt.toLocaleString() : '';
  }

  
  
    


  
  ngAfterViewInit() {
    requestAnimationFrame(() => this.renderCallStageOverlay());
    setTimeout(() => {
    if (localStorage.getItem('live_meeting_swipe_intro') != 'true') {
      this.showSwipeIntro=true;
      setTimeout(() => {
       this.showSwipeIntro=false;
       localStorage.setItem("live_meeting_swipe_intro","true");
       }, 9000);
      
       }
      }, 30000);
    console.log('Scrolling to bottom');
    setTimeout(() => {
      this.scrollToBottom();
    }, 6000); // Adjust the delay as needed
  }
  
  scrollToBottom() {
    if (this.tileArea && this.tileArea.nativeElement) {
      console.log('Scrolling to bottom2');
      const element = this.tileArea.nativeElement;
      element.scrollTop = element.scrollHeight;
    }
  }
 
  ngOnDestroy(){
document.removeEventListener('click', this.dismissCallDropdowns);
if (new URLSearchParams(window.location.search).get('chat_call') !== 'true') {
  document.getElementById('call-session-identity-stage')?.remove();
}
this.callPageDestroyed = true;
this.stopCallElapsedTimer();
this.outgoingCallListener?.unsubscribe();
if (this.outgoingCallMeeting) void this.request.createRequestPost('iosCall', { action: 'end', meeting_id: this.outgoingCallMeeting }).catch(console.warn);
if (this.nativeCallListener) void this.nativeCallListener.remove();
if (this.nativeCallUUID && this.nativeCallEnding) void NativeCalls.end({ uuid: this.nativeCallUUID }).catch(console.warn);
if (this.nativeCallUUID && !this.nativeCallEnding) {
  this.audioVideo?.stop();
  const uuid = this.nativeCallUUID;
  setTimeout(() => { void NativeCalls.resumeNativeAudio({ uuid }).catch(console.warn); }, 1000);
}
void this.stopPrejoinMedia();
if (this.meeting && !this.nativeCallUUID) void this.endMeeting();
this.formservice.webViewLive=true;
this.chatService.stopAudio();
clearInterval(this.CallRingtone);
this.CallRingtone=null;
this.stopAudio();

  }
  stopAudio() {
    if (this.sound) {
      this.sound.stop();
    }
}
  async sendNotification(title, body, user_id, meeting_id): Promise<any> {
    // One invitation per meeting. Call signaling never writes a DM or uses a
    // chat message as a keepalive; AppSync carries actual call transitions.
    if (this.notifiedCallMeetings.has(meeting_id)) return;
    this.notifiedCallMeetings.add(meeting_id);
    this.outgoingCallMeeting = meeting_id;
    this.outgoingRinging = true;
    this.outgoingCallListener?.unsubscribe();
    this.outgoingCallListener = this.callSignaling.events.subscribe(call => {
      if (call.meeting_id === meeting_id && call.status !== 'ringing') this.stopOutgoingRinging();
    });
    void this.callSignaling.start('outgoing call ringing').catch(console.warn);
    this.sound = new Howl({
      src: ['https://static.wixstatic.com/mp3/8c5863_d1b991bee6494f158c45b1f8cab56355.mp3'],
      html5: true, autoplay: true, loop: true, volume: 1.0,
    });
    // Reconcile call state while the push request is still in flight. The
    // previous flow waited for push delivery, then waited another 10 seconds
    // before checking whether the recipient had already answered in CallKit.
    const deadline = Date.now() + 45000;
    let checkingCallState = false;
    const check = async () => {
      if (checkingCallState || this.callPageDestroyed || this.outgoingCallMeeting !== meeting_id || !this.outgoingRinging) return;
      if (Date.now() >= deadline) { this.stopOutgoingRinging(); return; }
      checkingCallState = true;
      try {
        const rawState = await this.request.createRequestPost('iosCall', { action: 'status', meeting_id });
        const state = typeof rawState === 'string' ? JSON.parse(rawState) : rawState;
        if (state?.status && state.status !== 'ringing') { this.stopOutgoingRinging(); return; }
      } catch (error) { console.warn('Could not reconcile outgoing call:', error); }
      finally { checkingCallState = false; }
      if (this.outgoingCallMeeting === meeting_id && this.outgoingRinging && !this.callPageDestroyed) {
        this.CallRingtone = setTimeout(() => { void check(); }, 2000);
      }
    };
    this.CallRingtone = setTimeout(() => { void check(); }, 1000);
    try {
      const raw = await this.request.createRequestPost('GreatAtractorNotifications', {
        title, body, user_id, meeting_id, has_video: this.videoCall === true, push_only: true,
      });
      return typeof raw === 'string' ? JSON.parse(raw) : raw;
    } catch (error) {
      this.stopOutgoingRinging();
      throw error;
    }
  }

  private stopOutgoingRinging(): void {
    this.outgoingRinging = false;
    clearTimeout(this.CallRingtone);
    this.CallRingtone = null;
    this.outgoingCallListener?.unsubscribe();
    this.outgoingCallListener = undefined;
    // Keep the meeting identity for cancellation/end after the ringtone stops.
    this.stopAudio();
  }

  static readonly DID: string = '+17035550122';
  /*static readonly BASE_URL: string = [
    location.protocol,
    '//',
    location.host,
    location.pathname.replace(/\/*$/, '/').replace('/v2', ''),
  ].join('');*/
  static readonly BASE_URL: string = 'https://8ye5c0s1v6.execute-api.us-east-1.amazonaws.com/Prod/';
  static testVideo: string =
      'https://upload.wikimedia.org/wikipedia/commons/transcoded/c/c0/Big_Buck_Bunny_4K.webm/Big_Buck_Bunny_4K.webm.360p.vp9.webm';
  static readonly MAX_MEETING_HISTORY_MS: number = 5 * 60 * 1000;
  static readonly DATA_MESSAGE_TOPIC: string = 'chat';
  static readonly DATA_MESSAGE_LIFETIME_MS: number = 300_000;

  // Ideally we don't need to change this. Keep this configurable in case users have a super slow network.
  loadingBodyPixDependencyTimeoutMs: number = 10_000;
  loadingBodyPixDependencyPromise: undefined | Promise<void>;

  attendeeIdPresenceHandler: (undefined | ((attendeeId: string, present: boolean, externalUserId: string, dropped: boolean) => void)) = undefined;
  activeSpeakerHandler: (undefined | ((attendeeIds: string[]) => void)) = undefined;
  volumeIndicatorHandler:  (undefined | ((attendeeId: string, volume: number, muted: boolean, signalStrength: number) => void)) = undefined;
  canUnmuteLocalAudioHandler: (undefined | ((canUnmute: boolean) => void)) = undefined;
  muteAndUnmuteLocalAudioHandler: (undefined | ((muted: boolean) => void)) = undefined;
  blurObserver: (undefined | BackgroundBlurVideoFrameProcessorObserver) = undefined;
  replacementObserver: (undefined | BackgroundReplacementVideoFrameProcessorObserver) = undefined;

  showActiveSpeakerScores = false;
  meeting: string | null = null;
  name: string | null = null;
  voiceConnectorId: string | null = null;
  sipURI: string | null = null;
  region: string | null = null;
  primaryExternalMeetingId: string | undefined = undefined;
  // We cache these so we can avoid having to create new attendees for promotion retries
  // and so the local UX on attendee IDs matches the remote experience
  primaryMeetingSessionCredentials: MeetingSessionCredentials | undefined = undefined;
  meetingSession: MeetingSession | null = null;
  priorityBasedDownlinkPolicy: VideoPriorityBasedPolicy | null = null;
  audioVideo: AudioVideoFacade | null = null;
  deviceController: DefaultDeviceController | undefined = undefined;
  canStartLocalVideo: boolean = true;
  defaultBrowserBehavior: DefaultBrowserBehavior = new DefaultBrowserBehavior();
  videoTileCollection: VideoTileCollection | undefined = undefined;
  videoPreferenceManager: VideoPreferenceManager | undefined = undefined;

  // eslint-disable-next-line
  roster: Roster = new Roster();

  contentShare: ContentShareManager | undefined = undefined;

  cameraDeviceIds: string[] = [];
  microphoneDeviceIds: string[] = [];
  currentAudioInputDevice: AudioInputDevice | undefined;

  buttonStates: { [key: string]: ButtonState } = {
    'button-microphone': 'on',
    'button-camera': 'off',
    'button-speaker': 'on',
    'button-content-share': 'off',
    'button-live-transcription': 'off',
    'button-video-stats': 'off',
    'button-promote-to-primary': 'off',
    'button-video-filter': 'off',
    //'button-video-recording-drop' : 'off',
    'button-record-self': 'off',
    'button-record-cloud': 'off',
    'button-live-connector': 'off',
  };

  isViewOnly = false;

  // feature flags
  enableWebAudio = false;
  logLevel = LogLevel.INFO;
  videoCodecPreferences: VideoCodecCapability[] | undefined = undefined;
  enableSimulcast = false;
  usePriorityBasedDownlinkPolicy = true;
  videoPriorityBasedPolicyConfig = new VideoPriorityBasedPolicyConfig;
  enablePin = false;
  echoReductionCapability = false;
  usingStereoMusicAudioProfile = false;

  supportsVoiceFocus = false;
  enableVoiceFocus = false;
  joinMuted = false;
  voiceFocusIsActive = false;

  supportsBackgroundBlur = false;
  supportsBackgroundReplacement = false;
  supportsVideoFx = false;

  enableLiveTranscription = false;
  noWordSeparatorForTranscription = false;

  markdown = require('markdown-it')({ linkify: true });
  lastMessageSender: string | null = null;
  lastReceivedMessageTimestamp = 0;
  lastPacketsSent = 0;
  meetingSessionPOSTLogger: POSTLogger;
  meetingEventPOSTLogger: POSTLogger;

  hasChromiumWebRTC: boolean = this.defaultBrowserBehavior.hasChromiumWebRTC();

  voiceFocusTransformer: VoiceFocusDeviceTransformer | undefined;
  voiceFocusDevice: VoiceFocusTransformDevice | undefined;
  joinInfo: any | undefined;
  deleteOwnAttendeeToLeave = false;
  disablePeriodicKeyframeRequestOnContentSender = false;

  blurProcessor: BackgroundBlurProcessor | undefined;
  replacementProcessor: BackgroundReplacementProcessor | undefined;
  replacementOptions: BackgroundReplacementOptions | undefined;

  // This is an extremely minimal reactive programming approach: these elements
  // will be updated when the Amazon Voice Focus display state changes.
  voiceFocusDisplayables: HTMLElement[] = [];
  analyserNode: RemovableAnalyserNode;

  liveTranscriptionDisplayables: HTMLElement[] = [];

  chosenVideoTransformDevice: DefaultVideoTransformDevice;
  chosenVideoFilter: VideoFilterName = 'None';
  selectedVideoFilterItem: VideoFilterName = 'None';

  DEFAULT_VIDEO_FX_CONFIG: VideoFxConfig = {
    backgroundBlur: {
      isEnabled: true,
      strength: 'high',
    },
    backgroundReplacement: {
      isEnabled: false,
      backgroundImageURL: null,
      defaultColor: 'black',
    }
  }
  videoFxProcessor: VideoFxProcessor | undefined;
  videoFxConfig: VideoFxConfig = this.DEFAULT_VIDEO_FX_CONFIG;

  meetingLogger: Logger | undefined = undefined;

  // If you want to make this a repeatable SPA, change this to 'spa'
  // and fix some state (e.g., video buttons).
  // Holding Shift while hitting the Leave button is handled by setting
  // this to `halt`, which allows us to stop and measure memory leaks.
  // The `nothing` option can be used to stop cleanup from happening allowing
  // `audioVideo` to be reused without stopping the meeting.
  behaviorAfterLeave: 'spa' | 'reload' | 'halt' | 'nothing' = 'reload';

  videoMetricReport: { [id: string]: { [id: string]: {} } } = {};

  removeFatalHandlers: () => void;

  transcriptContainerDiv = document.getElementById('transcript-container') as HTMLDivElement;
  partialTranscriptDiv: HTMLDivElement | undefined;
  partialTranscriptResultTimeMap = new Map<string, number>();
  partialTranscriptResultMap = new Map<string, TranscriptResult>();
  transcriptEntitySet = new Set<string>();

  addFatalHandlers(): void {
    fatal = this.fatal.bind(this);

    const onEvent = (event: ErrorEvent): void => {
      // In Safari there's only a message.
      fatal(event.error || event.message);
    };

    // Listen for unhandled errors, too.
    window.addEventListener('error', onEvent);

    window.onunhandledrejection = (event: PromiseRejectionEvent) => {
      fatal(event.reason);
    };

    this.removeFatalHandlers = () => {
      window.onunhandledrejection = undefined;
      window.removeEventListener('error', onEvent);
      fatal = undefined;
      this.removeFatalHandlers = undefined;
    }
  }

  eventReporter: EventReporter | undefined = undefined;
  enableEventReporting = false;

  constructor(  
    private chatService: ChatService,
    private request: RequestService,
    private callSignaling: CallSignalingService,
    public formservice: FormServiceService,
    //private videoTiles: VideoTileCollection,
    //private request: RequestService,
   // private http: HttpClient
   private modalcontroller: ModalController,
   private router: Router,
   private navController: NavController,
   private ngZone: NgZone,
   @Optional() private elementRef: ElementRef<HTMLElement> = null,

    ) {
   
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (global as any).app = this;

    this.addFatalHandlers();

    if (document.location.search.includes('testfatal=1')) {
      this.fatal(new Error('Testing fatal.'));
      return;
    }

    //(document.getElementById('sdk-version') as HTMLSpanElement).innerText =
      //'amazon-chime-sdk-js@' + Versioning.sdkVersion;
  
  }
  async dismiss(): Promise<void> {
    if (this.dismissing) {
      return;
    }

    this.dismissing = true;
    await this.stopPrejoinMedia();

    if (this.isWebviewLiveRoute()) {
      if (this.nativeCallUUID) await NativeCalls.end({ uuid: this.nativeCallUUID }).catch(console.warn);
      if (this.isChatCallRoute() || this.isMyceliumCallRoute()) {
        await this.returnFromCallPage();
        return;
      }
      await this.navController.navigateRoot('/home/ecosystem-page', { replaceUrl: true }).catch(error => {
        console.error('Unable to return to the ecosystem launcher:', error);
      });
      return;
    }
    await this.modalcontroller.dismiss();
  }

  /**
   * The WebView also contains the legacy Chime markup, which uses the same IDs
   * as this modal. Always resolve controls inside this component first so the
   * visible modal does not accidentally update the hidden WebView copy.
   */
  private getLocalElement<T extends HTMLElement>(id: string): T {
    const root = this.elementRef?.nativeElement || document;
    return root.querySelector(`#${id}`) as T;
  }

  private getLocalElementsByClassName(className: string): HTMLCollectionOf<Element> {
    const root = this.elementRef?.nativeElement || document;
    return root.getElementsByClassName(className);
  }

  private readonly callDropdownNames = ['microphone', 'camera', 'content-share', 'speaker'] as const;
  private readonly dismissCallDropdowns = (event: MouseEvent): void => {
    const target = event.target as Node;
    if (this.callDropdownNames.some(name =>
      this.getLocalElement<HTMLElement>(`button-${name}-drop`)?.contains(target) ||
      this.getLocalElement<HTMLElement>(`dropdown-menu-${name}`)?.contains(target)
    )) return;
    this.closeCallDropdowns();
  };

  private closeCallDropdowns(): void {
    for (const name of this.callDropdownNames) {
      this.getLocalElement<HTMLElement>(`dropdown-menu-${name}`)?.classList.remove('show', 'call-device-menu--open');
      this.getLocalElement<HTMLElement>(`button-${name}-drop`)?.setAttribute('aria-expanded', 'false');
    }
    this.renderCallStageOverlay();
  }

  toggleCallDropdown(name: typeof this.callDropdownNames[number], event: Event): void {
    event.preventDefault();
    event.stopPropagation();
    const menu = this.getLocalElement<HTMLElement>(`dropdown-menu-${name}`);
    const trigger = this.getLocalElement<HTMLElement>(`button-${name}-drop`);
    const flow = this.getLocalElement<HTMLElement>('flow-meeting');
    if (!menu || !trigger || !flow) return;
    const wasOpen = menu.classList.contains('call-device-menu--open');
    this.closeCallDropdowns();
    this.closeVideoFilterMenu();
    if (wasOpen) return;

    // The scrollable controls clip child menus. Put them beside the filter picker.
    if (menu.parentElement !== flow) flow.appendChild(menu);
    menu.style.transform = 'none';
    if (!menu.dataset['callMenuBound']) {
      menu.addEventListener('click', click => {
        if ((click.target as HTMLElement).closest('.dropdown-item')) {
          setTimeout(() => this.closeCallDropdowns(), 0);
        }
      });
      menu.dataset['callMenuBound'] = 'true';
    }
    menu.classList.add('show', 'call-device-menu--open');
    trigger.setAttribute('aria-expanded', 'true');
    this.positionCallDropdown(menu, trigger);
    this.renderCallStageOverlay();
  }

  private positionCallDropdown(menu: HTMLElement, trigger: HTMLElement): void {
    requestAnimationFrame(() => {
      if (!menu.classList.contains('call-device-menu--open')) return;
      const padding = 10;
      const width = Math.min(280, window.innerWidth - padding * 2);
      const rect = trigger.getBoundingClientRect();
      const height = menu.getBoundingClientRect().height;
      const above = rect.top - height - 8;
      const top = above >= padding ? above : Math.min(rect.bottom + 8, window.innerHeight - height - padding);
      menu.style.position = 'fixed';
      menu.style.width = `${width}px`;
      menu.style.left = `${Math.max(padding, Math.min(rect.right - width, window.innerWidth - width - padding))}px`;
      menu.style.top = `${Math.max(padding, top)}px`;
    });
  }

  private closeVideoFilterMenu(): void {
    const menu = this.getLocalElement<HTMLDivElement>('dropdown-menu-filter');
    const filterButton = this.getLocalElement<HTMLButtonElement>('button-video-filter');
    const filterDropButton = this.getLocalElement<HTMLButtonElement>('button-video-filter-drop');

    if (!menu) {
      return;
    }

    menu.classList.remove('show', 'live-filter-menu--open');
    menu.style.removeProperty('left');
    menu.style.removeProperty('top');
    menu.style.removeProperty('width');
    menu.style.removeProperty('position');
    menu.style.removeProperty('z-index');
    filterButton?.setAttribute('aria-expanded', 'false');
    filterDropButton?.setAttribute('aria-expanded', 'false');
    this.renderCallStageOverlay();
  }

  private positionVideoFilterMenu(menu: HTMLDivElement, trigger: HTMLElement): void {
    window.requestAnimationFrame(() => {
      if (!menu.classList.contains('live-filter-menu--open')) {
        return;
      }

      const viewportPadding = 10;
      const triggerRect = trigger.getBoundingClientRect();
      const maxWidth = Math.max(180, window.innerWidth - viewportPadding * 2);
      const menuWidth = Math.min(280, maxWidth);
      const menuHeight = menu.scrollHeight;
      const left = Math.min(
          Math.max(viewportPadding, triggerRect.right - menuWidth),
          window.innerWidth - menuWidth - viewportPadding
      );
      const aboveTop = triggerRect.top - menuHeight - 8;
      const belowTop = triggerRect.bottom + 8;
      const top = aboveTop >= viewportPadding
          ? aboveTop
          : Math.min(belowTop, window.innerHeight - menuHeight - viewportPadding);

      menu.style.position = 'fixed';
      menu.style.left = `${left}px`;
      menu.style.top = `${Math.max(viewportPadding, top)}px`;
      menu.style.width = `${menuWidth}px`;
      menu.style.zIndex = '100';
    });
  }

  private toggleVideoFilterMenu(): void {
    this.closeCallDropdowns();
    const menu = this.getLocalElement<HTMLDivElement>('dropdown-menu-filter');
    const filterButton = this.getLocalElement<HTMLButtonElement>('button-video-filter');
    const filterDropButton = this.getLocalElement<HTMLButtonElement>('button-video-filter-drop');

    if (!menu || !filterDropButton) {
      return;
    }

    if (menu.classList.contains('live-filter-menu--open')) {
      this.closeVideoFilterMenu();
      this.renderCallStageOverlay();
      return;
    }

    menu.classList.add('show', 'live-filter-menu--open');
    this.renderCallStageOverlay();
    filterButton?.setAttribute('aria-expanded', 'true');
    filterDropButton.setAttribute('aria-expanded', 'true');
    this.positionVideoFilterMenu(menu, filterDropButton);
  }

  /**
   * Stop all media used by the device-selection screen before the component
   * goes away. Chime's preview helpers do not always clear the element's
   * MediaStream themselves, especially when navigation happens from a route.
   */
  private async stopPrejoinMedia(): Promise<void> {
    const videoPreview = this.getLocalElement<HTMLVideoElement>('video-preview');
    const audioVideo = this.audioVideo;

    if (audioVideo && videoPreview) {
      try {
        await audioVideo.stopVideoPreviewForVideoInput(videoPreview);
      } catch (error) {
        this.log('Video preview was already stopped.', error);
      }
    }

    if (audioVideo) {
      try {
        await audioVideo.stopVideoInput();
      } catch (error) {
        this.log('Video input was already stopped.', error);
      }

      try {
        await audioVideo.stopAudioInput();
      } catch (error) {
        this.log('Audio input was already stopped.', error);
      }
    }

    await this.stopAudioPreview();

    if (videoPreview) {
      videoPreview.pause();
      const previewStream = videoPreview.srcObject as MediaStream | null;
      previewStream?.getTracks().forEach(track => track.stop());
      videoPreview.srcObject = null;
    }
  }

  private updatePrejoinSummary(): void {
    const meetingElement = this.getLocalElement<HTMLSpanElement>('info-meeting');
    const nameElement = this.getLocalElement<HTMLSpanElement>('info-name');

    if (meetingElement) {
      meetingElement.innerText = `${this.meeting || 'this live stream'}`;
    }
    if (nameElement) {
      nameElement.innerText = `${this.name || this.username || 'your profile'}`;
    }
  }

  private isSystemDataMessage(messageText: string): boolean {
    return messageText === 'Nuevo regalo 🎁' || messageText === 'Se ha unido 👀';
  }

  private incrementCommentCounter(): void {
    const label = this.getLocalElement<HTMLLabelElement>('msjs-tiempo-real');
    if (!label) {
      return;
    }

    const currentValue = parseInt(label.innerText, 10) || 0;
    label.innerText = `${currentValue + 1}`;
  }
  /**
   * We want to make it abundantly clear at development and testing time
   * when an unexpected error occurs.
   * If we're running locally, or we passed a `fatal=1` query parameter, fail hard.
   */
  fatal(e: Error | string): void {
    // Muffle mode: let the `try-catch` do its job.
    if (!SHOULD_DIE_ON_FATALS) {
      console.info('Ignoring fatal', e);
      return;
    }

    console.error('Fatal error: this was going to be caught, but should not have been thrown.', e);

    if (e && e instanceof Error) {
      document.getElementById('stack').innerText = e.message + '\n' + e.stack?.toString();
    } else {
      document.getElementById('stack').innerText = '' + e;
    }

    this.switchToFlow('flow-fatal');
  }

  initParameters(): void {
    // The host page owns the URL query string. A Live modal must not inherit
    // an unrelated host meeting such as `?m=hub`.
    const meeting = this.isBroadcaster() ? null : new URL(window.location.href).searchParams.get('m');
    if (meeting) {
      this.getLocalElement<HTMLInputElement>('inputMeeting').value = meeting;
      this.getLocalElement<HTMLInputElement>('inputName').focus();
    } else {
      this.getLocalElement<HTMLInputElement>('inputMeeting').focus();
    }
  }

  async initVoiceFocus(): Promise<void> {
    const logger = new ConsoleLogger('SDK', LogLevel.DEBUG);
    if (!this.enableWebAudio) {
      logger.info('[DEMO] Web Audio not enabled. Not checking for Amazon Voice Focus support.');
      return;
    }

    const spec: VoiceFocusSpec = getVoiceFocusSpec(this.joinInfo);

    try {
      this.supportsVoiceFocus = await VoiceFocusDeviceTransformer.isSupported(spec, {
        logger,
      });
      if (this.supportsVoiceFocus) {
        this.voiceFocusTransformer = await this.getVoiceFocusDeviceTransformer(MAX_VOICE_FOCUS_COMPLEXITY);
        this.supportsVoiceFocus =
            this.voiceFocusTransformer && this.voiceFocusTransformer.isSupported();
        if (this.supportsVoiceFocus) {
          logger.info('[DEMO] Amazon Voice Focus is supported.');
          document.getElementById('voice-focus-setting').classList.remove('hidden');
          return;
        }
      }
    } catch (e) {
      // Fall through.
      logger.warn(`[DEMO] Does not support Amazon Voice Focus: ${e.message}`);
    }
    logger.warn('[DEMO] Does not support Amazon Voice Focus.');
    this.supportsVoiceFocus = false;
    document.getElementById('voice-focus-setting').classList.toggle('hidden', true);
  }

  async initBackgroundBlur(): Promise<void> {
    try {
      this.supportsBackgroundBlur = await BackgroundBlurVideoFrameProcessor.isSupported(this.getBackgroundBlurSpec());
    }
    catch (e) {
      this.log(`[DEMO] Does not support background blur: ${e.message}`);
      this.supportsBackgroundBlur = false;
    }
  }
  
  /**
   * Determine if the videoFxProcessor is supported in current environment
   */
  async resolveSupportsVideoFX(): Promise<void> {
    const logger = new ConsoleLogger('SDK', LogLevel.DEBUG);
    try {
      this.supportsVideoFx = await VideoFxProcessor.isSupported(logger)
    } catch (e) {
      this.log(`[DEMO] Does not support background blur/background replacement v2: ${e.message}`);
      this.supportsVideoFx = false;
    }
  }

  async createReplacementImageBlob(startColor: string, endColor: string): Promise<Blob> {
    const canvas = document.createElement('canvas');
    canvas.width = 500;
    canvas.height = 500;
    const ctx = canvas.getContext('2d');
    const grd = ctx.createLinearGradient(0, 0, 250, 0);
    grd.addColorStop(0, startColor);
    grd.addColorStop(1, endColor);
    ctx.fillStyle = grd;
    ctx.fillRect(0, 0, 500, 500);
    const blob = await new Promise<Blob>(resolve => {
      canvas.toBlob(resolve);
    });
    return blob;
  }

  /**
   * The image blob in this demo is created by generating an image
   * from a canvas, but another common scenario would be to provide
   * an image blob from fetching a URL.
   *   const image = await fetch('https://someimage.jpeg');
   *   const imageBlob = await image.blob();
   */
  async getBackgroundReplacementOptions(): Promise<BackgroundReplacementOptions> {
    if (!this.replacementOptions) {
      const imageBlob = await this.createReplacementImageBlob('#000428', '#004e92');
      this.replacementOptions = { imageBlob };
    }
    return this.replacementOptions;
  }

  async initBackgroundReplacement(): Promise<void> {
    try {
      this.supportsBackgroundReplacement = await BackgroundReplacementVideoFrameProcessor.isSupported(this.getBackgroundBlurSpec(), await this.getBackgroundReplacementOptions());
    }
    catch (e) {
      this.log(`[DEMO] Does not support background replacement: ${e.message}`);
      this.supportsBackgroundReplacement = false;
    }
  }

  private async onVoiceFocusSettingChanged(): Promise<void> {
    this.log('[DEMO] Amazon Voice Focus setting toggled to', this.enableVoiceFocus);
    this.openAudioInputFromSelectionAndPreview();
  }

  initEventListeners(): void {
    document.addEventListener('click', this.dismissCallDropdowns);
    (document.getElementById('join-muted') as HTMLInputElement).addEventListener(
      'change',
      e => {
        this.joinMuted = (e.target as HTMLInputElement).checked;
        if (this.joinMuted) {
          this.buttonStates['button-microphone'] = 'off';
        } else {
          this.buttonStates['button-microphone'] = 'on';
        }
      }
    );

    if (!this.defaultBrowserBehavior.hasChromiumWebRTC()) {
      (document.getElementById('simulcast') as HTMLInputElement).disabled = true;
      (document.getElementById('content-simulcast-config')).style.display = 'none';
    }
    document.getElementById('join-view-only').addEventListener('change', () => {
      this.isViewOnly = (document.getElementById('join-view-only') as HTMLInputElement).checked;
    });

    document.getElementById('priority-downlink-policy').addEventListener('change', e => {
      this.usePriorityBasedDownlinkPolicy = (document.getElementById('priority-downlink-policy') as HTMLInputElement).checked;

      const serverSideNetworkAdaption = document.getElementById(
          'server-side-network-adaption'
      ) as HTMLSelectElement;
      const paginationPageSize = document.getElementById(
        'pagination-page-size'
      ) as HTMLElement;
      const paginationTitle = document.getElementById(
        'pagination-title'
      ) as HTMLElement;      
      const serverSideNetworkAdaptionTitle = document.getElementById(
          'server-side-network-adaption-title'
      ) as HTMLElement;

      if (this.usePriorityBasedDownlinkPolicy) {
        serverSideNetworkAdaption.style.display = 'block';
        paginationPageSize.style.display = 'block';
        paginationTitle.style.display = 'block';
        serverSideNetworkAdaptionTitle.style.display = 'block';
      } else {
        serverSideNetworkAdaption.style.display = 'none';
        paginationTitle.style.display = 'none';
        paginationPageSize.style.display = 'none';
        serverSideNetworkAdaptionTitle.style.display = 'none';
      }
    });

    const echoReductionCheckbox = (document.getElementById('echo-reduction-checkbox') as HTMLInputElement);
    (document.getElementById('webaudio') as HTMLInputElement).addEventListener('change', e => {
      this.enableWebAudio = (document.getElementById('webaudio') as HTMLInputElement).checked;
      if (this.enableWebAudio) {
        echoReductionCheckbox.style.display = 'block';
      } else {
        echoReductionCheckbox.style.display = 'none';
      }
    });

    const replicaMeetingInput = document.getElementById('replica-meeting-input');
    replicaMeetingInput.addEventListener('change', async _e => {
      (document.getElementById('primary-meeting-external-id') as HTMLInputElement).value = "";
    });

    this.getLocalElement<HTMLElement>('quick-join').addEventListener('click', e => {
      e.preventDefault();
      this.redirectFromAuthentication(true);
    });

    this.getLocalElement<HTMLFormElement>('form-authenticate').addEventListener('submit', e => {
      e.preventDefault();
      this.redirectFromAuthentication();
    });

    const earlyConnectCheckbox = document.getElementById('preconnect') as HTMLInputElement;
    earlyConnectCheckbox.checked = SHOULD_EARLY_CONNECT;
    earlyConnectCheckbox.onchange = () => {
      SHOULD_EARLY_CONNECT = !!earlyConnectCheckbox.checked;
    }

    const dieCheckbox = document.getElementById('die') as HTMLInputElement;
    dieCheckbox.checked = SHOULD_DIE_ON_FATALS;
    dieCheckbox.onchange = () => {
      SHOULD_DIE_ON_FATALS = !!dieCheckbox.checked;
    }

    const speechMonoCheckbox = document.getElementById(
        'fullband-speech-mono-quality'
    ) as HTMLInputElement;
    const musicMonoCheckbox = document.getElementById(
        'fullband-music-mono-quality'
    ) as HTMLInputElement;
    const musicStereoCheckbox = document.getElementById(
        'fullband-music-stereo-quality'
    ) as HTMLInputElement;
    speechMonoCheckbox.addEventListener('change', _e => {
      if (speechMonoCheckbox.checked) {
        musicMonoCheckbox.checked = false;
        musicStereoCheckbox.checked = false;
      }
    });
    musicMonoCheckbox.addEventListener('change', _e => {
      if (musicMonoCheckbox.checked) {
        speechMonoCheckbox.checked = false;
        musicStereoCheckbox.checked = false;
      }
    });
    musicStereoCheckbox.addEventListener('change', _e => {
      if (musicStereoCheckbox.checked) {
        speechMonoCheckbox.checked = false;
        musicMonoCheckbox.checked = false;
        this.usingStereoMusicAudioProfile = true;
      } else {
        this.usingStereoMusicAudioProfile = false;
      }
    });
/*
    document.getElementById('to-sip-flow').addEventListener('click', e => {
      e.preventDefault();
      this.switchToFlow('flow-sip-authenticate');
    });
    */

    document.getElementById('form-sip-authenticate').addEventListener('submit', e => {
      e.preventDefault();
      this.meeting = (document.getElementById('sip-inputMeeting') as HTMLInputElement).value;
      this.voiceConnectorId = (document.getElementById(
          'voiceConnectorId'
      ) as HTMLInputElement).value;

      AsyncScheduler.nextTick(
          async (): Promise<void> => {
            this.showProgress('progress-authenticate');
            const region = this.region || 'us-east-1';
            try {
              const response = await fetch(
                  `${ChimeContactComponent.BASE_URL}join?title=${encodeURIComponent(
                      this.meeting
                  )}&name=${encodeURIComponent(ChimeContactComponent.DID)}&region=${encodeURIComponent(
                      region
                  )}`,
                  {
                    method: 'POST',
                  }
              );
              const json = await response.json();
              const joinToken = json.JoinInfo.Attendee.Attendee.JoinToken;
              this.sipURI = `sip:${ChimeContactComponent.DID}@${this.voiceConnectorId};transport=tls;X-joinToken=${joinToken}`;
              this.switchToFlow('flow-sip-uri');
            } catch (error) {
              (document.getElementById(
                  'failed-meeting'
              ) as HTMLDivElement).innerText = `ID de reunión: ${this.meeting}`;
              (document.getElementById('failed-meeting-error') as HTMLDivElement).innerText =
                  error.message;
              this.switchToFlow('flow-failed-meeting');
              return;
            }
            const sipUriElement = document.getElementById('sip-uri') as HTMLInputElement;
            sipUriElement.value = this.sipURI;
            this.hideProgress('progress-authenticate');
          }
      );
    });

    if (!this.areVideoFiltersSupported()) {
      document.getElementById('video-input-filter-container').style.display = 'none';
    }

    let videoInputFilter = this.getLocalElement<HTMLInputElement>('video-input-filter');
    videoInputFilter.addEventListener('change', async () => {
      this.selectedVideoFilterItem = <VideoFilterName>videoInputFilter.value;
      this.log(`Clicking video filter: ${this.selectedVideoFilterItem}`);
      await this.openVideoInputFromSelection(this.selectedVideoInput, true)
    });

    // Bootstrap's JavaScript dropdown plugin is not loaded in this app. Keep
    // the picker usable with a small local menu controller instead of relying
    // on the data-bs-toggle attribute.
    const buttonVideoFilter = this.getLocalElement<HTMLButtonElement>('button-video-filter');
    const buttonVideoFilterDrop = this.getLocalElement<HTMLButtonElement>('button-video-filter-drop');
    const dropdownMenuFilter = this.getLocalElement<HTMLDivElement>('dropdown-menu-filter');
    const toggleVideoFilterMenu = (event: Event): void => {
      event.preventDefault();
      event.stopPropagation();
      this.toggleVideoFilterMenu();
    };
    buttonVideoFilter?.addEventListener('click', toggleVideoFilterMenu);
    buttonVideoFilterDrop?.addEventListener('click', toggleVideoFilterMenu);
    dropdownMenuFilter?.addEventListener('click', event => {
      const target = event.target as HTMLElement;
      if (target.closest('.dropdown-item')) {
        event.preventDefault();
        this.closeVideoFilterMenu();
      }
    });

    this.getLocalElement<HTMLElement>('copy-sip-uri').addEventListener('click', () => {
      const sipUriElement = this.getLocalElement<HTMLInputElement>('sip-uri');
      sipUriElement.select();
      document.execCommand('copy');
    });

    const audioInput = this.getLocalElement<HTMLSelectElement>('audio-input');
    audioInput.addEventListener('change', async (_ev: Event) => {
      this.log('audio input device is changed');
      await this.openAudioInputFromSelectionAndPreview();
    });

    const videoInput = this.getLocalElement<HTMLSelectElement>('video-input');
    videoInput.addEventListener('change', async (_ev: Event) => {
      this.log('video input device is changed');
      try {
        await this.openVideoInputFromSelection(videoInput.value, true);
      } catch (err) {
        fatal(err);
      }
    });

    const videoInputQuality = this.getLocalElement<HTMLSelectElement>('video-input-quality');
    videoInputQuality.addEventListener('change', async (_ev: Event) => {
      this.log('Video input quality is changed');
      switch (videoInputQuality.value) {
        case '360p':
          this.audioVideo.chooseVideoInputQuality(640, 360, 15);
          this.audioVideo.setVideoMaxBandwidthKbps(600);
          break;
        case '540p':
          this.audioVideo.chooseVideoInputQuality(960, 540, 15);
          this.audioVideo.setVideoMaxBandwidthKbps(1400);
          break;
        case '720p':
          this.audioVideo.chooseVideoInputQuality(1280, 720, 15);
          this.audioVideo.setVideoMaxBandwidthKbps(1500);
          break;
      }
      try {
        if (this.chosenVideoTransformDevice) {
          await this.chosenVideoTransformDevice.stop();
          this.chosenVideoTransformDevice = null;
        }
        await this.openVideoInputFromSelection(videoInput.value, true);
      } catch (err) {
        fatal(err);
      }
    });

    const audioOutput = this.getLocalElement<HTMLSelectElement>('audio-output');
    audioOutput.addEventListener('change', async (_ev: Event) => {
      this.log('audio output device is changed');
      await this.openAudioOutputFromSelection();
    });

    this.getLocalElement<HTMLElement>('button-test-sound').addEventListener('click', async e => {
      e.preventDefault();
      const audioOutput = this.getLocalElement<HTMLSelectElement>('audio-output');
      const testSound = new TestSound(this.meetingEventPOSTLogger, audioOutput.value);
      await testSound.init();
    });

    this.getLocalElement<HTMLFormElement>('form-devices').addEventListener('submit', e => {
      e.preventDefault();
      if (this.joiningMeeting) {
        return;
      }
      this.joiningMeeting = true;
      AsyncScheduler.nextTick(async () => {
        try {
          this.showProgress('progress-join');
          console.log('one');
          await this.stopAudioPreview();
          console.log('two');
          // Preserve the selected camera for a broadcaster. Passing null
          // disables video and leaves the live tile black.
          const selectedCamera = this.getLocalElement<HTMLSelectElement>('video-input').value;
          await this.openVideoInputFromSelection(
            this.isBroadcaster() ? selectedCamera : null,
            this.isBroadcaster()
          );
          console.log('three');
          // stopVideoProcessor should be called before join; it ensures that state variables and video processor stream are cleaned / removed before joining the meeting.
          // If stopVideoProcessor is not called then the state from preview screen will be carried into the in meeting experience and it will cause undesired side effects.
          await this.stopVideoProcessor();
          console.log('four');
          await this.join();
          console.log('five');
          if (this.isBroadcaster() && this.canStartLocalVideo) {
            this.audioVideo.startLocalVideoTile();
            this.toggleButton('button-camera', 'on');
          }
          this.hideProgress('progress-join');
          console.log('six');
          this.displayButtonStates();
          console.log('seven');
          this.switchToFlow('flow-meeting');
          console.log('eight');

        } catch (error) {
          this.joiningMeeting = false;
          this.hideProgress('progress-join');
          this.getLocalElement<HTMLElement>('failed-join').innerText = `ID de reunión: ${this.meeting}`;
          this.getLocalElement<HTMLElement>('failed-join-error').innerText = `Error: ${error.message}`;
        }
      });
    });

    (document.getElementById('add-voice-focus') as HTMLInputElement).addEventListener(
        'change',
        e => {
          this.enableVoiceFocus = (e.target as HTMLInputElement).checked;
          this.onVoiceFocusSettingChanged();
        }
    );

    const buttonMute = document.getElementById('button-microphone');
    buttonMute.addEventListener('click', _e => {
      this.toggleButton('button-microphone');
      if (this.isButtonOn('button-microphone')) {
        this.audioVideo.realtimeUnmuteLocalAudio();
      } else {
        this.audioVideo.realtimeMuteLocalAudio();
      }
    });

    const buttonCloudCapture = document.getElementById('button-record-cloud') as HTMLButtonElement;
    buttonCloudCapture.addEventListener('click', _e => {
      this.toggleButton('button-record-cloud');
    //  this.updateButtonVideoRecordingDrop()
      if (this.isButtonOn('button-record-cloud')) {
        AsyncScheduler.nextTick(async () => {
          buttonCloudCapture.disabled = true;
          await this.startMediaCapture();
          buttonCloudCapture.disabled = false;
        });
      } else {
        AsyncScheduler.nextTick(async () => {
          buttonCloudCapture.disabled = true;
          await this.stopMediaCapture();
          buttonCloudCapture.disabled = false;
        });
      }
    });

    const buttonLiveConnector = document.getElementById('button-live-connector') as HTMLButtonElement;
    buttonLiveConnector.addEventListener('click', _e => {
      this.toggleButton('button-live-connector');
      //this.updateButtonVideoRecordingDrop()
      if (this.isButtonOn('button-live-connector')) {
        AsyncScheduler.nextTick(async () => {
          buttonLiveConnector.disabled = true;
          const response = await this.startLiveConnector();
          const toastContainer = document.getElementById('toast-container');
          const toast = document.createElement('meeting-toast') as MeetingToast
          toastContainer.appendChild(toast);
          toast.message = "Playback URL: " + response.playBackUrl;
          toast.delay = "50000"
          toast.show();
          buttonLiveConnector.disabled = false;
        });
      } else {
        AsyncScheduler.nextTick(async () => {
          buttonLiveConnector.disabled = true;
          await this.stopLiveConnector();
          buttonLiveConnector.disabled = false;
        });
      }
    });

    const buttonRecordSelf = document.getElementById('button-record-self');
    let recorder: typeof MediaRecorder;
    buttonRecordSelf.addEventListener('click', _e => {
      const chunks: Blob[] = [];
      AsyncScheduler.nextTick(async () => {
        this.toggleButton('button-record-self');
        //this.updateButtonVideoRecordingDrop()
        if (!this.isButtonOn('button-record-self')) {
          console.info('Stopping recorder ', recorder);
          recorder.stop();
          recorder = undefined;
          return;
        }

        // Combine the audio and video streams.
        const mixed = new MediaStream();

        const localTile = this.audioVideo.getLocalVideoTile();
        if (localTile) {
          mixed.addTrack(localTile.state().boundVideoStream.getVideoTracks()[0]);
        }

        // We need to get access to the media stream broker, which requires knowing
        // the exact implementation. Sorry!
        /* @ts-ignore */
        const av: DefaultAudioVideoController = this.audioVideo.audioVideoController;
        const input = await av.mediaStreamBroker.acquireAudioInputStream();
        mixed.addTrack(input.getAudioTracks()[0]);

        recorder = new MediaRecorder(mixed, { mimeType: 'video/webm; codecs=h264' });
        console.info('Setting recorder to', recorder);
        recorder.ondataavailable = (event) => {
          if (event.data.size) {
            chunks.push(event.data);
          }
        };

        recorder.onstop = () => {
          const blob = new Blob(chunks, {
            type: 'video/webm',
          });
          chunks.length = 0;
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          /* @ts-ignore */
          a.style = 'display: none';
          a.href = url;
          a.download = 'recording.webm';
          a.click();
          window.URL.revokeObjectURL(url);
        };

        recorder.start();
      });
    });

    const buttonVideo = this.getLocalElement<HTMLButtonElement>('button-camera');

    buttonVideo.addEventListener('click', _e => {
      AsyncScheduler.nextTick(async () => {

        if (this.toggleButton('button-camera') === 'on' && this.canStartLocalVideo) {
          try {
            let camera: string | null = this.selectedVideoInput;
            if (camera === null || camera === 'None') {
              camera = this.cameraDeviceIds.length ? this.cameraDeviceIds[0] : null;
            }
            if (camera) {
              await this.openVideoInputFromSelection(camera, false);
            } else {
              // iOS can hide device IDs until camera permission is granted.
              // Selecting "None" here creates a black local video tile.
              const cameraStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user' } });
              try {
                await this.audioVideo.startVideoInput(cameraStream);
                this.selectedVideoInput = cameraStream.getVideoTracks()[0]?.getSettings().deviceId || null;
              } catch (error) {
                cameraStream.getTracks().forEach(track => track.stop());
                throw error;
              }
            }
            this.audioVideo.startLocalVideoTile();
            setTimeout(() => this.renderCallStageOverlay(), 0);
            if (this.isOneToOneCallSession && !this.videoCall && !this.videoUpgradeRequested && this.meeting) {
              try {
                await this.request.createRequestPost('iosCall', { action: 'request_video', meeting_id: this.meeting });
                this.videoUpgradeRequested = true;
              } catch (error) {
                console.warn('Could not notify the other participant about video:', error);
              }
            }
          } catch (err) {
            this.toggleButton('button-camera', 'off')
            this.showLocalCameraOffTile();
            fatal(err);
          }
        } else {
          await this.audioVideo.stopVideoInput();
          this.toggleButton('button-camera', 'off');
          this.showLocalCameraOffTile();
          this.renderCallStageOverlay();
        }
      });
    });

    const buttonSpeaker = this.getLocalElement<HTMLButtonElement>('button-speaker');
    buttonSpeaker.addEventListener('click', _e => {
      AsyncScheduler.nextTick(async () => {
        this.toggleButton('button-speaker');
        if (this.isButtonOn('button-speaker')) {
          try {
            await this.audioVideo.bindAudioElement(
                document.getElementById('meeting-audio') as HTMLAudioElement
            );
          } catch (e) {
            fatal(e);
            this.log('Failed to bindAudioElement', e);
          }
        } else {
          this.audioVideo.unbindAudioElement();
        }
      });
    });

    const buttonLiveTranscription = document.getElementById('button-live-transcription');
    
    //buttonLiveTranscription.addEventListener('click', () => {
      //this.transcriptContainerDiv.style.display = this.isButtonOn('button-live-transcription') ? 'none' : 'block';
      //this.toggleButton('button-live-transcription');
    //});

    //const buttonLiveTranscriptionModal = document.getElementById('button-live-transcription-modal-close');
    //buttonLiveTranscriptionModal.addEventListener('click', () => {
     // document.getElementById('live-transcription-modal').style.display = 'none';
    //});

    // show only languages available to selected transcription engine
    document.getElementsByName('transcription-engine').forEach(e => {
      e.addEventListener('change', () => {
        const engineTranscribeChecked = (document.getElementById('engine-transcribe') as HTMLInputElement).checked;
        const contentIdentificationChecked = (document.getElementById('content-identification-checkbox') as HTMLInputElement).checked;
        const contentRedactionChecked = (document.getElementById('content-redaction-checkbox') as HTMLInputElement).checked;
        document.getElementById('engine-transcribe-language').classList.toggle('hidden', !engineTranscribeChecked);
        document.getElementById('engine-transcribe-medical-language').classList.toggle('hidden', engineTranscribeChecked);
        document.getElementById('engine-transcribe-region').classList.toggle('hidden', !engineTranscribeChecked);
        document.getElementById('engine-transcribe-medical-region').classList.toggle('hidden', engineTranscribeChecked);
        document.getElementById('engine-transcribe-medical-content-identification').classList.toggle('hidden', engineTranscribeChecked);
        document.getElementById('engine-transcribe-language-identification').classList.toggle('hidden', !engineTranscribeChecked);
        document.getElementById('engine-transcribe-content-identification').classList.toggle('hidden', !engineTranscribeChecked);
        document.getElementById('engine-transcribe-redaction').classList.toggle('hidden', !engineTranscribeChecked);
        document.getElementById('engine-transcribe-partial-stabilization').classList.toggle('hidden', !engineTranscribeChecked);
        document.getElementById('engine-transcribe-custom-language-model').classList.toggle('hidden', !engineTranscribeChecked);
        if (!engineTranscribeChecked) {
          document.getElementById('transcribe-entity-types').classList.toggle('hidden', true);
        } else if (engineTranscribeChecked && (contentIdentificationChecked || contentRedactionChecked)) {
          document.getElementById('transcribe-entity-types').classList.toggle('hidden', false);
        }
      });
    });

    const languageIdentificationCb = document.getElementById('identify-language-checkbox') as HTMLInputElement;
    languageIdentificationCb.addEventListener('click', () => {
      (document.getElementById('button-start-transcription') as HTMLInputElement).disabled = languageIdentificationCb.checked;
      (document.getElementById('language-options').classList.toggle('hidden', !languageIdentificationCb.checked));
      (document.getElementById('preferred-language').classList.toggle('hidden', !languageIdentificationCb.checked));
      (document.getElementById('vocabulary-names').classList.toggle('hidden', !languageIdentificationCb.checked));
      (document.getElementById('vocabulary-filter-names').classList.toggle('hidden', !languageIdentificationCb.checked));
      (document.getElementById('transcribe-language') as HTMLInputElement).disabled = languageIdentificationCb.checked;
      (document.getElementById('content-identification-checkbox') as HTMLInputElement).disabled = languageIdentificationCb.checked;
      (document.getElementById('content-redaction-checkbox') as HTMLInputElement).disabled = languageIdentificationCb.checked;
      (document.getElementById('custom-language-model-checkbox') as HTMLInputElement).disabled = languageIdentificationCb.checked;
      (document.getElementById('transcribe-entity') as HTMLInputElement).disabled = languageIdentificationCb.checked;
      (document.getElementById('language-model-input-text') as HTMLInputElement).disabled = languageIdentificationCb.checked;
    });

    const languageOptionsDropDown = document.getElementById('language-options') as HTMLInputElement;
    languageOptionsDropDown.addEventListener('change', (event => languageOptionsDropDownClickHandler(event)));

    const contentIdentificationCb = document.getElementById('content-identification-checkbox') as HTMLInputElement;
    contentIdentificationCb.addEventListener('click', () => {
      (document.getElementById('content-redaction-checkbox') as HTMLInputElement).disabled = contentIdentificationCb.checked;
      (document.getElementById('transcribe-entity-types') as HTMLInputElement).classList.toggle('hidden', !contentIdentificationCb.checked);
    });

    const contentRedactionCb = document.getElementById('content-redaction-checkbox') as HTMLInputElement;
    contentRedactionCb.addEventListener('click', () => {
      (document.getElementById('content-identification-checkbox') as HTMLInputElement).disabled = contentRedactionCb.checked;
      (document.getElementById('transcribe-entity-types') as HTMLInputElement).classList.toggle('hidden', !contentRedactionCb.checked);
    });

    const partialResultsStabilityCb = document.getElementById('partial-stabilization-checkbox') as HTMLInputElement;
    partialResultsStabilityCb.addEventListener('click', () => {
      (document.getElementById('transcribe-partial-stability').classList.toggle('hidden', !partialResultsStabilityCb.checked));
    });

    const languageModelCb = document.getElementById('custom-language-model-checkbox') as HTMLInputElement;
    languageModelCb.addEventListener('click', () => {
      (document.getElementById('language-model').classList.toggle('hidden', !languageModelCb.checked));
    });

    const buttonStartTranscription = document.getElementById('button-start-transcription');
    buttonStartTranscription.addEventListener('click', async () => {
      let engine = '';
      let languageCode = '';
      let region = '';
      const transcriptionStreamParams: TranscriptionStreamParams = {};
      if ((document.getElementById('engine-transcribe') as HTMLInputElement).checked) {
        engine = 'transcribe';
        region = (document.getElementById('transcribe-region') as HTMLInputElement).value;

        if (!isChecked('identify-language-checkbox')) {
          languageCode = (document.getElementById('transcribe-language') as HTMLInputElement).value;

          if (isChecked('content-identification-checkbox')) {
            transcriptionStreamParams.contentIdentificationType = 'PII';
          }

          if (isChecked('content-redaction-checkbox')) {
            transcriptionStreamParams.contentRedactionType = 'PII';
          }

          if (isChecked('content-identification-checkbox') || isChecked('content-redaction-checkbox')) {
            let piiEntityTypes = getSelectedValues('#transcribe-entity');
            if (piiEntityTypes !== '') {
              transcriptionStreamParams.piiEntityTypes = piiEntityTypes;
            }
          }

          if (isChecked('custom-language-model-checkbox')) {
            let languageModelName = (document.getElementById('language-model-input-text') as HTMLInputElement).value;
            if (languageModelName) {
              transcriptionStreamParams.languageModelName = languageModelName;
            }
          }
        }

        if (isChecked('identify-language-checkbox')) {
          transcriptionStreamParams.identifyLanguage = true;
          const languageOptionsSelected = getSelectedValues('#language-options');
          if (languageOptionsSelected !== '') {
            transcriptionStreamParams.languageOptions = languageOptionsSelected;
          }

          const preferredLanguageSelected = (document.getElementById('preferred-language-selection') as HTMLInputElement).value;
          if (preferredLanguageSelected) {
            transcriptionStreamParams.preferredLanguage = preferredLanguageSelected;
          }

          const vocabularyNames = (document.getElementById('vocabulary-names-input-text') as HTMLInputElement).value;
          if (vocabularyNames) {
            transcriptionStreamParams.vocabularyNames = vocabularyNames;
          }

          const vocabularyFilterNames = (document.getElementById('vocabulary-filter-names-input-text') as HTMLInputElement).value;
          if (vocabularyFilterNames) {
            transcriptionStreamParams.vocabularyFilterNames = vocabularyFilterNames;
          }
        }

        if (isChecked('partial-stabilization-checkbox')) {
          transcriptionStreamParams.enablePartialResultsStability = true;
        }

        let partialResultsStability = (document.getElementById('partial-stability') as HTMLInputElement).value;
        if (partialResultsStability) {
          transcriptionStreamParams.partialResultsStability = partialResultsStability;
        }
      } else if ((document.getElementById('engine-transcribe-medical') as HTMLInputElement).checked) {
        engine = 'transcribe_medical';
        languageCode = (document.getElementById('transcribe-medical-language') as HTMLInputElement).value;
        region = (document.getElementById('transcribe-medical-region') as HTMLInputElement).value;
        if (isChecked('medical-content-identification-checkbox')) {
          transcriptionStreamParams.contentIdentificationType = 'PHI';
        }
      } else {
        throw new Error('Unknown transcription engine');
      }
      await startLiveTranscription(engine, languageCode, region, transcriptionStreamParams);
    });

    function isChecked(id: string): boolean {
      return (document.getElementById(id) as HTMLInputElement).checked;
    }

    // fetches checked values of the list from given selector id
    function getSelectedValues(id: string): string {
      let selectors = id + ' ' + 'option:checked';
      const selectedValues = document.querySelectorAll(selectors);
      let values = '';
      if (selectedValues.length > 0) {
        values = Array.from(selectedValues).filter(node => (node as HTMLInputElement).value !== '').map(el => (el as HTMLInputElement).value).join(',');
      }
      return values;
    }

    function createErrorSpan(message: string): void {
      let languageOptionsErrorSpan = document.createElement('span');
      languageOptionsErrorSpan.innerText = message;
      languageOptionsErrorSpan.classList.add('error-message-color');
      document.getElementById('language-options-error-message').appendChild(languageOptionsErrorSpan);
      (document.getElementById('button-start-transcription') as HTMLInputElement).disabled = true;
    }

    // callback to restrict users from selecting multiple language variant (locale) per language code
    // e.g. en-US and en-AU as language options cannot be selected for the same transcription
    // Details in https://docs.aws.amazon.com/transcribe/latest/dg/lang-id-stream.html
    function languageOptionsDropDownClickHandler(event: Event): boolean {
      let languageGroupSet = new Set();
      document.getElementById('language-options-error-message').innerHTML = '';
      const languageOptionsSelected = document.querySelectorAll('#language-options option:checked');

      const languageOptionsPreviewSpan = document.getElementById("language-options-selected-options");
      const languageString = languageOptionsSelected.length === 0 ? "None" : Array.from(languageOptionsSelected).map((node: HTMLSelectElement) => node.value).join(",").trim();
      languageOptionsPreviewSpan.innerText = languageString;

      let preferredLanguageDropDown = document.getElementById('preferred-language-selection');
      if (preferredLanguageDropDown.hasChildNodes) {
        let options = (preferredLanguageDropDown as HTMLSelectElement).options;
        for (let i = options.length - 1; i >= 0; i--) {
          if (options[i].value.length > 0) {
            preferredLanguageDropDown.removeChild(options[i]);
          }
        }
      }

      for (let i = languageOptionsSelected.length - 1; i >= 0; i--) {
        let currentItem = languageOptionsSelected.item(i) as HTMLSelectElement;
        if (languageGroupSet.has(currentItem.parentElement.id)) {
          createErrorSpan('Please select one language per group');
          return false;
        }
        languageGroupSet.add(currentItem.parentElement.id);
        let selectedValue = currentItem.value;
        let option = document.createElement('option');
        option.value = selectedValue;
        option.text = currentItem.innerText;
        document.getElementById('preferred-language-selection').appendChild(option);
      }

      if (languageOptionsSelected.length < 2) {
        createErrorSpan('Please select at least 2 language options');
        return false;
      } else if (languageOptionsSelected.length >= 2) {
        (document.getElementById('button-start-transcription') as HTMLInputElement).disabled = false;
      }
    }
    const startLiveTranscription = async (engine: string, languageCode: string, region: string, transcriptionStreamParams: TranscriptionStreamParams) => {
      const transcriptionAdditionalParams = JSON.stringify(transcriptionStreamParams);
      const response = await fetch(`${ChimeContactComponent.BASE_URL}start_transcription?title=${encodeURIComponent(this.meeting)}&engine=${encodeURIComponent(engine)}&language=${encodeURIComponent(languageCode)}&region=${encodeURIComponent(region)}&transcriptionStreamParams=${encodeURIComponent(transcriptionAdditionalParams)}`, {
        method: 'POST',
      });
      const json = await response.json();
      if (json.error) {
        throw new Error(`Server error: ${json.error}`);
      }
      document.getElementById('live-transcription-modal').style.display = 'none';
    };

    const buttonVideoStats = this.getLocalElement<HTMLButtonElement>('button-video-stats');
    buttonVideoStats.addEventListener('click', () => {
      // In public Lives this control is the share-link action. The template
      // keeps the legacy ID for SDK stats compatibility, so do not also
      // toggle the stats panel when the link is being copied.
      if (this.isPublication) {
        return;
      }
      if (this.isButtonOn('button-video-stats')) {
        this.showStats=false;
        document.querySelectorAll('.stats-info').forEach(e => e.remove());
      } else {
        this.showStats=true;
        this.getRelayProtocol();
      }
      this.toggleButton('button-video-stats');
    });

    const buttonPromoteToPrimary = document.getElementById('button-promote-to-primary');
    buttonPromoteToPrimary.addEventListener('click', async () => {
      if (!this.isButtonOn('button-promote-to-primary')) {
        await this.promoteToPrimaryMeeting();
      } else {
        this.meetingLogger.info("Demoting from primary meeting");
        if (this.deleteOwnAttendeeToLeave) {
          this.deleteAttendee(this.primaryExternalMeetingId, this.primaryMeetingSessionCredentials?.attendeeId);
        } else {
          this.audioVideo.demoteFromPrimaryMeeting()
        }
        // `audioVideoWasDemotedFromPrimaryMeeting` will adjust UX
      }
    });

    const sendMessage = (): void => {
      AsyncScheduler.nextTick(() => {
        const textArea = this.getLocalElement<HTMLTextAreaElement>('send-message');
        const textToSend = textArea.value.trim();
        if (!textToSend) {
          return;
        }
        textArea.value = '';
        this.sendMessage(textToSend);
      });
    };

    const textAreaSendMessage = this.getLocalElement<HTMLTextAreaElement>('send-message');
    textAreaSendMessage.addEventListener('keydown', e => {
      if (e.keyCode === 13) {
        if (e.shiftKey) {
          textAreaSendMessage.rows++;
        } else {
          e.preventDefault();
          sendMessage();
          textAreaSendMessage.rows = 1;
        }
      }
    });

    const buttonMeetingEnd = this.getLocalElement<HTMLButtonElement>('button-meeting-end');
    buttonMeetingEnd?.addEventListener('click', _e => {
   

      Swal2.fire({
        title: 'End meeting',
        text: `Are you sure you want to end the meeting?`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes, end',
        cancelButtonText: 'Cancel',
        color: '#ffffff',
        background: '#010f4e',
        position: 'top-end',
        timerProgressBar: true,
        toast: true,
      }).then((result) => {
        if (result.isConfirmed) {
        const confirmEnd = new URL(window.location.href).searchParams.get('confirm-end') === 'true';
      const prompt =
          'Are you sure you want to end the meeting for everyone? The meeting cannot be used after ending it.';
      if (confirmEnd && !window.confirm(prompt)) {
        return;
      }
      AsyncScheduler.nextTick(async () => {
        buttonMeetingEnd.disabled = true;
        try {
          await this.endMeeting();
          await this.leave();
        } finally {
          buttonMeetingEnd.disabled = false;
        }
      });
    }
      });
    });
  

    const buttonMeetingLeave = this.getLocalElement<HTMLButtonElement>('button-meeting-leave');
    buttonMeetingLeave?.addEventListener('click', e => {
      Swal2.fire({
        title: 'Leave meeting',
        text: `Are you sure you want to leave the meeting?`,
        icon: 'info',
        showCancelButton: true,
        confirmButtonText: 'Yes, exit',
        cancelButtonText: 'Cancel',
        color: '#ffffff',
        background: '#010f4e',
          position: 'top-end',
          timerProgressBar: true,
          toast: true,
      }).then((result) => {
        if (result.isConfirmed) {
        // Call your desired function here
        if (e.shiftKey) {
          this.behaviorAfterLeave = 'halt';
        };
        AsyncScheduler.nextTick(async () => {
          buttonMeetingLeave.disabled = true;
          try {
            await this.leave();
          } finally {
            buttonMeetingLeave.disabled = false;
          }
        });
        }
      });
    
    });
  }

  logAudioStreamPPS(clientMetricReport: ClientMetricReport) {
    const { currentTimestampMs, previousTimestampMs } = clientMetricReport;
    const deltaTime = currentTimestampMs - previousTimestampMs;
    const rtcStatsReport = clientMetricReport.getRTCStatsReport();

    let overage = 0; // Initialize the overage count outside the loop
    rtcStatsReport.forEach(report => {
      if (report.type === 'outbound-rtp' && report.kind === 'audio') {
        // Skip initial metric.
        if (report.packetsSent === 0 && previousTimestampMs === 0) return;

        const deltaPackets = report.packetsSent - this.lastPacketsSent;
        const pps = (1000 * deltaPackets) / deltaTime;

        //let overage = 0;
        if ((pps > 57) || (pps < 39)) {
          console.error('PPS:', pps, `(${++overage})`);
        } else {
          overage = 0;
          console.debug('PPS:', pps);
        }
        this.lastPacketsSent = report.packetsSent;
      }
    });
  }

  getSupportedMediaRegions(): string[] {
    const supportedMediaRegions: string[] = [];
    const mediaRegion = this.getLocalElement<HTMLSelectElement>('inputRegion');
    for (let i = 0; i < mediaRegion.length; i++) {
      supportedMediaRegions.push(mediaRegion.value);
    }
    return supportedMediaRegions;
  }

  async getNearestMediaRegion(): Promise<string> {
    const nearestMediaRegionResponse = await fetch(`https://nearest-media-region.l.chime.aws`, {
      method: 'GET',
    });
    const nearestMediaRegionJSON = await nearestMediaRegionResponse.json();
    const nearestMediaRegion = nearestMediaRegionJSON.region;
    return nearestMediaRegion;
  }

  setMediaRegion(): void {
    AsyncScheduler.nextTick(
        async (): Promise<void> => {
          try {
            const query = new URLSearchParams(document.location.search);
            const region = query.get('region');
            const nearestMediaRegion = region ? region : await this.getNearestMediaRegion();
            if (nearestMediaRegion === '' || nearestMediaRegion === null) {
              throw new Error('Nearest Media Region cannot be null or empty');
            }
            const supportedMediaRegions: string[] = this.getSupportedMediaRegions();
            if (supportedMediaRegions.indexOf(nearestMediaRegion) === -1) {
              supportedMediaRegions.push(nearestMediaRegion);
              const mediaRegionElement = this.getLocalElement<HTMLSelectElement>('inputRegion');
              const newMediaRegionOption = document.createElement('option');
              newMediaRegionOption.value = nearestMediaRegion;
              newMediaRegionOption.text = nearestMediaRegion + ' (' + nearestMediaRegion + ')';
              mediaRegionElement.add(newMediaRegionOption, null);
            }
            this.getLocalElement<HTMLSelectElement>('inputRegion').value = nearestMediaRegion;
          } catch (error) {
            fatal(error);
            this.log('Default media region selected: ' + error.message);
          }
        }
    );
  }

  async promoteToPrimaryMeeting() {
    this.meetingLogger.info("Attempting to promote self to primary meeting from replica");

    if (this.primaryMeetingSessionCredentials === undefined) {
      this.primaryMeetingSessionCredentials = await this.getPrimaryMeetingCredentials();
    }
    await this.audioVideo.promoteToPrimaryMeeting(this.primaryMeetingSessionCredentials)
        .then((status) => {
          const toastContainer = document.getElementById('toast-container');
          const toast = document.createElement('meeting-toast') as MeetingToast
          toastContainer.appendChild(toast);
          if (status.isFailure()) {
            toast.message = ` Failed to promote to primary meeting due to error: ${status.toString()}`;
            toast.addButton('Retry', () => { this.promoteToPrimaryMeeting() });
          } else {
            toast.message = `Successfully promoted to primary meeting`;
            this.updateUXForReplicaMeetingPromotionState('promoted');
          }
          toast.show();
        })
  }
  public sendMessageFunction() {
    const textArea = this.getLocalElement<HTMLTextAreaElement>('send-message');
    const textToSend = textArea.value.trim();
    if (!textToSend) {
      return;
    }
    textArea.value = '';

    // Call the sendMessage function with the textToSend
    this.sendMessage(textToSend);
  }
  
  public sendMessage(textToSend: string): void {
    AsyncScheduler.nextTick(() => {
      if (!textToSend) {
        return;
      }

      if (!this.isSystemDataMessage(textToSend)) {
        this.incrementCommentCounter();
        if (this.isPublication) {
          void this.fetchCounter('comentario', 'add');
        }
      }
  
      this.audioVideo.realtimeSendDataMessage(
        ChimeContactComponent.DATA_MESSAGE_TOPIC,
        textToSend,
        ChimeContactComponent.DATA_MESSAGE_LIFETIME_MS
      );
  
      // echo the message to the handler
      this.dataMessageHandler(
        new DataMessage(
          Date.now(),
          ChimeContactComponent.DATA_MESSAGE_TOPIC,
          new TextEncoder().encode(textToSend),
          this.meetingSession.configuration.credentials.attendeeId,
          this.meetingSession.configuration.credentials.externalUserId
        )
      );
    });
  }
  
  
  private async getPrimaryMeetingCredentials(): Promise<MeetingSessionCredentials> {
    // Use the same join endpoint, but point it to the provided primary meeting title and give us an arbitrarily different user name
    const joinInfo = (await this.sendJoinRequest(this.primaryExternalMeetingId, `promoted-${this.name}`, this.region)).JoinInfo;
    // To avoid duplicating code we reuse the constructor for `MeetingSessionConfiguration` which contains `MeetingSessionCredentials`
    // within it and properly does the parsing of the `chime::CreateAttendee` response
    const configuration = new MeetingSessionConfiguration(joinInfo.Meeting, joinInfo.Attendee);
    return configuration.credentials;
  }

  updateUXForViewOnlyMode() {
    for (const button in this.buttonStates) {
      if (button === 'button-speaker' || button === 'button-video-stats' || button === 'button-live-transcription') {
        continue;
      }
      this.toggleButton(button, 'disabled');
    }

    // Mute since we use dummy audio
    this.audioVideo.realtimeMuteLocalAudio();
  }

  updateUXForReplicaMeetingPromotionState(promotedState: 'promoted' | 'demoted') {
    const isPromoted = promotedState === 'promoted'

    // Enable/disable buttons as appropriate
    for (const button in this.buttonStates) {
      if (button === 'button-speaker' || button === 'button-video-stats' || button === 'button-live-transcription') {
        continue;
      }

      if (button === 'button-promote-to-primary') {
        // Don't disable promotion button
        this.meetingLogger.info(`promote button ${isPromoted ? 'on' : 'off'}`)
        this.toggleButton(button, isPromoted ? 'on' : 'off');
        continue;
      }

      this.toggleButton(button, isPromoted ? 'off' : 'disabled');
    }

    // Additionally mute audio so it's not in an unexpected state when demoted
    if (!isPromoted) {
      this.audioVideo.realtimeMuteLocalAudio();
    }
  }

  setButtonVisibility(button: string, visible: boolean, state?: ButtonState) {
    const element = document.getElementById(button);
    element.style.display = visible ? 'inline-block' : 'none';
    this.toggleButton(button, state);
  }

  toggleButton(button: string, state?: ButtonState): ButtonState {
    if (state) {
      this.buttonStates[button] = state;
    } else if (this.buttonStates[button] === 'on') {
      this.buttonStates[button] = 'off';
    } else {
      this.buttonStates[button] = 'on';
    }
    this.displayButtonStates();
    return this.buttonStates[button];
  }

  isButtonOn(button: string): boolean {
    return this.buttonStates[button] === 'on';
  }
/*
  updateButtonVideoRecordingDrop(): void {
    if (this.buttonStates['button-record-self'] === 'on' || this.buttonStates['button-record-cloud'] === 'on'  || this.buttonStates['button-live-connector'] === 'on') {
      this.buttonStates['button-video-recording-drop'] = 'on';
    } else if (this.buttonStates['button-record-self'] === 'off' && this.buttonStates['button-record-cloud'] === 'off' && this.buttonStates['button-live-connector'] === 'off') {
      this.buttonStates['button-video-recording-drop'] = 'off';
    }
    this.displayButtonStates()
  }
*/
  displayButtonStates(): void {
    for (const button in this.buttonStates) {
      const element = this.getLocalElement<HTMLButtonElement>(button);
      const drop = this.getLocalElement<HTMLButtonElement>(`${button}-drop`);
      if (!element) continue;
      const on = this.isButtonOn(button);
      if (button === 'button-camera') element.setAttribute('aria-pressed', String(on));
      element.classList.add(on ? 'btn-success' : 'btn-outline-secondary');
      element.classList.remove(on ? 'btn-outline-secondary' : 'btn-success');
      const iconElement = element.firstElementChild as HTMLElement; if (iconElement) { 
        console.log('falta agergar las clases de estilos de los icons activo e inactivo')
        //iconElement.classList.add(on ? 'ion-icon-active' : 'ion-icon-inactive'); 
        //iconElement.classList.remove(on ? 'ion-icon-inactive' : 'ion-icon-active');
      }
      if (this.buttonStates[button] === 'disabled') {
        element.setAttribute('disabled', '');
      } else {
        element.removeAttribute('disabled');
      }
      if (drop) {
        drop.classList.add(on ? 'btn-success' : 'btn-outline-secondary');
        drop.classList.remove(on ? 'btn-outline-secondary' : 'btn-success');
        if (this.buttonStates[button] === 'disabled') {
          drop.setAttribute('disabled', '');
        } else {
          drop.removeAttribute('disabled');
        }
      }
      const mediaControl = button === 'button-microphone' || button === 'button-camera' || button === 'button-speaker';
      if (mediaControl) {
        const stateText = on ? 'activado' : 'desactivado';
        const controlName = button === 'button-microphone' ? 'Micrófono' : button === 'button-camera' ? 'Cámara' : 'Audio';
        element.classList.toggle('call-control-active', on);
        element.classList.toggle('call-control-inactive', !on);
        element.setAttribute('aria-pressed', String(on));
        element.setAttribute('aria-label', `${controlName} ${stateText}`);
        element.title = `${controlName} ${stateText}`;
        if (drop) drop.title = `Seleccionar ${controlName.toLowerCase()}`;
        const icon = element.querySelector('ion-icon');
        if (icon) {
          const iconNames: Record<string, [string, string]> = {
            'button-microphone': ['mic', 'mic-off'],
            'button-camera': ['videocam-sharp', 'videocam-off-sharp'],
            'button-speaker': ['volume-high-sharp', 'volume-mute-sharp'],
          };
          icon.setAttribute('name', on ? iconNames[button][0] : iconNames[button][1]);
        }
      }
    }
  }

  private refreshNoVideoPlaceholder(): void {
    this.ngZone.run(() => {
      this.showNoVideoPlaceholder = this.callParticipants.length === 0;
      this.noVideoDisplayName = this.name || this.username || 'Esperando participantes';
    });
  }

  private upsertCallParticipant(attendeeId: string, name: string, isLocal = false, hasVideo?: boolean): void {
    if (!attendeeId) return;
    this.ngZone.run(() => {
      const existing = this.callParticipants.find(participant => participant.attendeeId === attendeeId);
      if (existing) {
        existing.name = isLocal ? 'You' : (name || existing.name);
        existing.isLocal = isLocal;
        if (hasVideo !== undefined) existing.hasVideo = hasVideo;
      } else {
        this.callParticipants.push({
          attendeeId,
          name: isLocal ? 'You' : (name || 'Participant'),
          isLocal,
          hasVideo: hasVideo === true,
        });
      }
      this.callParticipants.sort((left, right) => Number(left.isLocal) - Number(right.isLocal));
      this.showNoVideoPlaceholder = this.callParticipants.length === 0;
      setTimeout(() => this.videoTileCollection?.refreshParticipantLayout(), 0);
    });
    this.renderCallStageOverlay();
  }

  private removeCallParticipant(attendeeId: string): void {
    this.ngZone.run(() => {
      this.callParticipants = this.callParticipants.filter(participant => participant.attendeeId !== attendeeId);
      this.showNoVideoPlaceholder = this.callParticipants.length === 0;
      setTimeout(() => this.videoTileCollection?.refreshParticipantLayout(), 0);
    });
    this.renderCallStageOverlay();
  }

  private showLocalCameraOffTile(): void {
    this.upsertCallParticipant('local', 'You', true, false);
    this.videoTileCollection?.setLocalVideoEnabled(false);
    this.renderCallStageOverlay();
  }

  videoTileDidUpdate(tileState: any): void {
    const tileId = Number(tileState?.tileId);
    if (!Number.isFinite(tileId)) return;
    const remoteTile = tileState.localTile !== true;
    const remoteName = tileState.boundExternalUserId?.split('#').slice(-1)[0];
    const participantId = tileState.localTile ? 'local' : tileState.boundAttendeeId;
    if (remoteTile && (!participantId || !this.presentRemoteAttendees.has(participantId))) return;
    const hasActiveVideo = (tileState.boundVideoStream?.getVideoTracks?.() || [])
      .some((track: MediaStreamTrack) => track.readyState !== 'ended' && track.enabled);
    const participantName = tileState.localTile
      ? 'You'
      : (remoteName || this.remoteParticipantNames.get(participantId) || 'Participant');
    this.videoTileAttendeeIds.set(tileId, participantId);
    this.upsertCallParticipant(
      participantId,
      participantName,
      !remoteTile,
      hasActiveVideo,
    );
    // The collection is registered as a second Chime observer; let its
    // videoTileDidUpdate populate tileIdToTileIndex before writing the label.
    setTimeout(() => this.videoTileCollection?.setParticipantName(tileId, participantName), 0);
    if (remoteTile && remoteName && tileState.boundAttendeeId) {
      this.remoteParticipantNames.set(tileState.boundAttendeeId, remoteName);
    }
    this.refreshNoVideoPlaceholder();
    this.renderCallStageOverlay();
  }

  videoTileWasRemoved(tileId: number): void {
    const attendeeId = this.videoTileAttendeeIds.get(tileId);
    this.videoTileAttendeeIds.delete(tileId);
    if (attendeeId && !Array.from(this.videoTileAttendeeIds.values()).includes(attendeeId)) {
      const participant = this.callParticipants.find(value => value.attendeeId === attendeeId);
      if (participant) this.upsertCallParticipant(attendeeId, participant.name, participant.isLocal, false);
    }
    this.refreshNoVideoPlaceholder();
    this.renderCallStageOverlay();
  }

  showProgress(id: string): void {
    this.getLocalElement<HTMLDivElement>(id).style.visibility = 'visible';
  }

  hideProgress(id: string): void {
    this.getLocalElement<HTMLDivElement>(id).style.visibility = 'hidden';
  }

  switchToFlow(flow: string): void {
    Array.from(this.getLocalElementsByClassName('flow')).map(
        e => ((e as HTMLDivElement).style.display = 'none')
    );
    this.getLocalElement<HTMLDivElement>(flow).style.display = 'block';
    if (flow === 'flow-meeting') {
      requestAnimationFrame(() => this.renderCallStageOverlay());
    }
    if (flow === 'flow-meeting') {
      // Fallback cards are Angular-rendered while Chime video tiles are
      // appended imperatively. Recalculate after both are in the DOM so the
      // initial call layout does not depend on a later camera toggle.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => this.videoTileCollection?.refreshParticipantLayout());
      });
    }
  }

  async onAudioInputsChanged(freshDevices: MediaDeviceInfo[]): Promise<void> {
    await this.populateAudioInputList();

    if (!this.currentAudioInputDevice) {
      return;
    }

    if (this.currentAudioInputDevice === 'default') {
      // The default device might actually have changed. Go ahead and trigger a
      // reselection.
      this.log('Reselecting default device.');
      await this.selectAudioInputDevice(this.currentAudioInputDevice);
      return;
    }

    const freshDeviceWithSameID = freshDevices.find(
        device => device.deviceId === this.currentAudioInputDevice
    );

    if (freshDeviceWithSameID === undefined) {
      this.log('Existing device disappeared. Selecting a new one.');

      // Select a new device.
      await this.openAudioInputFromSelectionAndPreview();
    }
  }

  audioInputMuteStateChanged(device: string | MediaStream, muted: boolean): void {
    this.log('Mute state: device', device, muted ? 'is muted' : 'is not muted');
  }

  audioInputsChanged(freshAudioInputDeviceList: MediaDeviceInfo[]): void {
    this.onAudioInputsChanged(freshAudioInputDeviceList);
  }

  videoInputsChanged(_freshVideoInputDeviceList: MediaDeviceInfo[]): void {
    this.populateVideoInputList();
  }

  audioOutputsChanged(_freshAudioOutputDeviceList: MediaDeviceInfo[]): void {
    this.populateAudioOutputList();
  }

  audioInputStreamEnded(deviceId: string): void {
    this.log(`Current audio input stream from device id ${deviceId} ended.`);
  }

  videoInputStreamEnded(deviceId: string): void {
    this.log(`Current video input stream from device id ${deviceId} ended.`);
    if (this.buttonStates['button-camera'] === 'on') { // Video input is ended, update button state
      this.buttonStates['button-camera'] = 'off';
      this.displayButtonStates();
      this.showLocalCameraOffTile();
    }
  }

  metricsDidReceive(clientMetricReport: ClientMetricReport): void {
    this.logAudioStreamPPS(clientMetricReport);
    const metricReport = clientMetricReport.getObservableMetrics();
    this.videoMetricReport = clientMetricReport.getObservableVideoMetrics();
    this.displayEstimatedUplinkBandwidth(metricReport.availableOutgoingBitrate);
    this.displayEstimatedDownlinkBandwidth(metricReport.availableIncomingBitrate);

    this.isButtonOn('button-video-stats') && this.videoTileCollection.showVideoWebRTCStats(this.videoMetricReport);
  }

  displayEstimatedUplinkBandwidth(bitrate: number) {
    const value = `Available Uplink Bandwidth: ${bitrate ? bitrate / 1000 : 'Unknown'} Kbps`;
    const videoUplinkElement = document.getElementById('video-uplink-bandwidth') as HTMLDivElement;
    const mobileVideoUplinkElement = document.getElementById('mobile-video-uplink-bandwidth') as HTMLDivElement;
    
    if (videoUplinkElement) {
      videoUplinkElement.innerText = value;
    }
    
    if (mobileVideoUplinkElement) {
      mobileVideoUplinkElement.innerText = value;
    }
  }
  

  displayEstimatedDownlinkBandwidth(bitrate: number) {
    const value = `Available Downlink Bandwidth: ${bitrate ? bitrate / 1000 : 'Unknown'} Kbps`;
    const videoDownlinkElement = document.getElementById('video-downlink-bandwidth') as HTMLDivElement;
    const mobileVideoDownlinkElement = document.getElementById('mobile-video-downlink-bandwidth') as HTMLDivElement;
  
    if (videoDownlinkElement) {
      videoDownlinkElement.innerText = value;
    }
  
    if (mobileVideoDownlinkElement) {
      mobileVideoDownlinkElement.innerText = value;
    }
  }
  
  resetStats = (): void => {
    this.videoMetricReport = {};
  };

  async getRelayProtocol(): Promise<void> {
    const rawStats = await this.audioVideo.getRTCPeerConnectionStats();
    if (rawStats) {
      rawStats.forEach(report => {
        if (report.type === 'local-candidate') {
          this.log(`Local WebRTC Ice Candidate stats: ${JSON.stringify(report)}`);
          const relayProtocol = report.relayProtocol;
          if (typeof relayProtocol === 'string') {
            if (relayProtocol === 'udp') {
              this.log(`Connection using ${relayProtocol.toUpperCase()} protocol`);
            } else {
              this.log(`Connection fell back to ${relayProtocol.toUpperCase()} protocol`);
            }
          }
        }
      });
    }
  }

  async createLogStream(
      configuration: MeetingSessionConfiguration,
      pathname: string
  ): Promise<void> {
    const body = JSON.stringify({
      meetingId: configuration.meetingId,
      attendeeId: configuration.credentials.attendeeId,
    });
 
    try {
      const response = await fetch(`${ChimeContactComponent.BASE_URL}${pathname}`, {
        method: 'POST',
        body,
      });
      if (response.status === 200) {
        console.log('[DEMO] log stream created');
      }
    } catch (error) {
      fatal(error);
      this.log(error.message);
    }
  }

  eventDidReceive(name: EventName, attributes: EventAttributes): void {
    this.log(`Received an event: ${JSON.stringify({ name, attributes })}`);
    const { meetingHistory, ...otherAttributes } = attributes;
    switch (name) {
      case 'meetingStartRequested':
      case 'meetingStartSucceeded':
      case 'meetingEnded':
      case 'audioInputSelected':
      case 'videoInputSelected':
      case 'audioInputUnselected':
      case 'videoInputUnselected':
      case 'meetingReconnected':
      case 'receivingAudioDropped':
      case 'signalingDropped':
      case 'sendingAudioFailed':
      case 'sendingAudioRecovered':
      case 'attendeePresenceReceived': {
        // Exclude the "meetingHistory" attribute for successful -> published events.
        this.meetingEventPOSTLogger?.info(
            JSON.stringify({
              name,
              attributes: otherAttributes,
            })
        );
        break;
      }
      case 'audioInputFailed':
      case 'videoInputFailed':
      case 'meetingStartFailed':
      case 'meetingFailed': {
        // Send the last 5 minutes of events.
        this.meetingEventPOSTLogger?.info(
            JSON.stringify({
              name,
              attributes: {
                ...otherAttributes,
                meetingHistory: meetingHistory.filter(({ timestampMs }) => {
                  return Date.now() - timestampMs < ChimeContactComponent.MAX_MEETING_HISTORY_MS;
                }),
              },
            })
        );
        break;
      }
    }
  }

  async initializeMeetingSession(configuration: MeetingSessionConfiguration): Promise<void> {
    const consoleLogger = (this.meetingLogger = new ConsoleLogger('SDK', this.logLevel));
    if (this.isLocalHost()) {
      this.meetingLogger = consoleLogger;
    } else {
      await Promise.all([
        this.createLogStream(configuration, 'create_log_stream'),
        this.createLogStream(configuration, 'create_browser_event_log_stream'),
      ]);

      this.meetingSessionPOSTLogger = getPOSTLogger(configuration, 'SDK', `${ChimeContactComponent.BASE_URL}logs`, this.logLevel);
      this.meetingLogger = new MultiLogger(
          consoleLogger,
          this.meetingSessionPOSTLogger,
      );
      this.meetingEventPOSTLogger = getPOSTLogger(configuration, 'SDKEvent', `${ChimeContactComponent.BASE_URL}log_meeting_event`, this.logLevel);
    }
    this.eventReporter = await this.setupEventReporter(configuration);
    this.deviceController = new DefaultDeviceController(this.meetingLogger, {
      enableWebAudio: this.enableWebAudio,
    });
    const urlParameters = new URL(window.location.href).searchParams;
    const timeoutMs = Number(urlParameters.get('attendee-presence-timeout-ms'));
    if (!isNaN(timeoutMs)) {
      configuration.attendeePresenceTimeoutMs = Number(timeoutMs);
    }
    configuration.enableSimulcastForUnifiedPlanChromiumBasedBrowsers = this.enableSimulcast;
    if (this.usePriorityBasedDownlinkPolicy) {
      const serverSideNetworkAdaptionDropDown = document.getElementById('server-side-network-adaption') as HTMLSelectElement;
      switch (serverSideNetworkAdaptionDropDown.value) {
        case 'default':
          this.videoPriorityBasedPolicyConfig.serverSideNetworkAdaption = ServerSideNetworkAdaption.Default;
          break;
        case 'none':
          this.videoPriorityBasedPolicyConfig.serverSideNetworkAdaption = ServerSideNetworkAdaption.None;
          break;
        case 'enable-bandwidth-probing':
          this.videoPriorityBasedPolicyConfig.serverSideNetworkAdaption = ServerSideNetworkAdaption.BandwidthProbing;
          break;
        case 'enable-bandwidth-probing-and-video-adaption':
          this.videoPriorityBasedPolicyConfig.serverSideNetworkAdaption = ServerSideNetworkAdaption.BandwidthProbingAndRemoteVideoQualityAdaption;
          break;
      }
      this.priorityBasedDownlinkPolicy = new VideoPriorityBasedPolicy(this.meetingLogger, this.videoPriorityBasedPolicyConfig);
      configuration.videoDownlinkBandwidthPolicy = this.priorityBasedDownlinkPolicy;
      this.priorityBasedDownlinkPolicy.addObserver(this);
    }
    configuration.disablePeriodicKeyframeRequestOnContentSender = this.disablePeriodicKeyframeRequestOnContentSender;

    configuration.applicationMetadata = ApplicationMetadata.create('amazon-chime-sdk-js-demo', '2.0.0');

    if ((document.getElementById('pause-last-frame') as HTMLInputElement).checked) {
      configuration.keepLastFrameWhenPaused = true;
    }

    this.meetingSession = new DefaultMeetingSession(
        configuration,
        this.meetingLogger,
        this.deviceController,
        new DefaultEventController(configuration, this.meetingLogger, this.eventReporter)
    );

    if ((document.getElementById('fullband-speech-mono-quality') as HTMLInputElement).checked) {
      this.meetingSession.audioVideo.setAudioProfile(AudioProfile.fullbandSpeechMono());
      this.meetingSession.audioVideo.setContentAudioProfile(AudioProfile.fullbandSpeechMono());
      this.log('Using audio profile fullband-speech-mono-quality');
    } else if (
        (document.getElementById('fullband-music-mono-quality') as HTMLInputElement).checked
    ) {
      this.meetingSession.audioVideo.setAudioProfile(AudioProfile.fullbandMusicMono());
      this.meetingSession.audioVideo.setContentAudioProfile(AudioProfile.fullbandMusicMono());
      this.log('Using audio profile fullband-music-mono-quality');
    } else if (
        (document.getElementById('fullband-music-stereo-quality') as HTMLInputElement).checked
    ) {
      this.meetingSession.audioVideo.setAudioProfile(AudioProfile.fullbandMusicStereo());
      this.meetingSession.audioVideo.setContentAudioProfile(AudioProfile.fullbandMusicStereo());
      this.log('Using audio profile fullband-music-stereo-quality');
    }
    this.audioVideo = this.meetingSession.audioVideo;
    this.audioVideo.addDeviceChangeObserver(this);
    this.setupDeviceLabelTrigger();
    this.setupMuteHandler();
    this.setupCanUnmuteHandler();
    this.setupSubscribeToAttendeeIdPresenceHandler();
    this.setupDataMessage();
    this.setupLiveTranscription();
    this.audioVideo.addObserver(this);
    this.meetingSession.eventController.addObserver(this);
    this.audioVideo.addContentShareObserver(this);
    if (this.videoCodecPreferences !== undefined && this.videoCodecPreferences.length > 0) {
      this.audioVideo.setVideoCodecSendPreferences(this.videoCodecPreferences);
      this.audioVideo.setContentShareVideoCodecPreferences(this.videoCodecPreferences);
    }

    // The default pagination size is 25.
    let paginationPageSize = parseInt(this.getLocalElement<HTMLSelectElement>('pagination-page-size').value)
    this.videoTileCollection = new VideoTileCollection(this.audioVideo,
        this.meetingLogger,
        this.usePriorityBasedDownlinkPolicy ? new VideoPreferenceManager(this.meetingLogger, this.priorityBasedDownlinkPolicy) : undefined,
        paginationPageSize, this.isPublication, this.call, this.videoCall, false,
        this.elementRef?.nativeElement)
    this.audioVideo.addObserver(this.videoTileCollection);
    this.videoTileCollection.refreshParticipantLayout();

    this.contentShare = new ContentShareManager(this.meetingLogger, this.audioVideo, this.usingStereoMusicAudioProfile);
  //  this.tiles= this.videoTileCollection.tiles;
    console.log('tiles2', this.tiles);
  }

  async setupEventReporter(configuration: MeetingSessionConfiguration): Promise<EventReporter> {
    let eventReporter: EventReporter;
    const ingestionURL = configuration.urls.eventIngestionURL;
    if (!ingestionURL) {
      return eventReporter;
    }
    if (!this.enableEventReporting) {
      return new NoOpEventReporter();
    }
    const eventReportingLogger = new ConsoleLogger('SDKEventIngestion', LogLevel.INFO);
    const meetingEventClientConfig = new MeetingEventsClientConfiguration(
        configuration.meetingId,
        configuration.credentials.attendeeId,
        configuration.credentials.joinToken
    );
    const eventIngestionConfiguration = new EventIngestionConfiguration(
        meetingEventClientConfig,
        ingestionURL
    );
    if (this.isLocalHost()) {
      eventReporter = new DefaultMeetingEventReporter(eventIngestionConfiguration, eventReportingLogger);
    } else {
      await this.createLogStream(configuration, 'create_browser_event_ingestion_log_stream');
      const eventReportingPOSTLogger = getPOSTLogger(configuration, 'SDKEventIngestion', `${ChimeContactComponent.BASE_URL}log_event_ingestion`, LogLevel.DEBUG);
      const multiEventReportingLogger = new MultiLogger(
          eventReportingLogger,
          eventReportingPOSTLogger,
      );
      eventReporter = new DefaultMeetingEventReporter(eventIngestionConfiguration, multiEventReportingLogger);
    }
    return eventReporter;
  }

  private isLocalHost(): boolean {
    return document.location.host === '127.0.0.1:8080' || document.location.host === 'localhost:8080';
  }

  async join(): Promise<void> {
    if (this.callPageDestroyed) return;
    console.log('nine');
    window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
      console.log('ten');
      this.log(event.reason);
    });
    if (this.joinMuted) {
      console.log('eleven');
      this.audioVideo.realtimeMuteLocalAudio();
    }
    this.startCallElapsedTimer();
    this.audioVideo.start();
    console.log('twelve');
  }

  async leave(): Promise<void> {
    if (this.nativeCallUUID) {
      this.nativeCallEnding = true;
      void NativeCalls.end({ uuid: this.nativeCallUUID }).catch(console.warn);
    }
    const returnToPreviousRoute = this.isChatCallRoute() || this.isMyceliumCallRoute();
    const returnToEcosystem = this.isWebviewLiveRoute() && !returnToPreviousRoute;
    if (returnToPreviousRoute) {
      this.returnToPreviousRouteAfterLeave = true;
      if (this.behaviorAfterLeave !== 'halt') this.behaviorAfterLeave = 'spa';
    }
    if (returnToEcosystem) {
      this.returnToEcosystemAfterLeave = true;
      // Let audioVideoDidStop finish Chime's cleanup before the route changes.
      // Keep the normal modal/loader behavior untouched.
      if (this.behaviorAfterLeave !== 'halt') {
        this.behaviorAfterLeave = 'spa';
      }
    }

    if (this.deleteOwnAttendeeToLeave && !returnToEcosystem && !returnToPreviousRoute) {
      await this.deleteAttendee(this.meeting, this.meetingSession.configuration.credentials.attendeeId);
      return;
    }
    if (this.deleteOwnAttendeeToLeave && returnToPreviousRoute) {
      await this.deleteAttendee(this.meeting, this.meetingSession.configuration.credentials.attendeeId);
    }
    this.resetStats();
    this.audioVideo?.stop();
    await this.voiceFocusDevice?.stop();
    this.voiceFocusDevice = undefined;

    await this.chosenVideoTransformDevice?.stop();
    this.chosenVideoTransformDevice = undefined;
    this.roster.clear();

    if ((returnToEcosystem || returnToPreviousRoute) && !this.audioVideo) {
      if (returnToPreviousRoute) await this.returnFromCallPage();
      else await this.navController.navigateRoot('/home/ecosystem-page', { replaceUrl: true });
      return;
    }
    if (returnToEcosystem || returnToPreviousRoute) {
      return;
    }
    this.refresh();
  }
  refresh() {
    // Navigate to a temporary route
  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    // Navigate back to the current URL
    this.router.navigate(['/loader']);
  });
  setTimeout(() => {
  // Reload the current page to reinitialize the app
  window.location.reload();
  },6000);
}
  setupMuteHandler(): void {
    this.muteAndUnmuteLocalAudioHandler = (isMuted: boolean): void => {
      this.log(`muted = ${isMuted}`);
      this.buttonStates['button-microphone'] = isMuted ? 'off' : 'on';
      this.displayButtonStates();
    };
    this.audioVideo.realtimeSubscribeToMuteAndUnmuteLocalAudio(this.muteAndUnmuteLocalAudioHandler);
    const isMuted = this.audioVideo.realtimeIsLocalAudioMuted();
    this.muteAndUnmuteLocalAudioHandler(isMuted);
  }

  setupCanUnmuteHandler(): void {
    this.canUnmuteLocalAudioHandler = (canUnmute: boolean): void => {
      this.log(`canUnmute = ${canUnmute}`);
    };
    this.audioVideo.realtimeSubscribeToSetCanUnmuteLocalAudio(this.canUnmuteLocalAudioHandler);
    this.canUnmuteLocalAudioHandler(this.audioVideo.realtimeCanUnmuteLocalAudio());
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  updateProperty(obj: any, key: string, value: string): void {
    if (value !== undefined && obj[key] !== value) {
      obj[key] = value;
    }
  }

  setupSubscribeToAttendeeIdPresenceHandler(): void {
    this.attendeeIdPresenceHandler = (
        attendeeId: string,
        present: boolean,
        externalUserId: string,
        dropped: boolean
    ): void => {
      const safeExternalUserId = externalUserId || attendeeId;
      this.log(`${attendeeId} present = ${present} (${safeExternalUserId})`);
      const isContentAttendee = new DefaultModality(attendeeId).hasModality(
          DefaultModality.MODALITY_CONTENT
      );
      const isSelfAttendee =
          new DefaultModality(attendeeId).base() === this.meetingSession.configuration.credentials.attendeeId
          || new DefaultModality(attendeeId).base() === this.primaryMeetingSessionCredentials?.attendeeId
      if (!present) {
        this.presentRemoteAttendees.delete(attendeeId);
        this.roster.removeAttendee(attendeeId);
        this.remoteParticipantNames.delete(attendeeId);
        this.removeCallParticipant(attendeeId);
        this.refreshNoVideoPlaceholder();
        this.audioVideo.realtimeUnsubscribeFromVolumeIndicator(attendeeId, this.volumeIndicatorHandler);
        this.log(`${attendeeId} dropped = ${dropped} (${externalUserId})`);
        return;
      }
      //If someone else share content, stop the current content share
      if (
          !this.allowMaxContentShare() &&
          !isSelfAttendee &&
          isContentAttendee &&
          this.isButtonOn('button-content-share')
      ) {
        this.contentShare.stop();
      }
      const externalName = safeExternalUserId.split('#').slice(-1)[0] || 'Participant';
      const attendeeName = externalName + (isContentAttendee ? ' «Content»' : '');
      this.roster.addAttendee(attendeeId, attendeeName);
      if (!isSelfAttendee && !isContentAttendee) {
        this.presentRemoteAttendees.add(attendeeId);
        const displayName = externalName || attendeeName;
        this.remoteParticipantNames.set(attendeeId, displayName);
        this.upsertCallParticipant(attendeeId, displayName, false, false);
        for (const [tileId, tileAttendeeId] of this.videoTileAttendeeIds) {
          if (tileAttendeeId === attendeeId) {
            this.videoTileCollection?.setParticipantName(tileId, displayName);
          }
        }
        this.refreshNoVideoPlaceholder();
      }

      this.volumeIndicatorHandler = async (
          attendeeId: string,
          volume: number | null,
          muted: boolean | null,
          signalStrength: number | null
      ) => {
        if (muted !== null) {
          this.roster.setMuteStatus(attendeeId, muted);
        }
        if (signalStrength !== null) {
          this.roster.setSignalStrength(attendeeId, Math.round(signalStrength * 100));
        }
      };

      this.audioVideo.realtimeSubscribeToVolumeIndicator(attendeeId, this.volumeIndicatorHandler);
    };

    this.audioVideo.realtimeSubscribeToAttendeeIdPresence(this.attendeeIdPresenceHandler);

    // Hang on to this so we can unsubscribe later.
    this.activeSpeakerHandler = (attendeeIds: string[]): void => {
      // First reset all roster active speaker information
      for (const id of this.roster.getAllAttendeeIds()) {
        this.roster.setAttendeeSpeakingStatus(id, false);
      }

      // Then re-update roster and tile collection with latest information
      //
      // This will leave featured tiles up since this detector doesn't seem to clear
      // the list.
      for (const attendeeId of attendeeIds) {
        if (this.roster.hasAttendee(attendeeId)) {
          this.roster.setAttendeeSpeakingStatus(attendeeId, true);
          this.videoTileCollection.activeSpeakerAttendeeId = attendeeId
          break; // Only show the most active speaker
        }
      }
    };

    const scoreHandler = (scores: { [attendeeId: string]: number }) => {};

    this.audioVideo.subscribeToActiveSpeakerDetector(
        new DefaultActiveSpeakerPolicy(),
        this.activeSpeakerHandler,
        scoreHandler,
        this.showActiveSpeakerScores ? 100 : 0
    );
  }

  dataMessageHandler(dataMessage: DataMessage, contador?: string): void {
    if (!dataMessage.throttled) {
      const messageText = dataMessage.text();
      const isSelf =
          dataMessage.senderAttendeeId === this.meetingSession.configuration.credentials.attendeeId;
      if (dataMessage.timestampMs <= this.lastReceivedMessageTimestamp) {
        return;
      }
      this.lastReceivedMessageTimestamp = dataMessage.timestampMs;
      const messageDiv = this.getLocalElement<HTMLDivElement>('receive-message');
      const messageNameSpan = document.createElement('div') as HTMLDivElement;
      messageNameSpan.classList.add('message-bubble-sender');
      messageNameSpan.innerText = dataMessage.senderExternalUserId.split('#').slice(-1)[0];
      const messageTextSpan = document.createElement('div') as HTMLDivElement;
      messageTextSpan.classList.add(isSelf ? 'message-bubble-self' : 'message-bubble-other');
      messageTextSpan.innerHTML = this.markdown
          .render(messageText)
          .replace(/[<]a /g, '<a target="_blank" ');
      const appendClass = (element: HTMLElement, className: string): void => {
        for (let i = 0; i < element.children.length; i++) {
          const child = element.children[i] as HTMLElement;
          child.classList.add(className);
          appendClass(child, className);
        }
      };
      appendClass(messageTextSpan, 'markdown');
      if (this.lastMessageSender !== dataMessage.senderAttendeeId) {
        messageDiv.appendChild(messageNameSpan);
      }
      this.lastMessageSender = dataMessage.senderAttendeeId;
      messageDiv.appendChild(messageTextSpan);
      messageDiv.scrollTop = messageDiv.scrollHeight;

          // Check if 'regalo' is sent and update the label accordingly
    if (messageText === 'Nuevo regalo 🎁') {
      console.log('regalo');
      const labelToUpdate = this.getLocalElement<HTMLLabelElement>('regalos-tiempo-real');
      if (labelToUpdate) {
       
        // Get the current value and add 1
        const currentValue = parseInt(labelToUpdate.innerText, 10) || 0;
        labelToUpdate.innerText = (currentValue + 1).toString();
        setTimeout (() => {
        const regalos=this.fetchCounter('regalos', 'get');
        console.log('regalos',regalos);
      }, 1000);
      }
    }else if (messageText === 'Se ha unido 👀') {
      console.log('vista');
      const labelToUpdate = this.getLocalElement<HTMLLabelElement>('vistas-tiempo-real');
      if (labelToUpdate) {
        this.stopAudio();
        this.stopOutgoingRinging();
        // Get the current value and add 1
        const currentValue = parseInt(labelToUpdate.innerText, 10) || 0;
        labelToUpdate.innerText = (currentValue + 1).toString();
        setTimeout (() => {
        const vistas=this.fetchCounter('vistas', 'get');
        console.log('vistas',vistas);
        }, 1000);
      

      }
    }
    if (!isSelf && !this.isSystemDataMessage(messageText)) {
      this.incrementCommentCounter();
    }
    
    } else {
      this.log('Message is throttled. Please resend');
    }
  }

  setupDataMessage(): void {
    this.audioVideo.realtimeSubscribeToReceiveDataMessage(
      ChimeContactComponent.DATA_MESSAGE_TOPIC,
        (dataMessage: DataMessage) => {
          this.dataMessageHandler(dataMessage);
        }
    );
  }

  transcriptEventHandler = (transcriptEvent: TranscriptEvent): void => {
    if (!this.enableLiveTranscription) {
      // Toggle disabled 'Live Transcription' button to enabled when we receive any transcript event
      this.enableLiveTranscription = true;
      this.updateLiveTranscriptionDisplayState();

      // Transcripts view and the button to show and hide it are initially hidden
      // Show them when when live transcription gets enabled, and do not hide afterwards
      this.setButtonVisibility('button-live-transcription', true, 'on');
      this.transcriptContainerDiv.style.display = 'block';
    }

    if (transcriptEvent instanceof TranscriptionStatus) {
      this.appendStatusDiv(transcriptEvent);
      if (transcriptEvent.type === TranscriptionStatusType.STARTED) {
        // Determine word separator based on language code
        let languageCode = null;
        const transcriptionConfiguration = JSON.parse(transcriptEvent.transcriptionConfiguration);
        if (transcriptionConfiguration) {
          if (transcriptionConfiguration.EngineTranscribeSettings) {
            languageCode = transcriptionConfiguration.EngineTranscribeSettings.LanguageCode;
          } else if (transcriptionConfiguration.EngineTranscribeMedicalSettings) {
            languageCode = transcriptionConfiguration.EngineTranscribeMedicalSettings.languageCode;
          }
        }

        if (languageCode && LANGUAGES_NO_WORD_SEPARATOR.has(languageCode)) {
          this.noWordSeparatorForTranscription = true;
        }
      } else if ((transcriptEvent.type === TranscriptionStatusType.STOPPED || transcriptEvent.type === TranscriptionStatusType.FAILED) && this.enableLiveTranscription) {
        // When we receive a STOPPED status event:
        // 1. toggle enabled 'Live Transcription' button to disabled
        this.enableLiveTranscription = false;
        this.noWordSeparatorForTranscription = false;
        this.updateLiveTranscriptionDisplayState();

        // 2. force finalize all partial results
        this.partialTranscriptResultTimeMap.clear();
        this.partialTranscriptDiv = null;
        this.partialTranscriptResultMap.clear();
      }
    } else if (transcriptEvent instanceof Transcript) {
      for (const result of transcriptEvent.results) {
        const resultId = result.resultId;
        const isPartial = result.isPartial;
        const languageCode = result.languageCode;
        if (languageCode && LANGUAGES_NO_WORD_SEPARATOR.has(languageCode)) {
          this.noWordSeparatorForTranscription = true;
        }
        if (!isPartial) {
          if (result.alternatives[0].entities?.length > 0) {
            for (const entity of result.alternatives[0].entities) {
              //split the entity based on space
              let contentArray = entity.content.split(' ');
              for (const content of contentArray) {
                this.transcriptEntitySet.add(content);
              }
            }
          }
        }
        this.partialTranscriptResultMap.set(resultId, result);
        this.partialTranscriptResultTimeMap.set(resultId, result.endTimeMs);
        this.renderPartialTranscriptResults();
        if (isPartial) {
          continue;
        }

        // Force finalizing partial results that's 5 seconds older than the latest one,
        // to prevent local partial results from indefinitely growing
        for (const [olderResultId, endTimeMs] of this.partialTranscriptResultTimeMap) {
          if (olderResultId === resultId) {
            break;
          } else if (endTimeMs < result.endTimeMs - 5000) {
            this.partialTranscriptResultTimeMap.delete(olderResultId);
          }
        }

        this.partialTranscriptResultTimeMap.delete(resultId);
        this.transcriptEntitySet.clear();

        if (this.partialTranscriptResultTimeMap.size === 0) {
          // No more partial results in current batch, reset current batch
          this.partialTranscriptDiv = null;
          this.partialTranscriptResultMap.clear();
        }
      }
    }

    this.transcriptContainerDiv.scrollTop = this.transcriptContainerDiv.scrollHeight;
  };

  renderPartialTranscriptResults = () => {
    if (this.partialTranscriptDiv) {
      // Keep updating existing partial result div
      this.updatePartialTranscriptDiv();
    } else {
      // All previous results were finalized. Create a new div for new results, update, then add it to DOM
      this.partialTranscriptDiv = document.createElement('div') as HTMLDivElement;
      this.updatePartialTranscriptDiv();
      this.transcriptContainerDiv.appendChild(this.partialTranscriptDiv);
    }
  };

  updatePartialTranscriptDiv = () => {
    this.partialTranscriptDiv.innerHTML = '';

    const partialTranscriptSegments: TranscriptSegment[] = [];
    for (const result of this.partialTranscriptResultMap.values()) {
      this.populatePartialTranscriptSegmentsFromResult(partialTranscriptSegments, result);
    }
    partialTranscriptSegments.sort((a, b) => a.startTimeMs - b.startTimeMs);

    const speakerToTranscriptSpanMap = new Map<string, HTMLSpanElement>();
    for (const segment of partialTranscriptSegments) {
      const newSpeakerId = segment.attendee.attendeeId;
      if (!speakerToTranscriptSpanMap.has(newSpeakerId)) {
        this.appendNewSpeakerTranscriptDiv(segment, speakerToTranscriptSpanMap);
      } else {
        const partialResultSpeakers: string[] = Array.from(speakerToTranscriptSpanMap.keys());
        if (partialResultSpeakers.indexOf(newSpeakerId) < partialResultSpeakers.length - 1) {
          // Not the latest speaker and we reach the end of a sentence, clear the speaker to Span mapping to break line
          speakerToTranscriptSpanMap.delete(newSpeakerId);
          this.appendNewSpeakerTranscriptDiv(segment, speakerToTranscriptSpanMap);
        } else {
          const transcriptSpan = speakerToTranscriptSpanMap.get(newSpeakerId);
          transcriptSpan.appendChild(this.createSpaceSpan());
          transcriptSpan.appendChild(segment.contentSpan);
        }
      }
    }
  };

  populatePartialTranscriptSegmentsFromResult = (segments: TranscriptSegment[], result: TranscriptResult) => {
    let startTimeMs: number = null;
    let attendee: Attendee = null;
    let contentSpan;
    for (const item of result.alternatives[0].items) {
      const itemContentSpan = document.createElement('span') as HTMLSpanElement;
      itemContentSpan.innerText = item.content;
      itemContentSpan.classList.add('transcript-content');
      // underline the word with red to show confidence level of predicted word being less than 0.3
      // for redaction, words are represented as '[Name]' and has a confidence of 0. Redacted words are only shown with highlighting.
      if (item.hasOwnProperty('confidence') && !item.content.startsWith("[") && item.confidence < 0.3) {
        itemContentSpan.classList.add('confidence-style');
      }

      // highlight the word in green to show the predicted word is a PII/PHI entity
      if (this.transcriptEntitySet.size > 0 && this.transcriptEntitySet.has(item.content)) {
        itemContentSpan.classList.add('entity-color');
      }

      if (!startTimeMs) {
        contentSpan = document.createElement('span') as HTMLSpanElement;
        contentSpan.appendChild(itemContentSpan);
        attendee = item.attendee;
        startTimeMs = item.startTimeMs;
      } else if (item.type === TranscriptItemType.PUNCTUATION) {
        contentSpan.appendChild(itemContentSpan);
        segments.push({
          contentSpan,
          attendee: attendee,
          startTimeMs: startTimeMs,
          endTimeMs: item.endTimeMs
        });
        startTimeMs = null;
        attendee = null;
      } else {
        if (this.noWordSeparatorForTranscription) {
          contentSpan.appendChild(itemContentSpan);
        } else {
          contentSpan.appendChild(this.createSpaceSpan());
          contentSpan.appendChild(itemContentSpan);
        }
      }
    }

    // Reached end of the result but there is no closing punctuation
    if (startTimeMs) {
      segments.push({
        contentSpan: contentSpan,
        attendee: attendee,
        startTimeMs: startTimeMs,
        endTimeMs: result.endTimeMs,
      });
    }
  };

  createSpaceSpan(): HTMLSpanElement {
    const spaceSpan = document.createElement('span') as HTMLSpanElement;
    spaceSpan.classList.add('transcript-content');
    spaceSpan.innerText = '\u00a0';
    return spaceSpan;
  };

  appendNewSpeakerTranscriptDiv = (
      segment: TranscriptSegment,
      speakerToTranscriptSpanMap: Map<string, HTMLSpanElement>) => {
    const speakerTranscriptDiv = document.createElement('div') as HTMLDivElement;
    speakerTranscriptDiv.classList.add('transcript');

    const speakerSpan = document.createElement('span') as HTMLSpanElement;
    speakerSpan.classList.add('transcript-speaker');
    speakerSpan.innerText = segment.attendee.externalUserId.split('#').slice(-1)[0] + ': ';
    speakerTranscriptDiv.appendChild(speakerSpan);

    speakerTranscriptDiv.appendChild(segment.contentSpan);

    this.partialTranscriptDiv.appendChild(speakerTranscriptDiv);

    speakerToTranscriptSpanMap.set(segment.attendee.attendeeId, segment.contentSpan);
  };

  appendStatusDiv = (status: TranscriptionStatus) => {
    const statusDiv = document.createElement('div') as HTMLDivElement;
    statusDiv.innerText = '(Live Transcription ' + status.type + ' at '
        + new Date(status.eventTimeMs).toLocaleTimeString() + ' in ' + status.transcriptionRegion
        + ' with configuration: ' + status.transcriptionConfiguration
        + (status.message ? ' due to "' + status.message + '".': '') + ')';
    this.transcriptContainerDiv.appendChild(statusDiv);
  };

  setupLiveTranscription = () => {
    this.audioVideo.transcriptionController?.subscribeToTranscriptEvent(this.transcriptEventHandler);
  };

  // eslint-disable-next-line
  async sendJoinRequest(
      meeting: string,
      name: string,
      region: string,
      primaryExternalMeetingId?: string): Promise<any> {
    let uri = `${ChimeContactComponent.BASE_URL}join?title=${encodeURIComponent(
        meeting
    )}&name=${encodeURIComponent(name)}&region=${encodeURIComponent(region)}&publication=${encodeURIComponent(this.isPublication)}&profile_photo=${encodeURIComponent(this.profile_photo)}&publication_category=${this.publication_category}`
    if (primaryExternalMeetingId) {
      uri += `&primaryExternalMeetingId=${primaryExternalMeetingId}`;
    }
    if (this.scheduledStartAt) {
      uri += `&scheduledAt=${encodeURIComponent(this.scheduledStartAt.toISOString())}`;
    }

    uri += `&ns_es=${this.echoReductionCapability}`
    console.log(uri);
    const response = await fetch(uri,
        {
          method: 'POST',
       
        }
    );
    console.log('res1', response);
    console.log('res2', JSON.stringify(response));
    const json = await response.json();
    console.log('resj', json);
    if (json.error) {
      throw new Error(`Server error: ${json.error}`);
    }
    if (this.call === true){
      void this.sendNotification( `Llamada entrante de @${this.username}`, `@${this.username} te está llamando, da click para contestar`, this.receipient_user_id, meeting).catch(error => console.warn("Call notification delivery failed:", error));
    }else if(this.videoCall === true ){
      void this.sendNotification( `Videollamada entrante de @${this.username}`, `@${this.username} te está llamando, da click para contestar`, this.receipient_user_id, meeting).catch(error => console.warn("Call notification delivery failed:", error));
    }

    return json;
  }


  async deleteAttendee(meeting: string, attendeeId: string): Promise<void> {
    let uri = `${ChimeContactComponent.BASE_URL}deleteAttendee?title=${encodeURIComponent(meeting)}&attendeeId=${encodeURIComponent(attendeeId)}`
    const response = await fetch(uri,
        {
          method: 'POST',
        }
    );
    const json = await response.json();
    this.meetingLogger.info(`Delete attendee response: ${JSON.stringify(json)}`)
  }

  async startMediaCapture(): Promise<any> {
    await fetch(
        `${ChimeContactComponent.BASE_URL}startCapture?title=${encodeURIComponent(this.meeting)}`, {
          method: 'POST',
        });
  }

  async stopMediaCapture(): Promise<any> {
    await fetch(
        `${ChimeContactComponent.BASE_URL}endCapture?title=${encodeURIComponent(this.meeting)}`, {
          method: 'POST',
        });
  }

  async startLiveConnector(): Promise<any> {
    const liveConnectorresponse = await fetch(
        `${ChimeContactComponent.BASE_URL}startLiveConnector?title=${encodeURIComponent(this.meeting)}`, {
          method: 'POST',
        });
    const json = await liveConnectorresponse.json();
    if (json.error) {
      throw new Error(`Server error: ${json.error}`);
    }
    return json;
  }

  async stopLiveConnector(): Promise<any> {
    await fetch(
        `${ChimeContactComponent.BASE_URL}endLiveConnector?title=${encodeURIComponent(this.meeting)}`, {
          method: 'POST',
        });
  }


  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async endMeeting(): Promise<any> {
    if (this.nativeCallUUID) {
      this.nativeCallEnding = true;
      void NativeCalls.end({ uuid: this.nativeCallUUID }).catch(console.warn);
    }
    if ((this.call || this.videoCall) && this.meeting) {
      void this.request.createRequestPost('iosCall', { action: 'end', meeting_id: this.meeting }).catch(console.warn);
    }
    await fetch(`${ChimeContactComponent.BASE_URL}end?title=${encodeURIComponent(this.meeting)}`, {
      method: 'POST',
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async getAttendee(attendeeId: string): Promise<any> {
    const response = await fetch(
        `${ChimeContactComponent.BASE_URL}attendee?title=${encodeURIComponent(
            this.meeting
        )}&attendee=${encodeURIComponent(attendeeId)}`
    );
    const json = await response.json();
    if (json.error) {
      throw new Error(`Server error: ${json.error}`);
    }
    return json;
  }

  setupDeviceLabelTrigger(): void {
    // Note that device labels are privileged since they add to the
    // fingerprinting surface area of the browser session. In Chrome private
    // tabs and in all Firefox tabs, the labels can only be read once a
    // MediaStream is active. How to deal with this restriction depends on the
    // desired UX. The device controller includes an injectable device label
    // trigger which allows you to perform custom behavior in case there are no
    // labels, such as creating a temporary audio/video stream to unlock the
    // device names, which is the default behavior. Here we override the
    // trigger to also show an alert to let the user know that we are asking for
    // mic/camera permission.
    //
    // Also note that Firefox has its own device picker, which may be useful
    // for the first device selection. Subsequent device selections could use
    // a custom UX with a specific device id.
    if (!this.defaultBrowserBehavior.doesNotSupportMediaDeviceLabels()) {
      this.audioVideo.setDeviceLabelTrigger(
          async (): Promise<MediaStream> => {
            if (this.isRecorder() || this.isBroadcaster() || this.isViewOnly) {
              throw new Error('Recorder or Broadcaster does not need device labels');
            }
            this.switchToFlow('flow-need-permission');
            const stream = await navigator.mediaDevices.getUserMedia({ audio: true, video: true });
            this.switchToFlow('flow-devices');
            return stream;
          }
      );
    }
  }

  populateDeviceList(
      elementId: string,
      genericName: string,
      devices: MediaDeviceInfo[],
      additionalOptions: string[]
  ): void {
    const list = this.getLocalElement<HTMLSelectElement>(elementId);
    while (list.firstElementChild) {
      list.removeChild(list.firstElementChild);
    }
    for (let i = 0; i < devices.length; i++) {
      const option = document.createElement('option');
      list.appendChild(option);
      option.text = devices[i].label || `${genericName} ${i + 1}`;
      option.value = devices[i].label ? devices[i].deviceId : '';
    }
    if (additionalOptions.length > 0) {
      const separator = document.createElement('option');
      separator.disabled = true;
      separator.text = '──────────';
      list.appendChild(separator);
      for (const additionalOption of additionalOptions) {
        const option = document.createElement('option');
        list.appendChild(option);
        option.text = additionalOption;
        option.value = additionalOption;
      }
    }
    if (!list.firstElementChild) {
      const option = document.createElement('option');
      option.text = 'Device selection unavailable';
      list.appendChild(option);
    }
  }

  populateVideoPreviewFilterList(
      elementId: string,
      genericName: string,
      filters: VideoFilterName[]
  ): void {
    const list = this.getLocalElement<HTMLSelectElement>(elementId);
    while (list.firstElementChild) {
      list.removeChild(list.firstElementChild);
    }
    for (let i = 0; i < filters.length; i++) {
      const option = document.createElement('option');
      list.appendChild(option);
      option.text = filters[i] || `${genericName} ${i + 1}`;
      option.value = filters[i];
    }

    if (!list.firstElementChild) {
      const option = document.createElement('option');
      option.text = 'Filter selection unavailable';
      list.appendChild(option);
    }
  }

  populateInMeetingDeviceList(
      elementId: string,
      genericName: string,
      devices: MediaDeviceInfo[],
      additionalOptions: string[],
      additionalToggles: Toggle[] | undefined,
      callback: (name: string) => void
  ): void {
    const menu = this.getLocalElement<HTMLDivElement>(elementId);
    while (menu.firstElementChild) {
      menu.removeChild(menu.firstElementChild);
    }
    for (let i = 0; i < devices.length; i++) {
      this.createDropdownMenuItem(menu, devices[i].label || `${genericName} ${i + 1}`, () => {
        callback(devices[i].deviceId);
      });
    }
    if (additionalOptions.length) {
      this.createDropdownMenuItem(menu, '──────────', () => { }).classList.add('text-center');
      for (const additionalOption of additionalOptions) {
        this.createDropdownMenuItem(
            menu,
            additionalOption,
            () => {
              callback(additionalOption);
            },
            `${elementId}-${additionalOption.replace(/\s/g, '-')}`
        );
      }
    }
    if (additionalToggles?.length) {
      this.createDropdownMenuItem(menu, '──────────', () => { }).classList.add('text-center');
      for (const { name, oncreate, action } of additionalToggles) {
        const id = `toggle-${elementId}-${name.replace(/\s/g, '-')}`;
        const elem = this.createDropdownMenuItem(menu, name, action, id);
        oncreate(elem);
      }
    }
    if (!menu.firstElementChild) {
      this.createDropdownMenuItem(menu, 'Device selection unavailable', () => { });
    }
  }

  createDropdownMenuItem(
      menu: HTMLDivElement,
      title: string,
      clickHandler: () => void,
      id?: string
  ): HTMLButtonElement {
    const button = document.createElement('button') as HTMLButtonElement;
    menu.appendChild(button);
    button.innerText = title;
    button.classList.add('dropdown-item');
    this.updateProperty(button, 'id', id);
    button.addEventListener('click', () => {
      clickHandler();
    });
    return button;
  }

  async populateAllDeviceLists(): Promise<void> {
    await this.populateAudioInputList();
    await this.populateVideoInputList();
    await this.populateAudioOutputList();
  }

  private async selectVideoFilterByName(name: VideoFilterName): Promise<void> {
    this.selectedVideoFilterItem = name;
    this.log(`clicking video filter ${this.selectedVideoFilterItem}`);
    this.toggleButton(
        'button-video-filter',
        this.selectedVideoFilterItem === 'None' ? 'off' : 'on'
    );
    if (this.isButtonOn('button-camera')) {
      try {
        await this.openVideoInputFromSelection(this.selectedVideoInput, false);
      } catch (err) {
        fatal(err);
        this.log('Failed to choose VideoTransformDevice', err);
      }
    }
  }

  private async stopVideoProcessor(): Promise<void> {
    this.log('Clearing filter variables and stopping the video transform device');
    this.chosenVideoFilter = 'None';
    this.selectedVideoFilterItem = 'None';
    this.chosenVideoTransformDevice?.stop();
  }

  private getBackgroundBlurSpec(): BackgroundFilterSpec {
    return {
      paths: BACKGROUND_BLUR_PATHS,
      model: BACKGROUND_BLUR_MODEL,
      ...BACKGROUND_BLUR_ASSET_SPEC
    };
  }

  private async populateVideoFilterInputList(isPreviewWindow: boolean): Promise<void> {
    const genericName = 'Filter';
    let filters: VideoFilterName[] = ['None'];

    if (this.areVideoFiltersSupported()) {
      filters = filters.concat(VIDEO_FILTERS);
      if (platformCanSupportBodyPixWithoutDegradation()) {
        if (!this.loadingBodyPixDependencyPromise) {
          this.loadingBodyPixDependencyPromise = loadBodyPixDependency(this.loadingBodyPixDependencyTimeoutMs);
        }
        // do not use `await` to avoid blocking page loading
        this.loadingBodyPixDependencyPromise.then(() => {
          filters.push('Segmentation');
          this.populateFilterList(isPreviewWindow, genericName, filters);
        }).catch(err => {
          this.log('Could not load BodyPix dependency', err);
        });
      }

      if (this.supportsBackgroundBlur) {
        filters.push('Background Blur 10% CPU');
        filters.push('Background Blur 20% CPU');
        filters.push('Background Blur 30% CPU');
        filters.push('Background Blur 40% CPU');
      }

      if (this.supportsBackgroundReplacement) {
        filters.push('Background Replacement');
      }

      // Add VideoFx functionality/options if the processor is supported
      if (this.supportsVideoFx) {
        BACKGROUND_FILTER_V2_LIST.map(effectName => filters.push(effectName));
      }
    }

    this.populateFilterList(isPreviewWindow, genericName, filters);
  }

  private async populateFilterList(isPreviewWindow: boolean, genericName: string, filters: VideoFilterName[]): Promise<void> {
    if (isPreviewWindow) {
      this.populateVideoPreviewFilterList(
          'video-input-filter',
          genericName,
          filters
      );
    }
    else {
      this.populateInMeetingDeviceList(
          'dropdown-menu-filter',
          genericName,
          [],
          filters,
          undefined,
          async (name: VideoFilterName) => {
            await this.selectVideoFilterByName(name);
          }
      );
    }
  }

  async populateAudioInputList(): Promise<void> {
    const genericName = 'Microphone';
    let additionalDevices = ['None', '440 Hz', 'Prerecorded Speech', 'Echo'];
    const additionalStereoTestDevices = ['L-500Hz R-1000Hz', 'Prerecorded Speech (Stereo)'];
    const additionalToggles = [];

    if (!this.defaultBrowserBehavior.hasFirefoxWebRTC()) {
      // We don't add this in Firefox because there is no known mechanism, using MediaStream or WebAudio APIs,
      // to *not* generate audio in Firefox. By default, everything generates silent audio packets in Firefox.
      additionalDevices.push('No Audio');
    }

    // This can't work unless Web Audio is enabled.
    if (this.enableWebAudio && this.supportsVoiceFocus) {
      additionalToggles.push({
        name: 'Amazon Voice Focus',
        oncreate: (elem: HTMLElement) => {
          this.voiceFocusDisplayables.push(elem);
        },
        action: () => this.toggleVoiceFocusInMeeting(),
      });
    }
/*
    // Don't allow replica meeting attendees to enable transcription even when promoted
    if (this.primaryExternalMeetingId === undefined || this.primaryExternalMeetingId.length === 0) {
      additionalToggles.push({
        name: 'Live Transcription',
        oncreate: (elem: HTMLElement) => {
          this.liveTranscriptionDisplayables.push(elem);
        },
        action: () => this.toggleLiveTranscription(),
      });
    }*/

    this.populateDeviceList(
        'audio-input',
        genericName,
        await this.audioVideo.listAudioInputDevices(),
        additionalDevices
    );

    if (this.usingStereoMusicAudioProfile) {
      additionalDevices = additionalDevices.concat(additionalStereoTestDevices);
    }

    this.populateInMeetingDeviceList(
        'dropdown-menu-microphone',
        genericName,
        await this.audioVideo.listAudioInputDevices(),
        additionalDevices,
        additionalToggles,
        async (name: string) => {
          await this.selectAudioInputDeviceByName(name);
        }
    );
  }

  private areVideoFiltersSupported(): boolean {
    return this.defaultBrowserBehavior.supportsCanvasCapturedStreamPlayback();
  }

  private isVoiceFocusActive(): boolean {
    return this.currentAudioInputDevice instanceof VoiceFocusTransformDevice;
  }

  private updateVoiceFocusDisplayState(): void {
    const active = this.isVoiceFocusActive();
    this.log('Updating Amazon Voice Focus display state:', active);
    for (const elem of this.voiceFocusDisplayables) {
      elem.classList.toggle('vf-active', active);
    }
  }

  private isVoiceFocusEnabled(): boolean {
    this.log('VF supported:', this.supportsVoiceFocus);
    this.log('VF enabled:', this.enableVoiceFocus);
    return this.supportsVoiceFocus && this.enableVoiceFocus;
  }

  private async reselectAudioInputDevice(): Promise<void> {
    const current = this.currentAudioInputDevice;

    if (current instanceof VoiceFocusTransformDevice) {
      // Unwrap and rewrap if Amazon Voice Focus is selected.
      const intrinsic = current.getInnerDevice();
      const device = await this.audioInputSelectionWithOptionalVoiceFocus(intrinsic);
      return this.selectAudioInputDevice(device);
    }

    // If it's another kind of transform device, just reselect it.
    if (isAudioTransformDevice(current)) {
      return this.selectAudioInputDevice(current);
    }

    // Otherwise, apply Amazon Voice Focus if needed.
    const device = await this.audioInputSelectionWithOptionalVoiceFocus(current);
    return this.selectAudioInputDevice(device);
  }

  private async toggleVoiceFocusInMeeting(): Promise<void> {
    const elem = document.getElementById('add-voice-focus') as HTMLInputElement;
    this.enableVoiceFocus = this.supportsVoiceFocus && !this.enableVoiceFocus;
    elem.checked = this.enableVoiceFocus;
    this.log('Amazon Voice Focus toggle is now', elem.checked);

    await this.reselectAudioInputDevice();
  }

  private updateLiveTranscriptionDisplayState() {
    this.log('Updating live transcription display state to:', this.enableLiveTranscription);
    for (const elem of this.liveTranscriptionDisplayables) {
      elem.classList.toggle('live-transcription-active', this.enableLiveTranscription);
    }
  }

  private async toggleLiveTranscription(): Promise<void> {
    this.log('live transcription were previously set to ' + this.enableLiveTranscription + '; attempting to toggle');

    if (this.enableLiveTranscription) {
      const response = await fetch(`${ChimeContactComponent.BASE_URL}${encodeURIComponent('stop_transcription')}?title=${encodeURIComponent(this.meeting)}`, {
        method: 'POST',
      });
      const json = await response.json();
      if (json.error) {
        throw new Error(`Server error: ${json.error}`);
      }
    } else {
      const liveTranscriptionModal = document.getElementById(`live-transcription-modal`);
      liveTranscriptionModal.style.display = "block";
    }
  }

  async populateVideoInputList(): Promise<void> {
    const genericName = 'Camera';
    const additionalDevices = ['None', 'Blue', 'SMPTE Color Bars'];
    this.populateDeviceList(
        'video-input',
        genericName,
        await this.audioVideo.listVideoInputDevices(),
        additionalDevices
    );
    this.populateInMeetingDeviceList(
        'dropdown-menu-camera',
        genericName,
        await this.audioVideo.listVideoInputDevices(),
        additionalDevices,
        undefined,
        async (name: string) => {
          try {
            // If video is already started sending or the video button is enabled, then reselect a new stream
            // Otherwise, just update the device.
            if (this.meetingSession.audioVideo.hasStartedLocalVideoTile()) {
              await this.openVideoInputFromSelection(name, false);
            } else {
              this.selectedVideoInput = name;
            }
          } catch (err) {
            fatal(err);
          }
        }
    );
    const cameras = await this.audioVideo.listVideoInputDevices();
    this.cameraDeviceIds = cameras.map(deviceInfo => {
      return deviceInfo.deviceId;
    });
  }

  async populateAudioOutputList(): Promise<void> {
    const supportsChoosing = this.defaultBrowserBehavior.supportsSetSinkId();
    const genericName = 'Speaker';
    const additionalDevices: string[] = [];
    const devices = supportsChoosing ? await this.audioVideo.listAudioOutputDevices() : [];
    this.populateDeviceList('audio-output', genericName, devices, additionalDevices);
    this.populateInMeetingDeviceList(
        'dropdown-menu-speaker',
        genericName,
        devices,
        additionalDevices,
        undefined,
        async (name: string) => {
          if (!supportsChoosing) {
            return;
          }
          try {
            await this.chooseAudioOutput(name);
          } catch (e) {
            fatal(e);
            this.log('Failed to chooseAudioOutput', e);
          }
        }
    );
  }

  private async chooseAudioOutput(device: string): Promise<void> {
    // Set it for the content share stream if we can.
    const videoElem = this.getLocalElement<HTMLVideoElement>('content-share-video');
    if (this.defaultBrowserBehavior.supportsSetSinkId()) {
      // @ts-ignore
      videoElem.setSinkId(device);
    }

    await this.audioVideo.chooseAudioOutput(device);
  }

  private analyserNodeCallback: undefined | (() => void);

  async selectedAudioInput(): Promise<AudioInputDevice> {
    const audioInput = this.getLocalElement<HTMLSelectElement>('audio-input');
    const device = await this.audioInputSelectionToDevice(audioInput.value);
    return device;
  }

  async selectAudioInputDevice(device: AudioInputDevice): Promise<void> {
    this.currentAudioInputDevice = device;
    this.log('Selecting audio input', device);
    try {
      await this.audioVideo.startAudioInput(device);
    } catch (e) {
      fatal(e);
      this.log(`failed to choose audio input device ${device}`, e);
    }
    this.updateVoiceFocusDisplayState();
  }

  async selectAudioInputDeviceByName(name: string): Promise<void> {
    this.log('Selecting audio input device by name:', name);
    const device = await this.audioInputSelectionToDevice(name);
    return this.selectAudioInputDevice(device);
  }

  async openAudioInputFromSelection(): Promise<void> {
    const device = await this.selectedAudioInput();
    await this.selectAudioInputDevice(device);
  }

  async openAudioInputFromSelectionAndPreview(): Promise<void> {
    await this.stopAudioPreview();
    await this.openAudioInputFromSelection();
    this.log('Starting audio preview.');
    await this.startAudioPreview();
  }

  setAudioPreviewPercent(percent: number): void {
    const audioPreview = this.getLocalElement<HTMLElement>('audio-preview');
    if (!audioPreview) {
      return;
    }
    this.updateProperty(audioPreview.style, 'transitionDuration', '33ms');
    this.updateProperty(audioPreview.style, 'width', `${percent}%`);
    if (audioPreview.getAttribute('aria-valuenow') !== `${percent}`) {
      audioPreview.setAttribute('aria-valuenow', `${percent}`);
    }
  }

  async stopAudioPreview(): Promise<void> {
    if (!this.analyserNode) {
      return;
    }

    this.analyserNodeCallback = undefined;

    // Disconnect the analyser node from its inputs and outputs.
    this.analyserNode.disconnect();
    this.analyserNode.removeOriginalInputs();

    this.analyserNode = undefined;
  }

  startAudioPreview(): void {
    this.setAudioPreviewPercent(0);

    // Recreate.
    if (this.analyserNode) {
      // Disconnect the analyser node from its inputs and outputs.
      this.analyserNode.disconnect();
      this.analyserNode.removeOriginalInputs();

      this.analyserNode = undefined;
    }

    const analyserNode = this.audioVideo.createAnalyserNodeForAudioInput();

    if (!analyserNode) {
      return;
    }

    if (!analyserNode.getByteTimeDomainData) {
      this.getLocalElement<HTMLElement>('audio-preview').parentElement.style.visibility = 'hidden';
      return;
    }

    this.analyserNode = analyserNode;
    const data = new Uint8Array(analyserNode.fftSize);
    let frameIndex = 0;
    this.analyserNodeCallback = () => {
      if (frameIndex === 0) {
        analyserNode.getByteTimeDomainData(data);
        const lowest = 0.01;
        let max = lowest;
        for (const f of data) {
          max = Math.max(max, (f - 128) / 128);
        }
        let normalized = (Math.log(lowest) - Math.log(max)) / Math.log(lowest);
        let percent = Math.min(Math.max(normalized * 100, 0), 100);
        this.setAudioPreviewPercent(percent);
      }
      frameIndex = (frameIndex + 1) % 2;
      if (this.analyserNodeCallback) {
        requestAnimationFrame(this.analyserNodeCallback);
      }
    };
    requestAnimationFrame(this.analyserNodeCallback);
  }

  async openAudioOutputFromSelection(): Promise<void> {
    if (this.defaultBrowserBehavior.supportsSetSinkId()) {
      try {
        const audioOutput = this.getLocalElement<HTMLSelectElement>('audio-output');
        await this.chooseAudioOutput(audioOutput.value);
      } catch (e) {
        fatal(e);
        this.log('failed to chooseAudioOutput', e);
      }
    }
    const audioMix = this.getLocalElement<HTMLAudioElement>('meeting-audio');
    try {
      await this.audioVideo.bindAudioElement(audioMix);
    } catch (e) {
      fatal(e);
      this.log('failed to bindAudioElement', e);
    }
  }

  private selectedVideoInput: string | null = null;
  async openVideoInputFromSelection(selection: string | null, showPreview: boolean): Promise<void> {
    this.selectedVideoInput = selection;
    this.log(`Switching to: ${this.selectedVideoInput}`);
    const device = await this.videoInputSelectionToDevice(this.selectedVideoInput);
    if (device === null) {
      try {
        await this.audioVideo.stopVideoInput();
      } catch (e) {
        fatal(e);
        this.log(`failed to stop video input`, e);
      }
      this.log('no video device selected');
      if (showPreview) {
        const videoPreviewEl = this.getLocalElement<HTMLVideoElement>('video-preview');
        await this.audioVideo.stopVideoPreviewForVideoInput(videoPreviewEl);
      }
    } else {
      try {
        await this.audioVideo.startVideoInput(device);
      } catch (e) {
        fatal(e);
        this.log(`failed to start video input ${device}`, e);
      }
      if (showPreview) {
        const videoPreviewEl = this.getLocalElement<HTMLVideoElement>('video-preview');
        this.audioVideo.startVideoPreviewForVideoInput(videoPreviewEl);
      }
    }
  }

  private async audioInputSelectionToIntrinsicDevice(value: string): Promise<Device> {
    if (this.isRecorder()) {
      return null;
    }

    if (value === '440 Hz') {
      return DefaultDeviceController.synthesizeAudioDevice(440);
    }

    if (value === 'L-500Hz R-1000Hz') {
      return new SynthesizedStereoMediaStreamProvider(500, 1000).getMediaStream();
    }

    if (value === 'Prerecorded Speech') {
      return new AudioBufferMediaStreamProvider('audio_file').getMediaStream();
    }

    if (value === 'Prerecorded Speech (Stereo)') {
      return new AudioBufferMediaStreamProvider('stereo_audio_file', true).getMediaStream();
    }

    // use the speaker output MediaStream with a 50ms delay and a 20% volume reduction as audio input
    if (value === 'Echo') {
      try {
        const speakerStream = await this.audioVideo.getCurrentMeetingAudioStream();

        const audioContext = DefaultDeviceController.getAudioContext();
        const streamDestination = audioContext.createMediaStreamDestination();
        const audioSourceNode = audioContext.createMediaStreamSource(speakerStream);
        const delayNode = audioContext.createDelay(0.05);
        const gainNode = audioContext.createGain();
        gainNode.gain.value = 0.8;

        // connect the AudioSourceNode, DelayNode and GainNode to the same output destination
        audioSourceNode.connect(delayNode);
        delayNode.connect(gainNode);
        gainNode.connect(streamDestination);

        return streamDestination.stream;
      } catch (e) {
        this.log(`Error creating Echo`);
        return null;
      }
    }

    if (value === 'No Audio') {
      // An empty media stream destination without any source connected to it, so it doesn't generate any audio.
      // This is currently only used for integration testing of 'sendingAudioFailed' and 'sendingAudioRecovered' events.
      // Note: It's currently not possible to emulate 'No Audio' in Firefox, so we don't provide it
      // as an option in the audio inputs list.
      return DefaultDeviceController.getAudioContext().createMediaStreamDestination().stream;
    }

    if (value === 'None' || value === '') {
      // When the device is passed in as null, the SDK will synthesize an empty audio device that generates silence.
      return null;
    }

    return value;
  }

  private async getVoiceFocusDeviceTransformer(maxComplexity?: VoiceFocusModelComplexity): Promise<VoiceFocusDeviceTransformer> {
    if (this.voiceFocusTransformer) {
      return this.voiceFocusTransformer;
    }

    function exceeds(configured: VoiceFocusModelComplexity): boolean {
      const max = Number.parseInt(maxComplexity.substring(1), 10);
      const complexity = Number.parseInt(configured.substring(1), 10);
      return complexity > max;
    }

    const logger = new ConsoleLogger('SDK', LogLevel.DEBUG);

    // Find out what it will actually execute, and cap it if needed.
    const spec: VoiceFocusSpec = getVoiceFocusSpec(this.joinInfo);
    const config = await VoiceFocusDeviceTransformer.configure(spec, { logger });

    let transformer;
    if (maxComplexity && config.supported && exceeds(config.model.variant)) {
      logger.info(`Downgrading VF to ${maxComplexity}`);
      spec.variant = maxComplexity;
      transformer = VoiceFocusDeviceTransformer.create(spec, { logger }, undefined, this.joinInfo);
    } else {
      transformer = VoiceFocusDeviceTransformer.create(spec, { logger }, config, this.joinInfo);
    }

    return this.voiceFocusTransformer = await transformer;
  }

  private async createVoiceFocusDevice(inner: Device): Promise<VoiceFocusTransformDevice | Device> {
    if (!this.supportsVoiceFocus) {
      return inner;
    }

    if (this.voiceFocusDevice) {
      // Dismantle the old one.
      return (this.voiceFocusDevice = await this.voiceFocusDevice.chooseNewInnerDevice(inner));
    }

    try {
      const transformer = await this.getVoiceFocusDeviceTransformer(MAX_VOICE_FOCUS_COMPLEXITY);
      const vf: VoiceFocusTransformDevice = await transformer.createTransformDevice(inner);
      if (vf) {
        await vf.observeMeetingAudio(this.audioVideo);
        return this.voiceFocusDevice = vf;
      }
    } catch (e) {
      // Fall through.
    }
    return inner;
  }

  private async audioInputSelectionWithOptionalVoiceFocus(
      device: Device
  ): Promise<Device | VoiceFocusTransformDevice> {
    if (this.isVoiceFocusEnabled()) {
      if (!this.voiceFocusDevice) {
        return this.createVoiceFocusDevice(device);
      }

      // Switch out the inner if needed.
      // The reuse of the Voice Focus device is more efficient, particularly if
      // reselecting the same inner -- no need to modify the Web Audio graph.
      // Allowing the Voice Focus device to manage toggling Voice Focus on and off
      // also
      return (this.voiceFocusDevice = await this.voiceFocusDevice.chooseNewInnerDevice(device));
    }

    return device;
  }

  private async audioInputSelectionToDevice(
      value: string
  ): Promise<Device | VoiceFocusTransformDevice> {
    const inner = await this.audioInputSelectionToIntrinsicDevice(value);
    return this.audioInputSelectionWithOptionalVoiceFocus(inner);
  }

  private videoInputSelectionToIntrinsicDevice(value: string): Device {
    if (value === 'Blue') {
      return SyntheticVideoDeviceFactory.create('blue');
    }

    if (value === 'SMPTE Color Bars') {
      return SyntheticVideoDeviceFactory.create('smpte');
    }

    return value;
  }

  private async videoFilterToProcessor(videoFilter: string): Promise<VideoFrameProcessor | null> {
    this.log(`Choosing video filter ${videoFilter}`);

    if (videoFilter === 'Emojify') {
      return new EmojifyVideoFrameProcessor('🚀');
    }

    if (videoFilter === 'CircularCut') {
      return new CircularCut();
    }

    if (videoFilter === 'NoOp') {
      return new NoOpVideoFrameProcessor();
    }

    if (videoFilter === 'Segmentation') {
      return new SegmentationProcessor();
    }

    if (videoFilter === 'Resize (9/16)') {
      return new ResizeProcessor(0.5625);  // 16/9 Aspect Ratio
    }

    if (BACKGROUND_BLUR_V1_LIST.includes(videoFilter as VideoFilterName)) {
      // In the event that frames start being dropped we should take some action to remove the background blur.
      this.blurObserver = {
        filterFrameDurationHigh: (event) => {
          this.log(`background filter duration high: framed dropped - ${event.framesDropped}, avg - ${event.avgFilterDurationMillis} ms, frame rate - ${event.framerate}, period - ${event.periodMillis} ms`);
        },
        filterCPUUtilizationHigh: (event) => {
          this.log(`background filter CPU utilization high: ${event.cpuUtilization}%`);
        }
      };

      const cpuUtilization: number = Number(videoFilter.match(/([0-9]{2})%/)[1]);
      this.blurProcessor = await BackgroundBlurVideoFrameProcessor.create(this.getBackgroundBlurSpec(), { filterCPUUtilization: cpuUtilization });
      this.blurProcessor.addObserver(this.blurObserver);
      return this.blurProcessor;
    }

    if (BACKGROUND_REPLACEMENT_V1_LIST.includes(videoFilter as VideoFilterName)) {
      // In the event that frames start being dropped we should take some action to remove the background replacement.
      this.replacementObserver = {
        filterFrameDurationHigh: (event) => {
          this.log(`background filter duration high: framed dropped - ${event.framesDropped}, avg - ${event.avgFilterDurationMillis} ms, frame rate - ${event.framerate}, period - ${event.periodMillis} ms`);
        }
      };

      this.replacementProcessor = await BackgroundReplacementVideoFrameProcessor.create(this.getBackgroundBlurSpec(), await this.getBackgroundReplacementOptions());
      this.replacementProcessor.addObserver(this.replacementObserver);
      return this.replacementProcessor;
    }
    
    // Create a VideoFxProcessor
    if (BACKGROUND_FILTER_V2_LIST.includes(videoFilter as VideoFilterName)) {
      const defaultBudgetPerFrame: number = 50;
      this.updateFxConfig(videoFilter);
      try {
        this.videoFxProcessor = await VideoFxProcessor.create(this.meetingLogger, this.videoFxConfig, defaultBudgetPerFrame);
        return this.videoFxProcessor;
      } catch (error) {
        this.meetingLogger.warn(error.toString());
        return new NoOpVideoFrameProcessor();
      }
    }
    return null;
  }

  /**
   * Update this.videoFxConfig to match the corresponding configuration specified by the videoFilter.
   * @param videoFilter 
   */
  private updateFxConfig(videoFilter: string): void {
    this.videoFxConfig.backgroundBlur.isEnabled = (
      videoFilter === 'Background Blur 2.0 - Low' ||
      videoFilter === 'Background Blur 2.0 - Medium' ||
      videoFilter === 'Background Blur 2.0 - High'
    )

    this.videoFxConfig.backgroundReplacement.isEnabled = (
      videoFilter === 'Background Replacement 2.0 - (Beach)' ||
      videoFilter === 'Background Replacement 2.0 - (Default)' ||
      videoFilter === 'Background Replacement 2.0 - (Blue)'
    )
    
    switch(videoFilter) {
      case 'Background Blur 2.0 - Low':
        this.videoFxConfig.backgroundBlur.strength = 'low';
        break;
      case 'Background Blur 2.0 - Medium':
        this.videoFxConfig.backgroundBlur.strength = 'medium';
        break;
      case 'Background Blur 2.0 - High':
        this.videoFxConfig.backgroundBlur.strength = 'high';
        break;
      case 'Background Replacement 2.0 - (Beach)':
        this.videoFxConfig.backgroundReplacement.backgroundImageURL = BackgroundImageEncoding();
        this.videoFxConfig.backgroundReplacement.defaultColor = null;
        break;
      case 'Background Replacement 2.0 - (Default)':
        this.videoFxConfig.backgroundReplacement.backgroundImageURL = null;
        this.videoFxConfig.backgroundReplacement.defaultColor = '#000000';
        break;
      case 'Background Replacement 2.0 - (Blue)':
        this.videoFxConfig.backgroundReplacement.backgroundImageURL = null;
        this.videoFxConfig.backgroundReplacement.defaultColor = '#26A4FF';
        break;
    }
  }

  private async videoInputSelectionWithOptionalFilter(
      innerDevice: Device
  ): Promise<VideoInputDevice> {
    if (this.selectedVideoFilterItem === 'None') {
      return innerDevice;
    }
    // We have reselected our filter, don't need to make a new processor
    if (this.chosenVideoTransformDevice &&
        this.selectedVideoFilterItem === this.chosenVideoFilter) {
      // Our input device has changed, so swap it out for the new one
      if (this.chosenVideoTransformDevice.getInnerDevice() !== innerDevice) {
        this.chosenVideoTransformDevice = this.chosenVideoTransformDevice.chooseNewInnerDevice(
          innerDevice
        );
      }
      return this.chosenVideoTransformDevice;
    }

    // A different filter is selected so we must modify our processor
    if (this.chosenVideoTransformDevice) {
      await this.chosenVideoTransformDevice.stop();
    }
    const proc = await this.videoFilterToProcessor(this.selectedVideoFilterItem);
    this.chosenVideoFilter = this.selectedVideoFilterItem;
    this.chosenVideoTransformDevice = new DefaultVideoTransformDevice(
        this.meetingLogger,
        innerDevice,
        [proc]
    );
    return this.chosenVideoTransformDevice;
  }

  private async videoInputSelectionToDevice(value: string | null): Promise<VideoInputDevice> {
    if (this.isRecorder() || value === 'None' || value === null) {
      return null;
    }
    const intrinsicDevice = this.videoInputSelectionToIntrinsicDevice(value);
    return await this.videoInputSelectionWithOptionalFilter(intrinsicDevice);
  }

  isRecorder(): boolean {
    return new URL(window.location.href).searchParams.get('record') === 'true';
  }

  isBroadcaster(): boolean {
    return this.broadcast || new URL(window.location.href).searchParams.get('broadcast') === 'true';
  }

  isAbortingOnReconnect(): boolean {
    return new URL(window.location.href).searchParams.get('abort-on-reconnect') === 'true';
  }

  async authenticate(): Promise<string> {
    console.log('meeting', this.meeting);
    console.log('name', this.name);
    console.log('region', this.region);
    console.log('primaryExternalMeetingId', this.primaryExternalMeetingId);
    
    this.joinInfo = (await this.sendJoinRequest(this.meeting, this.name, this.region, this.primaryExternalMeetingId)).JoinInfo;
console.log('222');
    this.region = this.joinInfo.Meeting.Meeting.MediaRegion;
    const configuration = new MeetingSessionConfiguration(this.joinInfo.Meeting, this.joinInfo.Attendee);
    await this.initializeMeetingSession(configuration);
    this.primaryExternalMeetingId = this.joinInfo.PrimaryExternalMeetingId
    const url = new URL(window.location.href);
    url.searchParams.set('m', this.meeting);
    history.replaceState({}, `${this.meeting}`, url.toString());
    return configuration.meetingId;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  log(str: string, ...args: any[]): void {
    console.log.apply(console, [`[DEMO] ${str}`, ...args]);
  }

  audioVideoDidStartConnecting(reconnecting: boolean): void {
    this.log(`session connecting. reconnecting: ${reconnecting}`);
    if (reconnecting && this.isAbortingOnReconnect()) {
      fatal(Error('reconnect occured with abort-on-reconnect set to true'));
    }
  }

  audioVideoDidStart(): void {
    if (this.callPageDestroyed) {
      this.audioVideo?.stop();
      return;
    }
    this.log('session started');
    this.startCallElapsedTimer();
    if (this.nativeCallUUID) {
      const uuid = this.nativeCallUUID;
      void NativeCalls.completeAudioHandoff({ uuid })
        .then(() => this.nativeCallEnding
          ? undefined
          : this.callPageDestroyed
            ? NativeCalls.resumeNativeAudio({ uuid })
            : NativeCalls.mediaConnected({ uuid }))
        .catch(console.warn);
    }
    if (this.nativeCallUUID && this.nativeCallMuted) this.audioVideo.realtimeMuteLocalAudio();
    if ((this.nativeCallUUID || this.incomingVideoUpgrade) && this.nativeIncomingVideo && !this.nativeVideoStarted) {
      this.nativeVideoStarted = true;
      this.getLocalElement<HTMLButtonElement>('button-camera')?.click();
    }
  }

  audioVideoDidStop(sessionStatus: MeetingSessionStatus): void {
    this.log(`session stopped from ${JSON.stringify(sessionStatus)}`);
    this.stopCallElapsedTimer();
    if (this.nativeCallUUID && !this.nativeCallEnding) {
      void NativeCalls.resumeNativeAudio({ uuid: this.nativeCallUUID }).catch(console.warn);
    }
    if(this.behaviorAfterLeave === 'nothing') {
      return;
    }
    this.log(`resetting stats`);
    this.resetStats();

    const returnToStart = () => {
      if (this.returnToPreviousRouteAfterLeave) {
        void this.returnFromCallPage();
        return;
      }
      if (this.returnToEcosystemAfterLeave) {
        void this.navController.navigateRoot('/home/ecosystem-page', { replaceUrl: true }).catch(error => {
          console.error('Unable to return to the ecosystem launcher after leaving:', error);
        });
        return;
      }

      switch (this.behaviorAfterLeave) {
        case 'spa':
          this.switchToFlow('flow-authenticate');
          break;
        case 'reload':
          window.location.href = window.location.pathname;
          break;
          // This is useful for testing memory leaks.
        case 'halt': {
          // Wait a moment to make sure cleanup is done.
          setTimeout(() => {
            // Kill all references to code and content.
            // @ts-ignore
            window.app = undefined;
            // @ts-ignore
            window.app_meetingV2 = undefined;
            // @ts-ignore
            window.webpackHotUpdateapp_meetingV2 = undefined;
            document.getElementsByTagName('body')[0].innerHTML = '<b>Gone</b>';
            this.removeFatalHandlers();
          }, 2000);
          break;
        }
      }
    };

    /**
     * This is approximately the inverse of the initialization method above.
     * This work only needs to be done if you want to continue using the page; if
     * your app navigates away or closes the tab when done, you can let the browser
     * clean up.
     */
    const cleanUpResources = async () => {
      // Clean up the timers for this.
      this.audioVideo.unsubscribeFromActiveSpeakerDetector(this.activeSpeakerHandler);

      // Stop listening to attendee presence.
      this.audioVideo.realtimeUnsubscribeToAttendeeIdPresence(this.attendeeIdPresenceHandler);

      // Stop listening to transcript events.
      this.audioVideo.transcriptionController?.unsubscribeFromTranscriptEvent(this.transcriptEventHandler);

      this.audioVideo.realtimeUnsubscribeToMuteAndUnmuteLocalAudio(this.muteAndUnmuteLocalAudioHandler);
      this.audioVideo.realtimeUnsubscribeToSetCanUnmuteLocalAudio(this.canUnmuteLocalAudioHandler);
      this.audioVideo.realtimeUnsubscribeFromReceiveDataMessage(ChimeContactComponent.DATA_MESSAGE_TOPIC);

      // Stop watching device changes in the UI.
      this.audioVideo.removeDeviceChangeObserver(this);

      // Stop content share and local video.
      this.audioVideo.stopLocalVideoTile();
      await this.contentShare.stop();

      // Drop the audio output.
      this.audioVideo.unbindAudioElement();
      await this.deviceController.destroy();

      // remove blur event observer
      this.blurProcessor?.removeObserver(this.blurObserver);

      // remove replacement event observer
      this.replacementProcessor?.removeObserver(this.replacementObserver);

      // Stop any video processor.
      await this.chosenVideoTransformDevice?.stop();

      // Stop Voice Focus.
      await this.voiceFocusDevice?.stop();

      // Clean up the loggers so they don't keep their `onload` listeners around.
      setTimeout(async () => {
        await this.meetingEventPOSTLogger?.destroy();
        await this.meetingSessionPOSTLogger?.destroy();
      }, 500);

      if (isDestroyable(this.eventReporter)) {
        this.eventReporter?.destroy();
      }

      await this.blurProcessor?.destroy();
      await this.replacementProcessor?.destroy();

      this.audioVideo = undefined;
      this.voiceFocusDevice = undefined;
      this.meetingSession = undefined;
      this.activeSpeakerHandler = undefined;
      this.currentAudioInputDevice = undefined;
      this.eventReporter = undefined;
      this.blurProcessor = undefined;
      this.replacementProcessor = undefined;

      // Cleanup VideoFxProcessor
      this.videoFxProcessor?.destroy();
      this.videoFxProcessor = undefined;
    };

    const onLeftMeeting = async () => {
      await cleanUpResources();
      returnToStart();
    };

    if (sessionStatus.statusCode() === MeetingSessionStatusCode.MeetingEnded) {
      this.log(`meeting ended`);
      onLeftMeeting();
      return;
    }

    if (sessionStatus.statusCode() === MeetingSessionStatusCode.Left) {
      this.log('left meeting');
      onLeftMeeting();
      return;
    }
  }

  audioVideoWasDemotedFromPrimaryMeeting(status: any): void {
    const message = `Was demoted from primary meeting with status ${status.toString()}`
    this.log(message);
    this.updateUXForReplicaMeetingPromotionState('demoted');
    const toastContainer = document.getElementById('toast-container');
    const toast = document.createElement('meeting-toast') as MeetingToast
    toastContainer.appendChild(toast);
    toast.message = message;
    toast.addButton('Retry Promotion', () => { this.promoteToPrimaryMeeting() });
    toast.show();
  }

  videoAvailabilityDidChange(availability: MeetingSessionVideoAvailability): void {
    const didChange = this.canStartLocalVideo !== availability.canStartLocalVideo;
    this.canStartLocalVideo = availability.canStartLocalVideo;
    this.log(`video availability changed: canStartLocalVideo  ${availability.canStartLocalVideo}`);
    if (didChange && !this.meetingSession.audioVideo.hasStartedLocalVideoTile()) {
      if (!this.canStartLocalVideo) {
        this.enableLocalVideoButton(false, 'Can no longer enable local video in conference.');
      } else {
        // Enable ability to press button again
        this.enableLocalVideoButton(true, 'You can now enable local video in conference.');
      }
    }
  }

  private enableLocalVideoButton(enabled: boolean, warningMessage: string = ''): void {
    this.toggleButton('button-camera', enabled ? 'off' : 'disabled');

    if (warningMessage) {
      const toastContainer = document.getElementById('toast-container');
      const toast = document.createElement('meeting-toast') as MeetingToast
      toastContainer.appendChild(toast);
      toast.message = warningMessage;
      toast.show();
    }
  }

  private redirectFromAuthentication(quickjoin: boolean = false): void {
    if (this.authenticatingMeeting) {
      return;
    }

    if (this.scheduledCallError) {
      void Swal2.fire({ title: 'Reunión no disponible', text: this.scheduledCallError, icon: 'error' });
      return;
    }
    if (this.scheduledStartAt && Date.now() < this.scheduledStartAt.getTime()) {
      void Swal2.fire({
        title: 'La reunión aún no comienza',
        text: `Podrás unirte el ${this.scheduledCallTimeLabel}.`,
        icon: 'info',
      });
      return;
    }

    if(quickjoin===false){
      if (!this.validateInviteEmails()) {
        this.getLocalElement<HTMLTextAreaElement>('inputInviteEmails')?.focus();
        return;
      }
      this.meeting = this.getLocalElement<HTMLInputElement>('inputMeeting').value;
      const enteredName = this.getLocalElement<HTMLInputElement>('inputName').value.trim();
      this.name = enteredName || `${this.username || 'Guest'}`;
      this.region = this.getLocalElement<HTMLSelectElement>('inputRegion').value;
      this.usePriorityBasedDownlinkPolicy = true;
    } else {
      this.inviteEmails = [];
    }
    this.authenticatingMeeting = true;

    // Quick-join starts with the camera off. Chime may already have a local
    // tile object at this point, so wait for videoTileDidUpdate to confirm an
    // actual stream before treating this participant as video-enabled.
    this.upsertCallParticipant('local', 'You', true, false);

    this.updatePrejoinSummary();

    this.enableSimulcast = this.getLocalElement<HTMLInputElement>('simulcast').checked;
    this.enableEventReporting = this.getLocalElement<HTMLInputElement>('event-reporting').checked;
    this.deleteOwnAttendeeToLeave = this.getLocalElement<HTMLInputElement>('delete-attendee').checked;
    this.disablePeriodicKeyframeRequestOnContentSender = this.getLocalElement<HTMLInputElement>('disable-content-keyframe').checked;
    this.enableWebAudio = this.getLocalElement<HTMLInputElement>('webaudio').checked;
    //this.usePriorityBasedDownlinkPolicy = (document.getElementById('priority-downlink-policy') as HTMLInputElement).checked;
    this.echoReductionCapability = this.getLocalElement<HTMLInputElement>('echo-reduction-capability').checked;
    this.primaryExternalMeetingId = this.getLocalElement<HTMLInputElement>('primary-meeting-external-id').value;

    const chosenLogLevel = this.getLocalElement<HTMLSelectElement>('logLevelSelect').value;
    switch (chosenLogLevel) {
      case 'info':
        this.logLevel = LogLevel.INFO;
        break;
      case 'debug':
        this.logLevel = LogLevel.DEBUG;
        break;
      case 'warn':
        this.logLevel = LogLevel.WARN;
        break;
      case 'error':
        this.logLevel = LogLevel.ERROR;
        break;
      default:
        this.logLevel = LogLevel.OFF;
        break;
    }

    const chosenVideoSendCodec = this.getLocalElement<HTMLSelectElement>('videoCodecSelect').value;
    switch (chosenVideoSendCodec) {
      case 'vp8':
        this.videoCodecPreferences = [VideoCodecCapability.vp8()];
        break;
      case 'h264ConstrainedBaselineProfile':
        // If `h264ConstrainedBaselineProfile` is explicitly selected, include VP8 as fallback
        this.videoCodecPreferences = [VideoCodecCapability.h264ConstrainedBaselineProfile(), VideoCodecCapability.vp8()];
        break;
      default:
        this.videoCodecPreferences = [VideoCodecCapability.h264ConstrainedBaselineProfile(), VideoCodecCapability.vp8()];
        // If left on 'Meeting Default', use the existing behavior when `setVideoCodecSendPreferences` is not called
        // which should be equivalent to `this.videoCodecPreferences = [VideoCodecCapability.h264ConstrainedBaselineProfile()]`
        break;
    }

    AsyncScheduler.nextTick(
        async (): Promise<void> => {
          let chimeMeetingId: string = '';
          this.showProgress('progress-authenticate');
          try {
            chimeMeetingId = await this.authenticate();
          } catch (error) {
            this.authenticatingMeeting = false;
            console.error(error);
            const httpErrorMessage =
                'UserMedia is not allowed in HTTP sites. Either use HTTPS or enable media capture on insecure sites.';
            (document.getElementById(
                'failed-meeting'
            ) as HTMLDivElement).innerText = `ID de reunión: ${this.meeting}`;
            (document.getElementById('failed-meeting-error') as HTMLDivElement).innerText =
                window.location.protocol === 'http:' ? httpErrorMessage : error.message;
            this.switchToFlow('flow-failed-meeting');
            return;
          }
          await this.sendMeetingInvitations();
          (this.getLocalElement(
              'meeting-id'
          ) as HTMLSpanElement).innerText = `${this.meeting} (${this.region})`;
          (this.getLocalElement(
              'chime-meeting-id'
          ) as HTMLSpanElement).innerText = `ID de reunión: ${chimeMeetingId}`;
          (this.getLocalElement(
              'mobile-chime-meeting-id'
          ) as HTMLSpanElement).innerText = `ID de reunión: ${chimeMeetingId}`;
          (this.getLocalElement(
              'mobile-attendee-id'
          ) as HTMLSpanElement).innerText = `ID de presente: ${this.meetingSession.configuration.credentials.attendeeId}`;
          (this.getLocalElement(
              'desktop-attendee-id'
          ) as HTMLSpanElement).innerText = `ID de presente: ${this.meetingSession.configuration.credentials.attendeeId}`;
          this.updatePrejoinSummary();

          if (this.isViewOnly) {
            this.updateUXForViewOnlyMode();
            await this.skipDeviceSelection(false);
            return;
          }
          await this.initVoiceFocus();
          await this.initBackgroundBlur();
          await this.initBackgroundReplacement();
          await this.resolveSupportsVideoFX();
          await this.populateAllDeviceLists();
          await this.populateVideoFilterInputList(false);
          await this.populateVideoFilterInputList(true);
          if (this.enableSimulcast) {
            const videoInputQuality = this.getLocalElement<HTMLSelectElement>('video-input-quality');
            videoInputQuality.value = '720p';
            this.audioVideo.chooseVideoInputQuality(1280, 720, 15);
            videoInputQuality.disabled = true;
          }

          // `this.primaryExternalMeetingId` may by the join request
          const buttonPromoteToPrimary = this.getLocalElement<HTMLElement>('button-promote-to-primary');
          if (!this.primaryExternalMeetingId) {
            buttonPromoteToPrimary.style.display = 'none';
          } else {
            this.setButtonVisibility('button-record-cloud', false);
            this.updateUXForReplicaMeetingPromotionState('demoted');
          }

          if (quickjoin) {
            try {
              await this.skipDeviceSelection();
            } catch (error) {
              this.authenticatingMeeting = false;
              console.error('Could not start call audio:', error);
              (this.getLocalElement('failed-meeting') as HTMLDivElement).innerText = `ID de reunión: ${this.meeting}`;
              (this.getLocalElement('failed-meeting-error') as HTMLDivElement).innerText =
                'No se pudo activar el micrófono. Revisa el permiso de audio e intenta de nuevo.';
              this.switchToFlow('flow-failed-meeting');
              return;
            }
            this.displayButtonStates();
            return;
          }
          this.switchToFlow('flow-devices');
          await this.openAudioInputFromSelectionAndPreview();
          try {
            await this.openVideoInputFromSelection(
                this.getLocalElement<HTMLSelectElement>('video-input').value,
                true
            );
          } catch (err) {
            fatal(err);
          }
          await this.openAudioOutputFromSelection();
          this.hideProgress('progress-authenticate');

          // Open the signaling connection while the user is checking their input devices.
          const preconnect = this.getLocalElement<HTMLInputElement>('preconnect');
          if (preconnect.checked) {
            if (this.joinMuted) {
              this.audioVideo.realtimeMuteLocalAudio();
            }
            this.audioVideo.start({ signalingOnly: true });
          }
        }
    );

  }

  // to call from form-authenticate form
  private async skipDeviceSelection(autoSelectAudioInput: boolean = true): Promise<void> {
    if (autoSelectAudioInput) {
      // Quick join has no device-selection step. Before permission is granted,
      // the selector can have an empty device ID, which the normal selection
      // path interprets as "None" (silent audio). Keep the native call running
      // until WebKit has actually acquired and selected its microphone.
      const microphone = await navigator.mediaDevices.getUserMedia({ audio: true });
      try {
        await this.audioVideo.startAudioInput(microphone);
        if (this.nativeCallUUID && Capacitor.getPlatform() === 'ios') {
          await NativeCalls.prepareAudio({ uuid: this.nativeCallUUID });
        }
        this.currentAudioInputDevice = microphone;
      } catch (error) {
        microphone.getTracks().forEach(track => track.stop());
        throw error;
      }
    }
    await this.openAudioOutputFromSelection();
    await this.join();
    this.switchToFlow('flow-meeting');
    this.hideProgress('progress-authenticate');
  }

  allowMaxContentShare(): boolean {
    const allowed = new URL(window.location.href).searchParams.get('max-content-share') === 'true';
    if (allowed) {
      return true;
    }
    return false;
  }

  connectionDidBecomePoor(): void {
    this.log('connection is poor');
  }

  connectionDidSuggestStopVideo(): void {
    this.log('suggest turning the video off');
  }

  connectionDidBecomeGood(): void {
    this.log('connection is good now');
  }

  videoSendDidBecomeUnavailable(): void {
    this.log('sending video is not available');
    this.enableLocalVideoButton(false, 'Cannot enable local video due to call being at capacity');
  }

  contentShareDidStart(): void {
    this.toggleButton('button-content-share', 'on')
  }

  contentShareDidStop(): void {
    this.toggleButton('button-content-share', 'off')
  }

  encodingSimulcastLayersDidChange(simulcastLayers: SimulcastLayers): void {
    this.log(
        `current active simulcast layers changed to: ${SimulcastLayerMapping[simulcastLayers]}`
    );
  }

  tileWillBePausedByDownlinkPolicy(tileId: number): void {
    this.log(`Tile ${tileId} will be paused due to insufficient bandwidth`);
    this.videoTileCollection.bandwidthConstrainedTiles.add(tileId);
  }

  tileWillBeUnpausedByDownlinkPolicy(tileId: number): void {
    this.log(`Tile ${tileId} will be resumed due to sufficient bandwidth`);
    this.videoTileCollection.bandwidthConstrainedTiles.delete(tileId);
  }
  // Function to toggle the chat modal
  toggleChatModal() {
  this.chatModalOpen = !this.chatModalOpen;
}

toggleButtons(event?: Event) {
  event?.stopPropagation();
  this.buttonsModalOpen = !this.buttonsModalOpen;
}

onDevicesJoinClick(event: Event): void {
  event.preventDefault();
  if (this.joiningMeeting) {
    return;
  }

  const form = this.getLocalElement<HTMLFormElement>('form-devices');
  if (!form) {
    return;
  }

  // The CTA lives outside the scrolling card, so submit the same form
  // explicitly instead of depending on cross-container form association.
  form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
}

private async copyTextToClipboard(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch (error) {
    console.warn('The Clipboard API was unavailable; trying the browser fallback.', error);
  }

  // `localhost` and older desktop browsers can expose no Clipboard API (or
  // reject it outside a secure context). The selection fallback still works
  // for the user gesture that opened the share action.
  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.width = '1px';
  textArea.style.height = '1px';
  textArea.style.padding = '0';
  textArea.style.border = '0';
  textArea.style.opacity = '0';
  textArea.style.pointerEvents = 'none';
  document.body.appendChild(textArea);

  let copied = false;
  try {
    textArea.focus();
    textArea.select();
    textArea.setSelectionRange(0, textArea.value.length);
    copied = document.execCommand('copy');
  } catch (error) {
    console.warn('The browser clipboard fallback failed.', error);
  } finally {
    textArea.remove();
  }
  return copied;
}

async shareMeetingURL(): Promise<void> {
  const sessionUrl = `https://supercumulo.laniakea.tv/loader?meeting=${encodeURIComponent(this.meeting || '')}`;
  const copied = await this.copyTextToClipboard(sessionUrl);

  await Swal2.fire({
    title: copied ? 'Session URL copied' : 'Session URL',
    text: sessionUrl,
    icon: copied ? 'success' : 'warning',
    showCancelButton: false,
    confirmButtonText: 'OK',
    color: '#ffffff',
    background: '#010f4e',
    position: 'top-end',
    timerProgressBar: true,
    toast: true,
  });
}
async fetchCounter(counter, method) {
  // Get the current value and add 1
  let uri = `${ChimeContactComponent.BASE_URL}join?contador=${counter}&method=${method}&meeting=${this.meeting}&meetingid=${encodeURIComponent(this.meeting)}`;
  uri += `&ns_es=${this.echoReductionCapability}`;
  console.log(uri);
  console.log('this.meeting', this.meeting);
  try {
    const response = await fetch(uri, {
      method: 'POST',
    });
    if (method==='get'){
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
   
      const json = await response.json();
      console.log(json);
      const publicLiveData = JSON.parse(json.publicLive.S);

if (publicLiveData) {
console.log('publicLiveData',publicLiveData);
const vistas = publicLiveData.vistas;
const regalos = publicLiveData.regalos;
const comentarios = publicLiveData.comentarios;

console.log('Vistas:', vistas);
console.log('Regalos:', regalos);
console.log('Comentarios:', comentarios);
if (vistas>=1){
  const labelToUpdate = this.getLocalElement<HTMLLabelElement>('vistas-tiempo-real');
  if (labelToUpdate) {
    labelToUpdate.innerText = (vistas).toString();
  }
}


const labelToUpdateVistas = this.getLocalElement<HTMLLabelElement>('msjs-tiempo-real');
if (labelToUpdateVistas) {
  labelToUpdateVistas.innerText = (comentarios).toString();
}

if (regalos >= 1){
console.log('Regalos is greater:', regalos);
const labelToUpdate = this.getLocalElement<HTMLLabelElement>('regalos-tiempo-real');
if (labelToUpdate) {
  labelToUpdate.innerText = (regalos).toString();
}

}
} else {
console.log('publicLive data is not available.');
}

    }

  } catch (error) {
    console.error('Error fetching counter:', error);
  }
}

}

// Angular owns this component's lifecycle and injected call services.

window.addEventListener('click', event => {
  const liveTranscriptionModal = document.getElementById('live-transcription-modal');
  if (event.target === liveTranscriptionModal) {
    liveTranscriptionModal.style.display = 'none';
  }
});
